/* <----- MEP ICONS START -----> */

// sidebar Icons
export const NpaPropertiesIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    fill={"none"}
  >
    <path
      d="M8.85501 19.6814L8.61928 16.6181C8.49253 14.9712 9.89783 13.5703 11.6768 13.5703C13.4557 13.5703 14.861 14.9712 14.7342 16.6181L14.4985 19.6814"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M2.60199 12.0122C2.26995 10.0066 2.10393 9.00392 2.51243 8.11497C2.92093 7.22602 3.82723 6.61779 5.63983 5.40136L6.99413 4.4925C9.24898 2.97927 10.3764 2.22266 11.6773 2.22266C12.9781 2.22266 14.1056 2.97927 16.3604 4.4925L17.7147 5.40136C19.5274 6.61779 20.4336 7.22602 20.8421 8.11497C21.2506 9.00392 21.0846 10.0066 20.7526 12.0122L20.4695 13.7224C19.9987 16.5653 19.7634 17.9869 18.6649 18.8349C17.5664 19.683 15.9603 19.683 12.7484 19.683H10.6062C7.3942 19.683 5.78823 19.683 4.68971 18.8349C3.5912 17.9869 3.35585 16.5653 2.88515 13.7224L2.60199 12.0122Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinejoin="round"
    />
  </svg>
);

export const NpaInquiriesIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    fill={"none"}
  >
    <path
      d="M9.75 15.6201V16.5H10.63C10.937 16.5 11.0906 16.5 11.2286 16.4428C11.3666 16.3856 11.4752 16.2771 11.6923 16.0601L15.31 12.442C15.5148 12.2373 15.6172 12.1349 15.6719 12.0245C15.776 11.8144 15.776 11.5677 15.6719 11.3575C15.6172 11.2471 15.5148 11.1447 15.31 10.94C15.1052 10.7352 15.0029 10.6328 14.8924 10.5781C14.6822 10.474 14.4355 10.474 14.2253 10.5781C14.1149 10.6328 14.0125 10.7352 13.8077 10.94L10.19 14.558C9.9729 14.775 9.86437 14.8835 9.80715 15.0215C9.75 15.1596 9.75 15.313 9.75 15.6201Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinejoin="round"
    />
    <path
      d="M14.25 8.25C14.25 8.25 14.25 7.07295 14.1358 6.79729C14.0216 6.52164 13.8049 6.30487 13.3713 5.87132L9.81892 2.31891C9.44475 1.94475 9.2577 1.75766 9.02588 1.64681C8.97765 1.62375 8.9283 1.60329 8.8779 1.58551C8.63558 1.5 8.37105 1.5 7.84185 1.5C5.40811 1.5 4.19123 1.5 3.367 2.16455C3.20048 2.29881 3.04881 2.45048 2.91455 2.617C2.25 3.44123 2.25 4.65812 2.25 7.09188V10.5C2.25 13.3284 2.25 14.7427 3.12868 15.6213C3.926 16.4186 5.16427 16.4925 7.5 16.4993M9 1.875V2.25C9 4.37132 9 5.43198 9.65903 6.09099C10.3181 6.75 11.3787 6.75 13.5 6.75H13.875"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Tables Icon
export const ImportIcon = (props) => {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    fill={"none"}
  >
    <path
      d="M11.2513 7.16797C11.0966 7.16797 10.9482 7.22943 10.8388 7.33882C10.7294 7.44822 10.668 7.59659 10.668 7.7513V10.0846C10.668 10.2393 10.6065 10.3877 10.4971 10.4971C10.3877 10.6065 10.2393 10.668 10.0846 10.668H1.91797C1.76326 10.668 1.61489 10.6065 1.50549 10.4971C1.39609 10.3877 1.33464 10.2393 1.33464 10.0846V7.7513C1.33464 7.59659 1.27318 7.44822 1.16378 7.33882C1.05438 7.22943 0.906012 7.16797 0.751302 7.16797C0.596592 7.16797 0.448219 7.22943 0.338823 7.33882C0.229427 7.44822 0.167969 7.59659 0.167969 7.7513V10.0846C0.167969 10.5488 0.352343 10.9939 0.680532 11.3221C1.00872 11.6503 1.45384 11.8346 1.91797 11.8346H10.0846C10.5488 11.8346 10.9939 11.6503 11.3221 11.3221C11.6503 10.9939 11.8346 10.5488 11.8346 10.0846V7.7513C11.8346 7.59659 11.7732 7.44822 11.6638 7.33882C11.5544 7.22943 11.406 7.16797 11.2513 7.16797ZM5.58714 8.16547C5.64261 8.21858 5.70803 8.26021 5.77964 8.28797C5.84946 8.31883 5.92496 8.33477 6.0013 8.33477C6.07764 8.33477 6.15314 8.31883 6.22297 8.28797C6.29457 8.26021 6.35999 8.21858 6.41547 8.16547L8.7488 5.83214C8.85865 5.72229 8.92036 5.57331 8.92036 5.41797C8.92036 5.26263 8.85865 5.11365 8.7488 5.0038C8.63896 4.89396 8.48998 4.83225 8.33464 4.83225C8.17929 4.83225 8.03031 4.89396 7.92047 5.0038L6.58464 6.34547V0.751302C6.58464 0.596592 6.52318 0.448219 6.41378 0.338823C6.30439 0.229427 6.15601 0.167969 6.0013 0.167969C5.84659 0.167969 5.69822 0.229427 5.58882 0.338823C5.47943 0.448219 5.41797 0.596592 5.41797 0.751302V6.34547L4.08214 5.0038C4.02775 4.94941 3.96318 4.90627 3.89211 4.87683C3.82105 4.8474 3.74489 4.83225 3.66797 4.83225C3.59105 4.83225 3.51489 4.8474 3.44382 4.87683C3.37276 4.90627 3.30819 4.94941 3.2538 5.0038C3.19941 5.05819 3.15627 5.12276 3.12683 5.19382C3.0974 5.26489 3.08225 5.34105 3.08225 5.41797C3.08225 5.49489 3.0974 5.57105 3.12683 5.64211C3.15627 5.71318 3.19941 5.77775 3.2538 5.83214L5.58714 8.16547Z"
      fill={"none"}
    />
  </svg>;
};

// left Arrow New Property
export const LeftArrowNewPropertyIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 24 24"
    fill={"none"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.58493 15.5859C10.1384 15.0338 10.1384 14.138 9.58493 13.5852L3.42047 8.00022L9.58493 2.41521C10.1384 1.86244 10.1384 0.967335 9.58493 0.414583C9.03149 -0.138194 8.13506 -0.138194 7.58163 0.414583L0.410208 6.91135C0.111178 7.21037 -0.020689 7.60864 0.00393867 8.00025C-0.020689 8.39117 0.111178 8.79012 0.410208 9.08912L7.58163 15.5859C8.13506 16.138 9.03147 16.138 9.58493 15.5859Z"
      fill="#444050"
    />
  </svg>
);

// Land Area Icon
export const LandAreaIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 24 24"
      fill={"none"}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.1867 0H3.81333C2.80252 0.00176255 1.8336 0.404089 1.11885 1.11885C0.404089 1.8336 0.00176255 2.80252 0 3.81333V16.1867C0.00176255 17.1975 0.404089 18.1664 1.11885 18.8812C1.8336 19.5959 2.80252 19.9982 3.81333 20H16.1867C17.1975 19.9982 18.1664 19.5959 18.8812 18.8812C19.5959 18.1664 19.9982 17.1975 20 16.1867V3.81333C19.9982 2.80252 19.5959 1.8336 18.8812 1.11885C18.1664 0.404089 17.1975 0.00176255 16.1867 0ZM18.6667 16.1867C18.6649 16.8439 18.4031 17.4736 17.9383 17.9383C17.4736 18.4031 16.8439 18.6649 16.1867 18.6667H3.81333C3.15614 18.6649 2.52636 18.4031 2.06165 17.9383C1.59694 17.4736 1.33509 16.8439 1.33333 16.1867V3.81333C1.33509 3.15614 1.59694 2.52636 2.06165 2.06165C2.52636 1.59694 3.15614 1.33509 3.81333 1.33333H16.1867C16.8439 1.33509 17.4736 1.59694 17.9383 2.06165C18.4031 2.52636 18.6649 3.15614 18.6667 3.81333V16.1867Z"
        fill="#9F2F48"
      />
      <path
        d="M16.0007 11.2254C15.8238 11.2254 15.6543 11.2956 15.5292 11.4206C15.4042 11.5457 15.334 11.7152 15.334 11.892V14.392L5.60732 4.66536H8.10732C8.28413 4.66536 8.4537 4.59513 8.57872 4.4701C8.70375 4.34508 8.77398 4.17551 8.77398 3.9987C8.77398 3.82189 8.70375 3.65232 8.57872 3.52729C8.4537 3.40227 8.28413 3.33203 8.10732 3.33203H3.79398C3.67198 3.33203 3.55498 3.3805 3.46872 3.46676C3.38245 3.55303 3.33398 3.67003 3.33398 3.79203V8.10536C3.33398 8.28218 3.40422 8.45174 3.52925 8.57677C3.65427 8.70179 3.82384 8.77203 4.00065 8.77203C4.17746 8.77203 4.34703 8.70179 4.47206 8.57677C4.59708 8.45174 4.66732 8.28218 4.66732 8.10536V5.60536L14.394 15.332H11.894C11.7172 15.332 11.5476 15.4023 11.4226 15.5273C11.2976 15.6523 11.2273 15.8219 11.2273 15.9987C11.2273 16.1755 11.2976 16.3451 11.4226 16.4701C11.5476 16.5951 11.7172 16.6654 11.894 16.6654H16.2073C16.3293 16.6654 16.4463 16.6169 16.5326 16.5306C16.6189 16.4444 16.6673 16.3274 16.6673 16.2054V11.892C16.6673 11.7152 16.5971 11.5457 16.4721 11.4206C16.347 11.2956 16.1775 11.2254 16.0007 11.2254Z"
        fill="#9F2F48"
      />
    </svg>
  );
};

export const CarpetAreaIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 24 24"
      fill={"none"}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.23594 18.5285V2.10952L1.05561 2.29109C0.93964 2.40705 0.782358 2.4722 0.618359 2.4722C0.45436 2.4722 0.297078 2.40705 0.181113 2.29109C0.0651482 2.17512 1.22189e-09 2.01784 0 1.85384C-1.22189e-09 1.68984 0.0651482 1.53256 0.181113 1.4166L1.41627 0.181437C1.47364 0.123924 1.54179 0.0782936 1.61682 0.0471597C1.69185 0.0160257 1.77228 0 1.85352 0C1.93475 0 2.01519 0.0160257 2.09022 0.0471597C2.16525 0.0782936 2.2334 0.123924 2.29076 0.181437L3.52592 1.4166C3.64189 1.53256 3.70703 1.68984 3.70703 1.85384C3.70703 2.01784 3.64189 2.17512 3.52592 2.29109C3.40996 2.40705 3.25267 2.4722 3.08868 2.4722C2.92468 2.4722 2.76739 2.40705 2.65143 2.29109L2.4711 2.10952V18.5285H18.8901L18.7085 18.3481C18.5925 18.2322 18.5274 18.0749 18.5274 17.9109C18.5274 17.7469 18.5925 17.5896 18.7085 17.4736C18.8244 17.3577 18.9817 17.2925 19.1457 17.2925C19.3097 17.2925 19.467 17.3577 19.583 17.4736L20.8181 18.7088C20.8756 18.7662 20.9213 18.8343 20.9524 18.9094C20.9835 18.9844 20.9996 19.0648 20.9996 19.1461C20.9996 19.2273 20.9835 19.3077 20.9524 19.3828C20.9213 19.4578 20.8756 19.5259 20.8181 19.5833L19.583 20.8185C19.467 20.9344 19.3097 20.9996 19.1457 20.9996C18.9817 20.9996 18.8244 20.9344 18.7085 20.8185C18.5925 20.7025 18.5274 20.5452 18.5274 20.3812C18.5274 20.2172 18.5925 20.0599 18.7085 19.944L18.8901 19.7636H2.4711V20.3812C2.4711 20.545 2.40603 20.7021 2.29021 20.8179C2.17439 20.9337 2.01731 20.9988 1.85352 20.9988C1.68973 20.9988 1.53264 20.9337 1.41682 20.8179C1.301 20.7021 1.23594 20.545 1.23594 20.3812V19.7636H0.618359C0.454567 19.7636 0.297483 19.6986 0.181665 19.5827C0.0658464 19.4669 0.00078009 19.3098 0.00078009 19.1461C0.00078009 18.9823 0.0658464 18.8252 0.181665 18.7094C0.297483 18.5935 0.454567 18.5285 0.618359 18.5285H1.23594ZM12.7624 1.79702L19.4879 6.28065C19.558 6.3244 19.6186 6.38178 19.6661 6.44938C19.7136 6.51698 19.747 6.59343 19.7645 6.67419C19.7819 6.75496 19.783 6.8384 19.7676 6.91958C19.7522 7.00076 19.7206 7.07802 19.6749 7.1468C19.6291 7.21557 19.5699 7.27446 19.501 7.31997C19.432 7.36548 19.3546 7.39669 19.2734 7.41175C19.1921 7.42681 19.1087 7.42541 19.028 7.40764C18.9473 7.38987 18.871 7.35609 18.8036 7.3083L18.5282 7.12549V14.5142C18.5275 14.9235 18.3646 15.3158 18.0752 15.6052C17.7858 15.8946 17.3935 16.0575 16.9842 16.0582H6.48536C6.07608 16.0575 5.68375 15.8946 5.39435 15.6052C5.10494 15.3158 4.94207 14.9235 4.94141 14.5142V7.12549L4.66597 7.3083C4.5297 7.39338 4.36563 7.42201 4.20859 7.38811C4.05155 7.35421 3.9139 7.26044 3.82486 7.12672C3.73582 6.993 3.70239 6.82984 3.73167 6.67187C3.76096 6.51391 3.85064 6.37357 3.98169 6.28065L10.7071 1.79702C11.0115 1.59415 11.369 1.4859 11.7348 1.4859C12.1005 1.4859 12.4581 1.59415 12.7624 1.79702ZM17.293 6.30041L12.0769 2.82468C11.9756 2.75723 11.8565 2.72124 11.7348 2.72124C11.613 2.72124 11.494 2.75723 11.3926 2.82468L6.17657 6.30041V14.5142C6.17657 14.5961 6.2091 14.6746 6.26701 14.7326C6.32492 14.7905 6.40346 14.823 6.48536 14.823H16.9842C17.0661 14.823 17.1446 14.7905 17.2026 14.7326C17.2605 14.6746 17.293 14.5961 17.293 14.5142V6.30041Z"
        fill="#9F2F48"
      />
    </svg>
  );
};

export const GreenDownloadIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 24 24"
      fill={"none"}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.4444 16H3.55555C2.60588 16 1.71302 15.6302 1.04142 14.9586C0.369847 14.287 0 13.3941 0 12.4444V11.5555C0 11.0646 0.397948 10.6666 0.888894 10.6666C1.37984 10.6666 1.77779 11.0646 1.77779 11.5555V12.4444C1.77779 12.9193 1.96273 13.3657 2.29845 13.7015C2.63426 14.0372 3.08068 14.2222 3.55555 14.2222H12.4444C12.9193 14.2222 13.3657 14.0372 13.7015 13.7015C14.0372 13.3656 14.2222 12.9192 14.2222 12.4444V11.5555C14.2222 11.0646 14.6202 10.6666 15.1111 10.6666C15.602 10.6666 16 11.0646 16 11.5555V12.4444C16 13.3941 15.6302 14.2869 14.9586 14.9586C14.287 15.6302 13.3941 16 12.4444 16ZM7.99998 12.4444C7.76788 12.4447 7.54491 12.3539 7.37903 12.1916L7.37897 12.1915L7.3772 12.1898L7.3767 12.1893C7.3762 12.1888 7.37577 12.1884 7.3753 12.1879L7.3744 12.187C7.37408 12.1867 7.37375 12.1864 7.37341 12.186L7.37148 12.1841L3.81591 8.62852C3.46879 8.2814 3.46879 7.71857 3.81591 7.37142C4.16302 7.0243 4.72588 7.02427 5.073 7.37142L7.11112 9.40954V0.888894C7.11109 0.397948 7.50904 0 7.99998 0C8.49093 0 8.88891 0.397948 8.88891 0.888894V9.40951L10.927 7.37142C11.2741 7.0243 11.837 7.0243 12.1841 7.37142C12.5312 7.71854 12.5312 8.2814 12.1841 8.62852L8.62852 12.1841L8.62659 12.186L8.6256 12.1869L8.6247 12.1878C8.62426 12.1883 8.62377 12.1888 8.62333 12.1892L8.6228 12.1897C8.62224 12.1903 8.62166 12.1909 8.62106 12.1915L8.621 12.1915C8.61122 12.201 8.60132 12.2103 8.59119 12.2193C8.51863 12.2841 8.43585 12.3366 8.3462 12.3744L8.34533 12.3748C8.34499 12.3749 8.34471 12.3751 8.34437 12.3752C8.23535 12.421 8.11825 12.4446 7.99998 12.4444Z"
        fill="#00796B"
      />
    </svg>
  );
};

export const PdfIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 24 24"
      fill={"none"}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.26653 12.6797C4.08253 12.6797 3.95853 12.6977 3.89453 12.7157V13.8937C3.97053 13.9117 4.06553 13.9167 4.19653 13.9167C4.67553 13.9167 4.97053 13.6747 4.97053 13.2667C4.97053 12.8997 4.71653 12.6797 4.26653 12.6797ZM7.75353 12.6917C7.55353 12.6917 7.42353 12.7097 7.34653 12.7277V15.3377C7.42353 15.3557 7.54753 15.3557 7.65953 15.3557C8.47653 15.3617 9.00853 14.9117 9.00853 13.9597C9.01453 13.1297 8.52953 12.6917 7.75353 12.6917Z"
        fill="#9F2F48"
      />
      <path
        d="M10 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H14C14.5304 20 15.0391 19.7893 15.4142 19.4142C15.7893 19.0391 16 18.5304 16 18V6L10 0ZM5.498 14.19C5.189 14.48 4.733 14.61 4.202 14.61C4.09904 14.6111 3.99613 14.6051 3.894 14.592V16.018H3V12.082C3.403 12.022 3.811 11.994 4.219 12C4.776 12 5.172 12.106 5.439 12.319C5.693 12.521 5.865 12.852 5.865 13.242C5.864 13.634 5.734 13.965 5.498 14.19ZM9.305 15.545C8.885 15.894 8.246 16.06 7.465 16.06C6.997 16.06 6.666 16.03 6.441 16V12.083C6.8446 12.0241 7.25214 11.9963 7.66 12C8.417 12 8.909 12.136 9.293 12.426C9.708 12.734 9.968 13.225 9.968 13.93C9.968 14.693 9.689 15.22 9.305 15.545ZM13 12.77H11.468V13.681H12.9V14.415H11.468V16.019H10.562V12.03H13V12.77ZM10 7H9V2L14 7H10Z"
        fill="#9F2F48"
      />
    </svg>
  );
};

export const DailerIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 20 20"
      fill={"none"}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={props.className}
    >
      <path
        d="M14.1264 10.1972C13.7604 9.81609 13.3189 9.61233 12.851 9.61233C12.3869 9.61233 11.9416 9.81231 11.5605 10.1934L10.3681 11.382C10.27 11.3292 10.1719 11.2802 10.0776 11.2311C9.94172 11.1632 9.81343 11.099 9.704 11.0311C8.58708 10.3217 7.57204 9.39724 6.59851 8.20108C6.12684 7.60489 5.80987 7.10303 5.5797 6.59363C5.88912 6.31062 6.17589 6.0163 6.45512 5.7333C6.56078 5.62764 6.66643 5.51821 6.77209 5.41256C7.56449 4.62015 7.56449 3.59379 6.77209 2.80139L5.74195 1.77125C5.62498 1.65428 5.50423 1.53353 5.39103 1.41278C5.16463 1.17883 4.92691 0.937338 4.68164 0.710936C4.31562 0.348692 3.87791 0.15625 3.41756 0.15625C2.9572 0.15625 2.51195 0.348692 2.13461 0.710936L2.12706 0.718483L0.844115 2.01275C0.361123 2.49574 0.0856665 3.08439 0.0252925 3.76737C-0.0652685 4.86919 0.259242 5.89555 0.508284 6.56721C1.11957 8.21618 2.03273 9.74439 3.39492 11.382C5.04765 13.3555 7.03622 14.9139 9.30779 16.012C10.1757 16.4233 11.3341 16.91 12.6284 16.993C12.7076 16.9968 12.7906 17.0006 12.8661 17.0006C13.7377 17.0006 14.4698 16.6874 15.0433 16.0648C15.0471 16.0573 15.0546 16.0535 15.0584 16.0459C15.2546 15.8082 15.481 15.5931 15.7188 15.3629C15.881 15.2082 16.047 15.046 16.2093 14.8762C16.5829 14.4875 16.7791 14.0347 16.7791 13.5706C16.7791 13.1027 16.5791 12.6537 16.198 12.2763L14.1264 10.1972ZM15.4773 14.1706C15.4735 14.1706 15.4735 14.1743 15.4773 14.1706C15.3301 14.329 15.1792 14.4724 15.0169 14.6309C14.7716 14.8649 14.5226 15.1101 14.2886 15.3856C13.9075 15.7931 13.4585 15.9856 12.8699 15.9856C12.8133 15.9856 12.7529 15.9856 12.6963 15.9818C11.5756 15.9101 10.5341 15.4724 9.75305 15.0988C7.61732 14.0649 5.74195 12.5971 4.18355 10.7368C2.89683 9.18594 2.0365 7.75205 1.46672 6.21252C1.1158 5.27295 0.987503 4.54091 1.0441 3.85038C1.08184 3.4089 1.25164 3.04288 1.56483 2.72969L2.85155 1.44297C3.03645 1.2694 3.23266 1.17506 3.4251 1.17506C3.66283 1.17506 3.85527 1.31845 3.97602 1.4392L3.98734 1.45052C4.21751 1.6656 4.43637 1.88823 4.66654 2.12595C4.78352 2.2467 4.90426 2.36745 5.02501 2.49197L6.05514 3.5221C6.45512 3.92208 6.45512 4.29187 6.05514 4.69185C5.94572 4.80127 5.84006 4.9107 5.73063 5.01636C5.41367 5.34087 5.1118 5.64274 4.78352 5.93706C4.77597 5.94461 4.76842 5.94838 4.76465 5.95593C4.44014 6.28044 4.50051 6.5974 4.56843 6.81248L4.57975 6.84644C4.84766 7.49546 5.225 8.10675 5.79855 8.83501L5.80233 8.83879C6.84378 10.1217 7.94183 11.1217 9.15308 11.8877C9.30779 11.9858 9.46627 12.065 9.61721 12.1405C9.75305 12.2084 9.88134 12.2726 9.99077 12.3405C10.0059 12.348 10.021 12.3593 10.0361 12.3669C10.1643 12.431 10.2851 12.4612 10.4096 12.4612C10.7228 12.4612 10.919 12.265 10.9832 12.2009L12.2737 10.9104C12.402 10.7821 12.6057 10.6274 12.8434 10.6274C13.0774 10.6274 13.2698 10.7745 13.3868 10.9028L13.3944 10.9104L15.4735 12.9895C15.8621 13.3744 15.8621 13.7706 15.4773 14.1706Z"
        fill="#9F2F48"
      />
    </svg>
  );
};

export const RedUserIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 20 20"
      fill={"none"}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={props.className}
    >
      <path
        d="M10.0001 10.6263C7.35846 10.6263 5.20846 8.4763 5.20846 5.83464C5.20846 3.19297 7.35846 1.04297 10.0001 1.04297C12.6418 1.04297 14.7918 3.19297 14.7918 5.83464C14.7918 8.4763 12.6418 10.6263 10.0001 10.6263ZM10.0001 2.29297C8.05013 2.29297 6.45846 3.88464 6.45846 5.83464C6.45846 7.78464 8.05013 9.3763 10.0001 9.3763C11.9501 9.3763 13.5418 7.78464 13.5418 5.83464C13.5418 3.88464 11.9501 2.29297 10.0001 2.29297ZM17.1585 18.9596C16.8168 18.9596 16.5335 18.6763 16.5335 18.3346C16.5335 15.4596 13.6001 13.1263 10.0001 13.1263C6.40013 13.1263 3.4668 15.4596 3.4668 18.3346C3.4668 18.6763 3.18346 18.9596 2.8418 18.9596C2.50013 18.9596 2.2168 18.6763 2.2168 18.3346C2.2168 14.7763 5.70846 11.8763 10.0001 11.8763C14.2918 11.8763 17.7835 14.7763 17.7835 18.3346C17.7835 18.6763 17.5001 18.9596 17.1585 18.9596Z"
        fill="#9F2F48"
      />
    </svg>
  );
};

export const ClockIcon = (props) => {
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 24 24"
    fill={"none"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2067 10.5894L9.69703 8.70714V4.87293C9.69703 4.48741 9.38541 4.17578 8.99988 4.17578C8.61436 4.17578 8.30273 4.48741 8.30273 4.87293V9.05575C8.30273 9.27534 8.40592 9.48241 8.58159 9.61347L11.3701 11.7049C11.4905 11.7955 11.6371 11.8445 11.7877 11.8443C12.0003 11.8443 12.2095 11.7488 12.3461 11.5647C12.5776 11.2573 12.5149 10.8202 12.2067 10.5894Z"
      fill="#9F2F48"
    />
    <path
      d="M9 0C4.0371 0 0 4.0371 0 9C0 13.9629 4.0371 18 9 18C13.9629 18 18 13.9629 18 9C18 4.0371 13.9629 0 9 0ZM9 16.6057C4.80674 16.6057 1.39426 13.1933 1.39426 9C1.39426 4.80674 4.80674 1.39426 9 1.39426C13.194 1.39426 16.6057 4.80674 16.6057 9C16.6057 13.1933 13.1933 16.6057 9 16.6057Z"
      fill="#9F2F48"
    />
  </svg>;
};

export const CalendarIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 24 24"
      fill={"none"}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_2718_15579"
        masktype="luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18"
      >
        <path
          d="M17.2501 17.25V0.749937H0.75V17.25H17.2501Z"
          fill="white"
          stroke="currentColor"
          strokeWidth={props.strokeWidth}
        />
      </mask>
      <g mask="url(#mask0_2718_15579)">
        <path
          d="M8.30861 13.8516H9.69141M12.4651 13.8516H13.8479M4.16016 13.8516H5.54296M8.30861 9.7031H9.69141M12.4651 9.7031H13.8479M4.16016 9.7031H5.54296M0.703125 6.23432H17.3049M13.1565 4.1601V0.703065M4.85158 4.1601V0.703065M3.47675 17.2969H14.5313C16.0631 17.2969 17.3049 16.0551 17.3049 14.5232V4.85953C17.3049 3.3277 16.0631 2.08587 14.5313 2.08587H3.47675C1.94492 2.08587 0.703125 3.3277 0.703125 4.85953V14.5232C0.703125 16.0551 1.94492 17.2969 3.47675 17.2969Z"
          stroke="currentColor"
          strokeWidth={props.strokeWidth}
          strokeMiterLimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const MepSentIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0247 2.17578C18.0247 2.10078 18.0247 2.02578 17.9502 1.95078V1.87578C17.9502 1.80078 17.8757 1.72578 17.8012 1.65078C17.764 1.61328 17.7267 1.59453 17.6895 1.57578C17.6522 1.55703 17.615 1.53828 17.5778 1.50078H17.5033C17.4288 1.50078 17.3543 1.50078 17.2798 1.42578V1.50078C17.2053 1.50078 17.1308 1.50078 17.0564 1.57578L2.1591 6.82578C1.86115 6.90078 1.6377 7.12578 1.6377 7.50078C1.6377 7.80078 1.78667 8.10078 2.08461 8.25078L8.49043 11.1008L11.3209 17.5508C11.4699 17.8508 11.6933 18.0008 11.9913 18.0008C12.2892 18.0008 12.5872 17.7758 12.6617 17.4758L17.8757 2.47578C18.0247 2.40078 18.0247 2.32578 18.0247 2.17578ZM14.4493 4.05078L8.93735 9.60078L4.39369 7.57578L14.4493 4.05078ZM9.98016 10.6508L11.9913 15.2258L15.4921 5.10078L9.98016 10.6508Z"
        fill="black"
      />
      <mask
        id="mask0_2718_14654"
        masktype="luminance"
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="18"
        height="17"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.0247 2.17578C18.0247 2.10078 18.0247 2.02578 17.9502 1.95078V1.87578C17.9502 1.80078 17.8757 1.72578 17.8012 1.65078C17.764 1.61328 17.7267 1.59453 17.6895 1.57578C17.6522 1.55703 17.615 1.53828 17.5778 1.50078H17.5033C17.4288 1.50078 17.3543 1.50078 17.2798 1.42578V1.50078C17.2053 1.50078 17.1308 1.50078 17.0564 1.57578L2.1591 6.82578C1.86115 6.90078 1.6377 7.12578 1.6377 7.50078C1.6377 7.80078 1.78667 8.10078 2.08461 8.25078L8.49043 11.1008L11.3209 17.5508C11.4699 17.8508 11.6933 18.0008 11.9913 18.0008C12.2892 18.0008 12.5872 17.7758 12.6617 17.4758L17.8757 2.47578C18.0247 2.40078 18.0247 2.32578 18.0247 2.17578ZM14.4493 4.05078L8.93735 9.60078L4.39369 7.57578L14.4493 4.05078ZM9.98016 10.6508L11.9913 15.2258L15.4921 5.10078L9.98016 10.6508Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_2718_14654)">
        <rect x="0.892578" width="17.8767" height="18" fill="#6E6B7B" />
      </g>
    </svg>
  );
};

export const MepEyeIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.58484 2.25C15.183 2.25 18.3179 8.4 18.4672 8.7C18.5419 8.85 18.5419 9.15 18.4672 9.3C18.3179 9.6 15.183 15.75 9.58484 15.75C4.31558 15.75 1.22859 10.3014 0.759582 9.47355L0.759578 9.47354L0.759567 9.47353C0.730303 9.42187 0.711234 9.38822 0.702466 9.375C0.627824 9.15 0.627824 8.925 0.702466 8.7C0.851749 8.4 3.98671 2.25 9.58484 2.25ZM2.1953 9C2.94172 10.2 5.55418 14.25 9.58484 14.25C13.6155 14.25 16.228 10.2 16.9744 9C16.228 7.8 13.6155 3.75 9.58484 3.75C5.55418 3.75 2.86708 7.8 2.1953 9ZM9.58484 6C7.94272 6 6.59917 7.35 6.59917 9C6.59917 10.65 7.94272 12 9.58484 12C11.227 12 12.5705 10.65 12.5705 9C12.5705 7.35 11.227 6 9.58484 6ZM8.092 9C8.092 9.825 8.76378 10.5 9.58484 10.5C10.4059 10.5 11.0777 9.825 11.0777 9C11.0777 8.175 10.4059 7.5 9.58484 7.5C8.76378 7.5 8.092 8.175 8.092 9Z"
        fill="black"
      />
      <mask
        id="mask0_2718_14653"
        masktype="luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="2"
        width="19"
        height="14"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.58484 2.25C15.183 2.25 18.3179 8.4 18.4672 8.7C18.5419 8.85 18.5419 9.15 18.4672 9.3C18.3179 9.6 15.183 15.75 9.58484 15.75C4.31558 15.75 1.22859 10.3014 0.759582 9.47355L0.759578 9.47354L0.759567 9.47353C0.730303 9.42187 0.711234 9.38822 0.702466 9.375C0.627824 9.15 0.627824 8.925 0.702466 8.7C0.851749 8.4 3.98671 2.25 9.58484 2.25ZM2.1953 9C2.94172 10.2 5.55418 14.25 9.58484 14.25C13.6155 14.25 16.228 10.2 16.9744 9C16.228 7.8 13.6155 3.75 9.58484 3.75C5.55418 3.75 2.86708 7.8 2.1953 9ZM9.58484 6C7.94272 6 6.59917 7.35 6.59917 9C6.59917 10.65 7.94272 12 9.58484 12C11.227 12 12.5705 10.65 12.5705 9C12.5705 7.35 11.227 6 9.58484 6ZM8.092 9C8.092 9.825 8.76378 10.5 9.58484 10.5C10.4059 10.5 11.0777 9.825 11.0777 9C11.0777 8.175 10.4059 7.5 9.58484 7.5C8.76378 7.5 8.092 8.175 8.092 9Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_2718_14653)">
        <rect x="0.646484" width="17.8767" height="18" fill="#6E6B7B" />
      </g>
    </svg>
  );
};

export const GreenRupeeIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2H1C0.734784 2 0.48043 1.89464 0.292893 1.70711C0.105357 1.51957 0 1.26522 0 1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H13C13.2652 0 13.5196 0.105357 13.7071 0.292893C13.8946 0.48043 14 0.734784 14 1C14 1.26522 13.8946 1.51957 13.7071 1.70711C13.5196 1.89464 13.2652 2 13 2H10C10.4452 2.59133 10.7527 3.27463 10.9 4H13C13.2652 4 13.5196 4.10536 13.7071 4.29289C13.8946 4.48043 14 4.73478 14 5C14 5.26522 13.8946 5.51957 13.7071 5.70711C13.5196 5.89464 13.2652 6 13 6H10.9C10.6691 7.12919 10.0554 8.14401 9.16254 8.87286C8.2697 9.6017 7.15255 9.99986 6 10H5.414L11.707 16.293C11.8892 16.4816 11.99 16.7342 11.9877 16.9964C11.9854 17.2586 11.8802 17.5094 11.6948 17.6948C11.5094 17.8802 11.2586 17.9854 10.9964 17.9877C10.7342 17.99 10.4816 17.8892 10.293 17.707L2.293 9.707C2.15319 9.56715 2.05798 9.38898 2.01942 9.19503C1.98085 9.00108 2.00065 8.80005 2.07632 8.61735C2.15199 8.43465 2.28013 8.27848 2.44454 8.1686C2.60895 8.05871 2.80225 8.00004 3 8H6C6.62048 8.00012 7.22574 7.80784 7.73239 7.44966C8.23905 7.09147 8.62217 6.585 8.829 6H1C0.734784 6 0.48043 5.89464 0.292893 5.70711C0.105357 5.51957 0 5.26522 0 5C0 4.73478 0.105357 4.48043 0.292893 4.29289C0.48043 4.10536 0.734784 4 1 4H8.829C8.62217 3.415 8.23905 2.90853 7.73239 2.55034C7.22574 2.19216 6.62048 1.99988 6 2Z"
        fill="#28C76F"
      />
    </svg>
  );
};

export const RequestedUser = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      color={props.color}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5 22H6.59087C5.04549 22 3.81631 21.248 2.71266 20.1966C0.453366 18.0441 4.1628 16.324 5.57757 15.4816C7.67837 14.2307 10.1368 13.7719 12.5 14.1052C13.3575 14.2261 14.1926 14.4514 15 14.7809"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 6.5C16.5 8.98528 14.4853 11 12 11C9.51472 11 7.5 8.98528 7.5 6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M18.5 22V15M15 18.5H22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const ApprovedUser = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      color={props.color}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 18C14 18 15 18 16 20C16 20 19.1765 15 22 14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 22H6.59087C5.04549 22 3.81631 21.248 2.71266 20.1966C0.453366 18.0441 4.1628 16.324 5.57757 15.4816C8.75591 13.5891 12.7529 13.5096 16 15.2432"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 6.5C16.5 8.98528 14.4853 11 12 11C9.51472 11 7.5 8.98528 7.5 6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const RejectedUser = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      color={props.color}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13 22H6.59087C5.04549 22 3.81631 21.248 2.71266 20.1966C0.453366 18.0441 4.1628 16.324 5.57757 15.4816C7.97679 14.053 10.8425 13.6575 13.5 14.2952"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 6.5C16.5 8.98528 14.4853 11 12 11C9.51472 11 7.5 8.98528 7.5 6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M16 22L19 19M19 19L22 16M19 19L16 16M19 19L22 22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const CrossIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="12.5" cy="12.5" r="12.5" fill="#FFE2E3" />
      <path
        d="M17.0837 8.91797L8.91699 17.0846M8.91699 8.91797L17.0837 17.0846"
        stroke="#FF4C51"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CheckIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="12.5" cy="12.5" r="12.5" fill="#DDF6E8" />
      <path
        d="M8.91699 14.168L10.9587 16.2096L17.0837 9.79297"
        stroke="#28C76F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EditIcon = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.75 15.6201V16.5H10.63C10.937 16.5 11.0906 16.5 11.2286 16.4428C11.3666 16.3856 11.4752 16.2771 11.6923 16.0601L15.31 12.442C15.5148 12.2373 15.6172 12.1349 15.6719 12.0245C15.776 11.8144 15.776 11.5677 15.6719 11.3575C15.6172 11.2471 15.5148 11.1447 15.31 10.94C15.1052 10.7352 15.0029 10.6328 14.8924 10.5781C14.6822 10.474 14.4355 10.474 14.2253 10.5781C14.1149 10.6328 14.0125 10.7352 13.8077 10.94L10.19 14.558C9.9729 14.775 9.86437 14.8835 9.80715 15.0215C9.75 15.1596 9.75 15.313 9.75 15.6201Z"
        stroke="#53587A"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 8.25C14.25 8.25 14.25 7.07295 14.1358 6.79729C14.0216 6.52164 13.8049 6.30487 13.3713 5.87132L9.81892 2.31891C9.44475 1.94475 9.2577 1.75766 9.02588 1.64681C8.97765 1.62375 8.9283 1.60329 8.8779 1.58551C8.63558 1.5 8.37105 1.5 7.84185 1.5C5.40811 1.5 4.19123 1.5 3.367 2.16455C3.20048 2.29881 3.04881 2.45048 2.91455 2.617C2.25 3.44123 2.25 4.65812 2.25 7.09188V10.5C2.25 13.3284 2.25 14.7427 3.12868 15.6213C3.926 16.4186 5.16427 16.4925 7.5 16.4993M9 1.875V2.25C9 4.37132 9 5.43198 9.65903 6.09099C10.3181 6.75 11.3787 6.75 13.5 6.75H13.875"
        stroke="#53587A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

/* <----- BANK ICONS START -----> */
export const AxisBank = (props) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2762_11050)">
        <path
          d="M33.0024 30.7344H23.0489L17.0039 20.1965H26.9574L33.0024 30.7344Z"
          fill="#AE285D"
        />
        <path
          d="M16.9662 2.99898L21.9562 11.5826L10.9326 30.7383H0.998047L16.9662 2.99898Z"
          fill="#AE285D"
        />
      </g>
      <defs>
        <clipPath id="clip0_2762_11050">
          <rect
            width="32"
            height="27.7378"
            fill="white"
            transform="translate(1 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const BankOfBaroda = (props) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2762_10970)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.6617 31.5193L5.02539 31.5308L5.12279 31.0505L15.0602 30.7655C16.9653 30.6929 18.816 30.5925 20.6067 29.9821C24.2777 28.7564 27.204 26.256 28.0649 23.1609C28.9881 19.8438 26.8652 16.6156 22.8669 16.3367C26.2548 15.3457 29.1424 13.1986 29.9119 10.4339C30.9102 6.84512 29.1037 5.03199 26.0534 4.36591C31.128 4.28665 35.0972 5.9927 33.7463 10.8483C32.978 13.6125 30.0214 15.7148 26.6547 16.6319C30.6071 16.9265 32.7753 20.6914 31.7275 23.9728C30.6367 27.3885 27.881 29.5108 24.21 30.7365C22.4168 31.3463 20.5656 31.4467 18.6617 31.5193Z"
          fill="#F26522"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5045 29.801L5.10558 30.1186C5.10377 29.9553 5.11224 29.9922 5.09288 29.8343L21.3028 25.0398L21.3566 24.4542L4.79765 28.735C4.74683 28.5783 4.74138 28.6213 4.67302 28.4731L22.0058 18.8762L21.8309 18.3977L4.12128 27.5535C4.0148 27.4022 4.06078 27.4664 3.93676 27.3296L24.5412 8.08878L24.2884 7.56729L3.17871 26.6478C3.07829 26.577 3.01416 26.5256 2.90708 26.4621L18.0117 4.72024L17.3752 4.72569L1.91672 26.0108C1.83081 25.9811 1.73402 25.9545 1.64508 25.9297L10.6212 4.68757H10.0507L0.393377 25.7676C0.2748 25.7664 0.00195312 25.7688 0.00195312 25.7688L6.25202 3.19206L17.9258 3.22775C23.4486 2.91195 27.8106 4.40202 26.3755 9.56071C25.606 12.3249 22.7184 14.472 19.3517 15.3897L19.3317 15.4635C23.3301 15.743 25.5824 18.9627 24.6604 22.2786C23.7995 25.3737 20.722 27.7918 17.051 29.0175C15.259 29.6274 13.409 29.7278 11.5045 29.801Z"
          fill="#F26522"
        />
      </g>
      <defs>
        <clipPath id="clip0_2762_10970">
          <rect width="34" height="34" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const BankOfIndia = (props) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.703 26.3444L8.03041 34L12.8821 23.5269L3 17.8092L14.2978 19.0187L16.703 1L19.1083 19.0187L30.4061 17.8092L20.5239 23.5269L25.3757 34L16.703 26.3444Z"
        fill="black"
      />
      <path
        d="M16.703 26.1238L8.51138 33.3533L13.102 23.4574L3.75586 18.0559L14.4352 19.2104L16.703 2.25L18.9708 19.2104L29.6501 18.0559L20.304 23.4574L24.8946 33.3533L16.703 26.1238Z"
        fill="#E53312"
      />
      <path
        d="M18.9704 19.2109H14.4348L13.1016 23.4579L16.7026 26.1243L20.3036 23.4579L18.9704 19.2109Z"
        fill="#0075BF"
      />
      <path
        d="M16.7029 25.2163C15.0948 25.2163 13.7891 23.9106 13.7891 22.3025C13.7891 20.6944 15.0948 19.375 16.7029 19.375C18.3109 19.375 19.6166 20.6807 19.6166 22.3025C19.6166 23.8969 18.3109 25.2163 16.7029 25.2163Z"
        fill="black"
      />
      <path
        d="M16.702 25.0524C15.1764 25.0524 13.9531 23.8154 13.9531 22.3035C13.9531 20.7917 15.1901 19.5547 16.702 19.5547C18.2276 19.5547 19.4508 20.7917 19.4508 22.3035C19.4508 23.8154 18.2138 25.0524 16.702 25.0524Z"
        fill="white"
      />
      <path
        d="M16.7706 20.572C16.7568 20.572 16.7568 20.572 16.7706 20.572C16.7568 20.572 16.7431 20.572 16.7431 20.572C16.7293 20.572 16.7293 20.572 16.7156 20.572C16.7018 20.5583 16.6743 20.572 16.6606 20.572C16.6469 20.572 16.6469 20.5583 16.6469 20.5583V20.572C16.6606 20.572 16.6606 20.572 16.6743 20.572C16.6881 20.5858 16.6881 20.5995 16.7018 20.6133C16.7156 20.6133 16.7431 20.6133 16.7431 20.6133C16.7568 20.6133 16.7568 20.5995 16.7568 20.5858C16.7568 20.5858 16.7706 20.5858 16.7843 20.5858L16.7706 20.572ZM16.6881 20.6133C16.6881 20.5995 16.7018 20.6133 16.7018 20.6133C16.7156 20.6133 16.6881 20.6133 16.6881 20.6133ZM16.7018 21.5754C16.6743 21.5754 16.6469 21.5891 16.6331 21.6166C16.6194 21.6303 16.6194 21.6578 16.6331 21.6716C16.6469 21.6853 16.6743 21.7128 16.7018 21.7128C16.7293 21.7128 16.7568 21.6853 16.7706 21.6716C16.798 21.6166 16.7568 21.5754 16.7018 21.5754ZM16.7156 21.6853C16.7018 21.6991 16.7018 21.6991 16.6881 21.6853C16.6743 21.6716 16.6743 21.6578 16.6743 21.6303C16.6743 21.6029 16.7018 21.5891 16.7156 21.5754C16.7431 21.6029 16.7431 21.6578 16.7156 21.6853ZM17.6639 22.6749C17.6502 22.6749 17.6502 22.6474 17.6502 22.6474C17.6364 22.6749 17.6364 22.6749 17.6227 22.6749C17.609 22.6749 17.609 22.6749 17.5952 22.6749C17.5952 22.7024 17.6502 22.7024 17.6502 22.6749C17.6639 22.6886 17.6914 22.7024 17.7052 22.6749C17.6914 22.6886 17.6777 22.6749 17.6639 22.6749ZM17.8426 22.6749C17.8289 22.6749 17.8014 22.6612 17.7739 22.6612C17.7601 22.6612 17.7464 22.6749 17.7327 22.6886C17.7189 22.7024 17.7052 22.7299 17.7189 22.7574C17.7189 22.7574 17.7189 22.7711 17.7327 22.7711C17.7327 22.7711 17.7327 22.7574 17.7464 22.7574C17.7876 22.7574 17.8151 22.7574 17.8426 22.7436C17.8563 22.7299 17.8564 22.7161 17.8701 22.7024C17.8701 22.6887 17.8838 22.6749 17.8838 22.6612C17.8564 22.6749 17.8426 22.6749 17.8426 22.6749ZM17.7601 22.7436C17.7464 22.7436 17.7464 22.7436 17.7601 22.7436C17.7464 22.7299 17.7464 22.7299 17.7601 22.7436C17.7601 22.7161 17.7601 22.7161 17.7739 22.7161C17.7876 22.7161 17.7876 22.7436 17.7739 22.7436C17.7876 22.7436 17.8014 22.7299 17.8014 22.7161C17.8151 22.7161 17.8151 22.7161 17.8151 22.7299C17.8151 22.7436 17.7876 22.7574 17.7601 22.7436ZM17.5402 22.6886C17.5127 22.6749 17.4715 22.6886 17.444 22.6886L17.4303 22.6749C17.4303 22.7024 17.444 22.7161 17.4715 22.7161C17.4853 22.7574 17.5265 22.7711 17.5815 22.7574C17.5815 22.7574 17.5815 22.7711 17.5952 22.7711L17.609 22.7574C17.609 22.7436 17.5952 22.7299 17.5952 22.7161C17.5815 22.7161 17.554 22.6886 17.5402 22.6886ZM17.499 22.7161C17.5127 22.7024 17.5402 22.7299 17.5265 22.7299H17.5127C17.5127 22.7574 17.5402 22.7436 17.554 22.7436C17.554 22.7436 17.5677 22.7436 17.5677 22.7574C17.5402 22.7574 17.4853 22.7436 17.499 22.7161ZM17.609 23.1147C17.609 23.1285 17.6227 23.1422 17.6364 23.1422C17.6502 23.1422 17.6639 23.1285 17.6639 23.1147C17.6502 23.101 17.6227 23.101 17.609 23.1147ZM17.2379 23.747C17.2516 23.7332 17.2791 23.7332 17.2928 23.7195C17.2653 23.692 17.1966 23.692 17.1966 23.747C17.1966 23.7744 17.2379 23.7744 17.2379 23.747ZM17.4028 24.2005C17.389 24.2005 17.3753 24.2143 17.3616 24.2143C17.3478 24.2143 17.3478 24.2005 17.3341 24.2005C17.3203 24.2005 17.2928 24.1868 17.2791 24.1868C17.2516 24.1868 17.1829 24.2005 17.2241 24.228C17.2379 24.2417 17.2653 24.2418 17.2791 24.2418C17.2653 24.2555 17.2791 24.2692 17.2791 24.2692C17.3066 24.283 17.3616 24.283 17.4028 24.2967C17.4303 24.2967 17.4578 24.2967 17.499 24.2967C17.5127 24.2967 17.5265 24.3105 17.5402 24.3105C17.5815 24.3105 17.5952 24.3105 17.6227 24.2967C17.6364 24.283 17.6502 24.283 17.6364 24.2555C17.609 24.2418 17.5677 24.228 17.5265 24.228C17.5127 24.1868 17.444 24.1868 17.4028 24.2005ZM18.6398 23.8157C18.626 23.8157 18.6123 23.8157 18.5985 23.8019C18.5711 23.8019 18.5436 23.8019 18.5161 23.8019C18.4886 23.8019 18.4748 23.8019 18.4474 23.7882C18.4199 23.7882 18.3924 23.7744 18.3786 23.7744C18.3649 23.7744 18.3374 23.747 18.3237 23.747C18.2549 23.7057 18.1862 23.6782 18.1175 23.6507C18.1312 23.6233 18.145 23.6095 18.1587 23.582C18.1725 23.5545 18.1725 23.5133 18.1862 23.4721C18.1862 23.4446 18.2 23.4171 18.2 23.4033C18.2 23.3484 18.2 23.3071 18.2 23.2522C18.1862 23.101 18.2 22.9635 18.2 22.8398C18.2 22.7849 18.1862 22.7299 18.1725 22.6749C18.1587 22.6199 18.145 22.5649 18.1175 22.5237C18.1175 22.51 18.1037 22.4825 18.09 22.4687C18.0763 22.455 18.0625 22.4413 18.0488 22.4413V22.4275C18.0488 22.4138 18.0213 22.4 18.0075 22.3863C17.9938 22.3725 17.9938 22.3725 17.98 22.3588C17.9663 22.3588 17.9526 22.345 17.9388 22.345C17.9251 22.345 17.9251 22.345 17.9113 22.3313C17.8976 22.3313 17.8976 22.3176 17.8976 22.3176C17.8701 22.3038 17.8426 22.3038 17.8014 22.3038C17.8014 22.3038 17.7876 22.3038 17.7876 22.2901C17.7327 22.2763 17.6639 22.2901 17.609 22.2763C17.554 22.2626 17.499 22.2351 17.4578 22.2076C17.4578 22.1801 17.444 22.1664 17.4165 22.1664C17.4165 22.1526 17.4303 22.1251 17.4028 22.1114H17.389C17.3616 22.0152 17.3478 21.919 17.3203 21.8365C17.3066 21.7953 17.2928 21.7403 17.2791 21.6991C17.2791 21.6716 17.2653 21.6441 17.2653 21.6166C17.2653 21.5891 17.2516 21.5616 17.2516 21.5479C17.2516 21.5066 17.2516 21.4792 17.2379 21.4379C17.2516 21.4242 17.2791 21.3967 17.2791 21.3692V21.3555C17.2791 21.3417 17.2653 21.328 17.2516 21.3005C17.2241 21.2455 17.2241 21.1768 17.2104 21.1218C17.1966 21.0531 17.1829 20.9981 17.1691 20.9431C17.1554 20.9294 17.1554 20.9019 17.1417 20.8881C17.1279 20.8469 17.1142 20.8332 17.0867 20.8194C17.0867 20.8057 17.0729 20.7919 17.0729 20.7782C17.0729 20.7645 17.0592 20.7507 17.0592 20.737C17.0592 20.7095 17.0592 20.6957 17.0592 20.682C17.0592 20.6682 17.0454 20.6682 17.0454 20.6682C17.0454 20.6545 17.0454 20.6545 17.0454 20.6408C17.0454 20.627 17.0317 20.627 17.0317 20.6133C17.0454 20.5858 17.0317 20.5583 17.0179 20.5445C17.0317 20.5308 17.018 20.5033 17.0042 20.4896C17.018 20.4758 17.0042 20.4483 16.9905 20.4346C17.0042 20.4071 16.9905 20.3934 16.9767 20.3796C16.9905 20.3521 16.9767 20.3246 16.963 20.3109V20.2971C16.963 20.2834 16.9492 20.2834 16.9492 20.2697C16.9492 20.2559 16.9492 20.2559 16.9492 20.2422C16.9492 20.2284 16.9492 20.2284 16.9355 20.2147C16.9355 20.1597 16.9217 20.1322 16.8805 20.091C16.8255 20.036 16.7568 20.0223 16.7018 20.0223C16.6331 20.0085 16.5781 20.0497 16.5232 20.0772C16.4819 20.1047 16.4682 20.1322 16.4544 20.1734V20.1872C16.4407 20.2147 16.4269 20.2422 16.4269 20.2834C16.4132 20.3109 16.4132 20.3246 16.4132 20.3384C16.4132 20.3521 16.4132 20.3659 16.4132 20.3659V20.3796V20.3934C16.3995 20.4071 16.3995 20.4346 16.3995 20.4483C16.3857 20.4621 16.3857 20.4896 16.3995 20.5033C16.3857 20.5171 16.3857 20.5583 16.3995 20.572C16.3995 20.5858 16.3857 20.5858 16.3857 20.5995C16.3857 20.6133 16.3995 20.6133 16.3995 20.627C16.3995 20.6408 16.3857 20.6408 16.3857 20.6545C16.3857 20.6682 16.3857 20.682 16.3857 20.6957C16.372 20.7095 16.3582 20.737 16.372 20.7507C16.372 20.7645 16.3582 20.7645 16.3582 20.7645V20.7782C16.3582 20.7919 16.3445 20.8057 16.3307 20.8057C16.3307 20.8194 16.317 20.8332 16.317 20.8469C16.3032 20.8744 16.2758 20.9156 16.262 20.9569C16.2345 21.0943 16.1933 21.2592 16.1658 21.3967C16.1658 21.4242 16.1521 21.4517 16.1383 21.4792C16.0696 21.4517 15.9734 21.4379 15.8909 21.4242C15.8909 21.4104 15.8909 21.3967 15.8772 21.3829C15.8634 21.3692 15.8497 21.3829 15.8222 21.3967C15.8222 21.3829 15.781 21.3692 15.7672 21.3829C15.7535 21.3829 15.7535 21.3692 15.7397 21.3692C15.726 21.328 15.7122 21.3005 15.6848 21.273C15.671 21.2592 15.6573 21.2592 15.6435 21.2455C15.616 21.2318 15.6023 21.218 15.5748 21.2043C15.5611 21.2043 15.5198 21.1768 15.5198 21.163V21.1493C15.4923 21.0531 15.4786 20.9706 15.4511 20.8744C15.4511 20.8607 15.4374 20.8469 15.4374 20.8332L15.4511 20.8194C15.4511 20.8057 15.4511 20.7919 15.4374 20.7782C15.4236 20.737 15.4099 20.7095 15.4099 20.6682C15.4511 20.6545 15.4786 20.6408 15.5061 20.627C15.5198 20.5995 15.5336 20.5858 15.5336 20.5445C15.5198 20.4483 15.4511 20.3659 15.4374 20.2559C15.4374 20.2284 15.4374 20.2147 15.4374 20.1872C15.4236 20.1872 15.4236 20.2009 15.4099 20.2147C15.3824 20.2971 15.4236 20.3796 15.4374 20.4483C15.4374 20.4758 15.4374 20.5171 15.4099 20.5445C15.3961 20.5583 15.3824 20.572 15.3686 20.572C15.3549 20.5445 15.3549 20.4896 15.3549 20.4621C15.3412 20.4483 15.3686 20.4208 15.3549 20.4071C15.3549 20.4071 15.3411 20.3934 15.3274 20.3796C15.3137 20.3659 15.3137 20.3659 15.3137 20.3521C15.2862 20.3109 15.2587 20.2559 15.2449 20.2147C15.2312 20.2009 15.2312 20.1734 15.2175 20.1734C15.2037 20.1872 15.2175 20.2009 15.2175 20.2009C15.2175 20.2422 15.2312 20.2697 15.2312 20.3109C15.2312 20.3384 15.2312 20.3934 15.2312 20.4208C15.2312 20.4346 15.2175 20.4346 15.2175 20.4483L15.2312 20.4621C15.2312 20.4758 15.2449 20.4758 15.2449 20.4896C15.2724 20.5171 15.2862 20.5583 15.2999 20.5995C15.2862 20.5995 15.2862 20.6133 15.2862 20.627C15.2312 20.6545 15.19 20.6133 15.19 20.5583C15.19 20.5171 15.19 20.4621 15.19 20.4208C15.1762 20.3659 15.1625 20.3246 15.135 20.2971C15.1212 20.2834 15.1212 20.2697 15.0938 20.2834C15.0938 20.2971 15.1075 20.3109 15.1075 20.3246C15.135 20.4071 15.1212 20.5445 15.1212 20.6408C15.1212 20.682 15.1487 20.7095 15.1762 20.737C15.2174 20.7644 15.2587 20.7507 15.3137 20.737C15.3274 20.7782 15.3411 20.8194 15.3411 20.8607C15.3411 20.8744 15.3411 20.8744 15.3411 20.8881L15.3549 20.9019C15.3686 20.9156 15.3686 20.9294 15.3686 20.9431C15.3961 21.0531 15.4236 21.163 15.4511 21.273C15.4511 21.2867 15.4374 21.2867 15.4374 21.2867C15.4374 21.3005 15.4374 21.3142 15.4374 21.3417C15.4374 21.3555 15.4374 21.3555 15.4374 21.3692C15.4374 21.3829 15.4511 21.3829 15.4511 21.3967C15.4511 21.4104 15.4511 21.4379 15.4648 21.4517C15.4648 21.4654 15.4786 21.4929 15.4923 21.5066C15.5061 21.5204 15.5198 21.5204 15.5198 21.5341C15.5198 21.5479 15.5336 21.5754 15.5336 21.5891C15.5336 21.6029 15.5473 21.6303 15.5473 21.6441C15.5748 21.754 15.6023 21.864 15.6298 21.9739C15.726 22.3313 15.8085 22.7024 15.8909 23.0597C15.9047 23.1285 15.9322 23.2109 15.9459 23.2797C15.9322 23.2797 15.9184 23.2934 15.9047 23.2934C15.8772 23.3071 15.8497 23.3071 15.8359 23.3209C15.7947 23.3346 15.7535 23.3621 15.726 23.3759C15.726 23.3759 15.7122 23.3759 15.7122 23.3896C15.616 23.4583 15.5473 23.5683 15.4923 23.6645C15.4786 23.6782 15.4786 23.692 15.4648 23.7057C15.4648 23.7195 15.4648 23.7195 15.4511 23.7332C15.4511 23.747 15.4374 23.747 15.4374 23.7607C15.4236 23.8019 15.4099 23.8432 15.3961 23.8981C15.3824 23.9669 15.3961 24.0218 15.4099 24.0768C15.3824 24.0768 15.3274 24.0906 15.3137 24.1181C15.3137 24.1318 15.3274 24.1455 15.3411 24.1593C15.3274 24.1593 15.3137 24.173 15.2999 24.1593C15.2724 24.1593 15.2175 24.1455 15.19 24.1593C15.1762 24.1593 15.1625 24.173 15.1625 24.1868C15.1625 24.2143 15.2174 24.2143 15.2449 24.2143C15.2587 24.2143 15.2587 24.2143 15.2724 24.2143C15.2999 24.2143 15.3137 24.2143 15.3411 24.2143C15.3549 24.2143 15.3549 24.2143 15.3549 24.228H15.3686H15.3824C15.4099 24.228 15.4374 24.228 15.4511 24.228C15.4511 24.2417 15.4374 24.2418 15.4374 24.2418C15.4374 24.2555 15.4374 24.2555 15.4374 24.2692C15.4511 24.283 15.4648 24.2967 15.4923 24.3105C15.5336 24.3242 15.5748 24.2967 15.6298 24.2967C15.671 24.2967 15.6985 24.3242 15.7397 24.3105C15.726 24.3242 15.7122 24.3654 15.726 24.3792C15.7397 24.3929 15.7397 24.3929 15.7535 24.3929C15.7947 24.3929 15.8222 24.3929 15.8634 24.3929C15.8909 24.3929 15.9322 24.3792 15.9596 24.3929C15.9734 24.3929 15.9734 24.4067 15.9734 24.4204L15.9871 24.4342L16.0009 24.4479C16.0146 24.4617 16.0559 24.4617 16.0696 24.4754C16.0696 24.4754 16.0696 24.4754 16.0696 24.4892C16.0696 24.5304 16.0696 24.5716 16.0971 24.5991C16.1108 24.6128 16.1246 24.6128 16.1246 24.6266C16.1521 24.6403 16.1658 24.6541 16.1933 24.6678C16.207 24.6816 16.2208 24.6816 16.2483 24.6953C16.262 24.7091 16.2758 24.7228 16.2895 24.7365C16.2758 24.7365 16.2758 24.7228 16.2758 24.7091C16.2758 24.6816 16.2895 24.6678 16.2895 24.6541C16.317 24.5166 16.2483 24.4204 16.1796 24.3654C16.1658 24.3517 16.1658 24.3517 16.1521 24.338C16.1795 24.338 16.207 24.3105 16.2345 24.2967C16.2483 24.338 16.2483 24.3929 16.262 24.4479C16.262 24.4617 16.262 24.4892 16.2758 24.4892C16.2895 24.4892 16.317 24.4891 16.317 24.4754C16.3307 24.4617 16.317 24.4204 16.3032 24.4067C16.2895 24.3655 16.2895 24.338 16.2758 24.3105C16.2758 24.2967 16.262 24.2692 16.262 24.2555C16.262 24.2418 16.317 24.2418 16.3445 24.2418C16.3582 24.2418 16.3857 24.2418 16.3995 24.2418C16.4269 24.2418 16.4407 24.228 16.4682 24.228C16.4819 24.2417 16.4819 24.2555 16.4957 24.2555C16.5369 24.2692 16.5781 24.2692 16.6194 24.2555C16.6331 24.2555 16.6606 24.2418 16.6743 24.2418C16.7018 24.228 16.7293 24.228 16.7431 24.228C16.7568 24.228 16.798 24.2143 16.798 24.2005C16.798 24.1868 16.7843 24.1868 16.7843 24.1868C16.798 24.1868 16.8118 24.173 16.8393 24.173C16.8668 24.173 16.8943 24.1868 16.908 24.1868C16.9217 24.1868 16.9355 24.1868 16.9492 24.1868C16.9767 24.1868 17.0042 24.2005 17.0317 24.2005C17.0454 24.2005 17.0592 24.1868 17.0729 24.1868C17.0867 24.1868 17.1142 24.1868 17.1279 24.2005C17.1554 24.2005 17.1829 24.2005 17.2104 24.2005C17.2516 24.2005 17.2791 24.1868 17.3203 24.173C17.3203 24.173 17.3341 24.1593 17.3478 24.1593C17.3616 24.1593 17.3753 24.1593 17.389 24.173C17.4028 24.173 17.4165 24.173 17.4303 24.173C17.444 24.173 17.4715 24.173 17.4715 24.1593C17.4715 24.1455 17.4578 24.1318 17.4578 24.1318C17.4165 24.1043 17.3478 24.1043 17.3066 24.1181C17.2928 24.1181 17.2791 24.1318 17.2653 24.1181C17.2653 24.1043 17.2791 24.1043 17.2928 24.1043C17.3066 24.1043 17.3066 24.0906 17.3066 24.0906C17.3478 24.1043 17.389 24.1043 17.4303 24.0906C17.444 24.1043 17.4853 24.1043 17.5127 24.1181V24.1318C17.5265 24.1455 17.5677 24.1455 17.5952 24.1455C17.6777 24.1455 17.7601 24.1593 17.8426 24.173C17.8701 24.2005 17.9388 24.1868 17.98 24.2143C17.9663 24.2143 17.9663 24.228 17.9526 24.228C17.8976 24.2143 17.8289 24.2143 17.7739 24.2418C17.7601 24.2418 17.7464 24.2692 17.7601 24.283C17.7739 24.2967 17.8151 24.3105 17.8563 24.3105C17.8976 24.3105 17.9251 24.3242 17.9663 24.3105C17.9801 24.3105 18.0075 24.2967 18.0075 24.2967C18.0213 24.2967 18.0213 24.283 18.0213 24.2692C18.0488 24.2692 18.145 24.2692 18.1587 24.2418C18.1587 24.228 18.145 24.228 18.145 24.228C18.1587 24.228 18.1587 24.2143 18.1862 24.2005C18.2 24.2005 18.2 24.2005 18.2137 24.2005C18.2274 24.2005 18.2412 24.2005 18.2412 24.1868C18.2549 24.173 18.2549 24.173 18.2687 24.1593C18.2962 24.1593 18.3099 24.1593 18.3237 24.1593C18.3374 24.1593 18.3649 24.1318 18.3786 24.1181C18.4061 24.1181 18.4199 24.1181 18.4474 24.1318C18.4748 24.1318 18.4886 24.1455 18.5161 24.1455C18.5436 24.1455 18.5711 24.1455 18.5848 24.1318C18.5985 24.1318 18.6123 24.1181 18.626 24.1181C18.6535 24.1043 18.681 24.1181 18.6948 24.0906V24.0768C18.736 24.0631 18.7497 24.0356 18.7497 23.9669C18.736 23.8569 18.6948 23.8294 18.6398 23.8157ZM15.2449 20.6957C15.2174 20.6957 15.19 20.6957 15.1762 20.6957C15.1625 20.6957 15.1487 20.682 15.135 20.6682C15.1075 20.627 15.1212 20.5445 15.1212 20.4758C15.135 20.5033 15.1212 20.5445 15.135 20.5858C15.135 20.6133 15.135 20.627 15.1487 20.6545C15.1625 20.6682 15.19 20.6957 15.2037 20.6957C15.2175 20.682 15.2312 20.682 15.2449 20.6957C15.2449 20.682 15.2587 20.682 15.2587 20.682C15.2587 20.6957 15.2449 20.6957 15.2449 20.6957ZM15.2724 20.5583C15.2587 20.5308 15.2312 20.4896 15.2175 20.4621C15.2312 20.4346 15.2312 20.3934 15.2312 20.3521V20.3659C15.2449 20.3934 15.2587 20.4346 15.2312 20.4346C15.2449 20.4758 15.2587 20.5171 15.2724 20.572C15.2724 20.572 15.2724 20.5583 15.2724 20.5583ZM15.2724 20.627C15.2724 20.6133 15.2862 20.6133 15.2999 20.6133C15.2999 20.6133 15.2862 20.6133 15.2724 20.627C15.2862 20.6408 15.2862 20.682 15.3137 20.6957C15.2999 20.6957 15.2999 20.6957 15.2999 20.7095C15.2862 20.682 15.2724 20.6408 15.2724 20.627ZM15.3274 20.8194C15.3137 20.7782 15.3137 20.737 15.3137 20.7095C15.3137 20.7232 15.3274 20.7507 15.3274 20.7782C15.3274 20.8057 15.3411 20.8332 15.3411 20.8469C15.3274 20.8469 15.3274 20.8332 15.3274 20.8194ZM15.3549 20.6133C15.3686 20.5995 15.3824 20.5995 15.3961 20.5858C15.3961 20.6133 15.3824 20.6133 15.3549 20.6133C15.3549 20.627 15.3549 20.627 15.3549 20.6133ZM18.145 23.5408C18.145 23.5545 18.1312 23.5545 18.1312 23.5683C18.1175 23.5958 18.1037 23.6095 18.09 23.637C18.0625 23.6782 18.0075 23.692 17.9663 23.7332C17.9526 23.747 17.9388 23.7607 17.9251 23.7744C17.9113 23.7882 17.8976 23.8019 17.8838 23.8019C17.8838 23.8019 17.8701 23.8019 17.8563 23.8019C17.8563 23.7882 17.8701 23.7882 17.8701 23.7882C17.8701 23.7744 17.8838 23.7744 17.8976 23.7744V23.7607C17.9113 23.7332 17.9388 23.7195 17.9526 23.692C17.9526 23.6782 17.9663 23.6645 17.9663 23.6507C17.9663 23.6507 17.9663 23.637 17.9663 23.6233C17.9801 23.6095 17.9938 23.6095 18.0075 23.5958C18.0075 23.582 18.0213 23.5683 18.035 23.5683C18.035 23.5545 18.0488 23.5271 18.0488 23.5271C18.0625 23.4721 18.035 23.4308 18.0488 23.3759C18.035 23.4034 18.035 23.4446 18.035 23.4858C18.035 23.527 18.0075 23.5683 17.98 23.582C17.98 23.5683 17.98 23.5545 17.98 23.5408C17.98 23.527 17.9938 23.5133 18.0075 23.4996C18.0213 23.4721 18.0075 23.4308 18.0213 23.4033C18.0213 23.3896 18.035 23.3759 18.035 23.3621C18.035 23.3484 18.035 23.3346 18.035 23.3209C18.035 23.3071 18.0213 23.2934 18.0213 23.2934C18.0213 23.2797 18.035 23.2659 18.035 23.2522C18.035 23.2384 18.0213 23.2247 18.0213 23.2109C18.0213 23.1972 18.0213 23.1697 18.035 23.156H18.0488L18.0625 23.1422C18.0763 23.156 18.09 23.2109 18.09 23.2247C18.09 23.2522 18.09 23.2934 18.09 23.3209C18.09 23.3484 18.09 23.3759 18.09 23.3896C18.09 23.4308 18.1175 23.4721 18.1175 23.5133C18.145 23.4858 18.1587 23.5133 18.145 23.5408ZM17.7327 23.4446C17.7327 23.4446 17.7327 23.4308 17.7327 23.4171C17.7327 23.4034 17.7189 23.3896 17.7189 23.3759C17.7189 23.3621 17.7327 23.3484 17.7327 23.3209C17.7327 23.3071 17.7189 23.2934 17.7189 23.2659C17.7189 23.2522 17.7189 23.2384 17.7189 23.2247L17.7052 23.1697C17.6914 23.1697 17.6914 23.1972 17.6914 23.2109V23.2384C17.6914 23.2522 17.7052 23.2659 17.7052 23.2797C17.7189 23.3071 17.6914 23.3346 17.6914 23.3621C17.6914 23.3759 17.7052 23.3896 17.7052 23.4033C17.7052 23.4171 17.6914 23.4446 17.6914 23.4583C17.6914 23.4721 17.7052 23.4858 17.7189 23.5133C17.7327 23.582 17.6914 23.6233 17.6777 23.6645C17.6639 23.6782 17.6502 23.6782 17.6364 23.692C17.6227 23.7057 17.6227 23.747 17.5815 23.7332C17.5815 23.7195 17.609 23.7195 17.609 23.7057C17.6227 23.692 17.6502 23.6782 17.6639 23.6507C17.6777 23.6095 17.6639 23.5683 17.6639 23.5133C17.6639 23.4858 17.6777 23.4721 17.6777 23.4583C17.6777 23.4446 17.6914 23.4171 17.6914 23.3896C17.6914 23.3484 17.6777 23.3071 17.6777 23.2797C17.6777 23.2659 17.6914 23.2522 17.7052 23.2384C17.7052 23.2247 17.7052 23.2247 17.6914 23.2109C17.6777 23.2109 17.6502 23.2109 17.6364 23.2109C17.6364 23.2247 17.6364 23.2247 17.6364 23.2384C17.6364 23.2522 17.6502 23.2522 17.6502 23.2659C17.6502 23.2797 17.6639 23.2934 17.6639 23.3209C17.6639 23.3346 17.6777 23.3484 17.6777 23.3759C17.6777 23.4171 17.6502 23.4721 17.6502 23.5133C17.6364 23.5133 17.6364 23.4996 17.6364 23.4858C17.6364 23.4721 17.6364 23.4721 17.6364 23.4583C17.6364 23.4446 17.6502 23.4308 17.6502 23.4171C17.6502 23.4034 17.6502 23.3896 17.6502 23.3759C17.6502 23.3621 17.6639 23.3484 17.6639 23.3346C17.6639 23.3209 17.6502 23.3209 17.6502 23.3071C17.6502 23.2797 17.6364 23.2522 17.6364 23.2247C17.6364 23.2247 17.6364 23.2247 17.6364 23.2109C17.6227 23.1972 17.5952 23.2109 17.5815 23.1972C17.5677 23.1834 17.5677 23.156 17.554 23.1285C17.5677 23.1147 17.5815 23.1285 17.5952 23.1147C17.609 23.1147 17.6227 23.101 17.6364 23.101C17.6502 23.101 17.6639 23.101 17.6777 23.101C17.6914 23.101 17.6914 23.0872 17.7052 23.0872C17.7189 23.0872 17.7327 23.101 17.7464 23.101H17.7601C17.7739 23.101 17.7876 23.1147 17.8014 23.1285C17.8426 23.1147 17.8564 23.0872 17.8701 23.046C17.8701 23.0872 17.8426 23.1147 17.8426 23.1697C17.8426 23.2109 17.8838 23.2384 17.8838 23.2797C17.8838 23.2934 17.8838 23.3071 17.8838 23.3209C17.8976 23.3896 17.8563 23.4171 17.8426 23.4583C17.8289 23.4446 17.8151 23.4308 17.8151 23.4171C17.8151 23.3896 17.8426 23.3621 17.8426 23.3484C17.8426 23.3071 17.8289 23.2659 17.8151 23.2384C17.8151 23.2247 17.8014 23.2109 17.8014 23.1972L17.7876 23.1834C17.7876 23.1697 17.7876 23.156 17.7739 23.156C17.7601 23.156 17.7601 23.1697 17.7601 23.1834C17.7601 23.2109 17.7876 23.2384 17.8014 23.2659C17.8014 23.2797 17.8014 23.2934 17.8151 23.3071C17.8151 23.3209 17.8289 23.3346 17.8289 23.3621C17.8289 23.3896 17.8014 23.4034 17.7876 23.4308C17.7876 23.4446 17.7876 23.4721 17.8014 23.4858C17.8014 23.4996 17.8151 23.4996 17.8289 23.5133C17.8289 23.5271 17.8426 23.5408 17.8426 23.5683C17.8426 23.582 17.8563 23.6095 17.8563 23.6233C17.8563 23.637 17.8563 23.6645 17.8563 23.6782C17.8563 23.692 17.8426 23.7057 17.8289 23.7332C17.8151 23.747 17.8151 23.7607 17.7876 23.7607C17.7739 23.7744 17.7601 23.7744 17.7327 23.7744C17.7189 23.7744 17.7189 23.7744 17.7052 23.7882C17.6914 23.7882 17.6777 23.7744 17.6639 23.7744C17.6639 23.7195 17.7052 23.7195 17.7327 23.692C17.7601 23.6645 17.7739 23.6233 17.7739 23.5683C17.7464 23.4996 17.7327 23.4721 17.7327 23.4446ZM17.389 23.5408C17.389 23.5408 17.389 23.5545 17.389 23.5683C17.3753 23.5683 17.3753 23.5545 17.3753 23.5408C17.3616 23.5133 17.3616 23.4858 17.3616 23.4446C17.3753 23.4034 17.389 23.3621 17.3753 23.3209C17.3753 23.3071 17.3478 23.2797 17.3478 23.2659C17.3341 23.2384 17.3203 23.2109 17.3203 23.1697C17.3203 23.1422 17.3341 23.101 17.3341 23.0597C17.3341 23.0185 17.3341 22.9773 17.3478 22.9498C17.3478 22.936 17.3616 22.9086 17.3753 22.8948C17.389 22.8948 17.389 22.9086 17.389 22.9223C17.4028 22.9498 17.4028 22.991 17.4028 23.0323C17.4028 23.0597 17.389 23.0735 17.3753 23.101C17.3616 23.1422 17.3616 23.1834 17.3616 23.2247C17.3616 23.2384 17.3753 23.2522 17.3753 23.2797C17.389 23.3209 17.4165 23.3484 17.4165 23.3896C17.4165 23.4034 17.4165 23.4308 17.4165 23.4446C17.4165 23.4858 17.389 23.4996 17.4028 23.5408C17.4028 23.5545 17.4165 23.582 17.4303 23.5958C17.444 23.637 17.4578 23.7057 17.4303 23.747C17.4165 23.747 17.4028 23.7195 17.389 23.7057C17.4303 23.637 17.4165 23.5683 17.389 23.5408ZM17.1142 23.0597C17.1416 23.1147 17.1279 23.2109 17.1691 23.2659C17.1966 23.3071 17.2241 23.3209 17.2791 23.3346C17.2928 23.3484 17.2791 23.3759 17.2928 23.3896C17.2928 23.4034 17.3066 23.4171 17.3066 23.4308C17.3066 23.4446 17.3066 23.4583 17.3066 23.4858C17.2928 23.4721 17.2928 23.4583 17.2928 23.4446C17.2928 23.4308 17.2791 23.4171 17.2653 23.4033C17.2379 23.3759 17.1966 23.3621 17.1691 23.3346C17.1416 23.3071 17.1142 23.2522 17.1142 23.1972C17.0867 23.1422 17.1142 23.101 17.1142 23.0597ZM17.0729 23.1285C17.0592 23.1285 17.0729 23.1147 17.0729 23.1147C17.0729 23.101 17.0867 23.0735 17.0867 23.046C17.0867 23.0323 17.0867 23.0185 17.1004 23.0048C17.0867 23.0323 17.0867 23.0597 17.0867 23.0872C17.0867 23.101 17.0867 23.1147 17.0729 23.1285ZM16.9767 21.5754C16.9767 21.5754 16.9767 21.5616 16.963 21.5616C16.9767 21.5479 16.9905 21.5204 17.0179 21.5204C17.0179 21.5754 17.0317 21.5891 17.0317 21.5891C17.0317 21.6029 17.0317 21.6166 17.0454 21.6441C17.0454 21.6716 17.0592 21.7128 17.0592 21.7403C17.0729 21.7678 17.0867 21.8502 17.1004 21.8915C17.1416 21.9877 17.1829 22.0839 17.2241 22.1664C17.2241 22.1801 17.2104 22.1939 17.2104 22.2076C17.2104 22.2213 17.2241 22.2213 17.2241 22.2213C17.2241 22.2351 17.2104 22.2351 17.2104 22.2488C17.2104 22.2763 17.2516 22.2901 17.2791 22.2901C17.2928 22.3038 17.2928 22.3176 17.2928 22.3313C17.2928 22.345 17.3066 22.3588 17.3066 22.3725C17.3066 22.3863 17.2928 22.3863 17.2791 22.4C17.2653 22.4138 17.2516 22.4275 17.2379 22.455C17.2104 22.4962 17.1691 22.5512 17.1554 22.6062C17.1554 22.6199 17.1417 22.6337 17.1417 22.6337C17.1417 22.2763 17.1142 21.919 16.9767 21.6991C16.9767 21.6853 16.9767 21.6853 16.9767 21.6716V21.6303C16.9905 21.6029 16.9905 21.5754 16.9767 21.5754ZM17.0729 21.4929C17.0729 21.4792 17.0867 21.4792 17.1004 21.4792C17.1279 21.4654 17.1691 21.4654 17.2104 21.4517V21.4654C17.1829 21.4792 17.1691 21.4792 17.1417 21.4792C17.1142 21.4929 17.1004 21.4929 17.0729 21.4929ZM17.6639 22.4413C17.6777 22.4413 17.6914 22.4138 17.7189 22.4138C17.7327 22.4275 17.7052 22.4413 17.6914 22.455C17.6777 22.4687 17.6639 22.4687 17.6364 22.4687C17.6227 22.4687 17.5952 22.455 17.5815 22.455C17.5402 22.4413 17.4853 22.455 17.444 22.4687C17.4028 22.4825 17.389 22.51 17.3616 22.5237C17.3753 22.455 17.4165 22.4275 17.4853 22.4138C17.499 22.4138 17.5265 22.4138 17.554 22.4138C17.5815 22.4275 17.6364 22.4413 17.6639 22.4413ZM17.6364 22.4138C17.6364 22.4 17.6502 22.4 17.6502 22.4C17.6914 22.4 17.6502 22.4275 17.6364 22.4138ZM17.9663 22.4962C17.9663 22.51 17.9526 22.51 17.9663 22.5237L17.98 22.5375C17.98 22.5375 17.9526 22.565 17.9388 22.565C17.9113 22.5787 17.8701 22.565 17.8563 22.5512C17.9113 22.5375 17.9388 22.5237 17.9663 22.4962ZM17.98 22.4962C18.0075 22.4687 18.035 22.4825 18.035 22.4962C18.0488 22.5512 18.0075 22.6062 17.9663 22.6199C17.9526 22.6199 17.9251 22.6199 17.9251 22.6062H17.9388C17.9663 22.6062 17.9938 22.5787 18.0213 22.565C18.0213 22.5237 18.0075 22.4962 17.98 22.4962ZM18.0763 23.0185C18.0763 23.0323 18.0763 23.0597 18.0625 23.0735C18.0488 23.101 18.0213 23.101 18.0213 23.1285C18.0075 23.156 18.035 23.1972 18.035 23.2247C18.0213 23.2247 18.0213 23.2109 18.0213 23.2109C18.0213 23.1972 18.0075 23.1972 18.0075 23.1834C17.9938 23.1422 18.0213 23.0735 18.0075 23.0323C18.0075 23.0185 17.9938 23.0048 17.9938 23.0048C17.9938 22.9773 18.0075 22.9635 18.0075 22.936C18.0075 22.9223 17.9938 22.9086 17.98 22.8948C17.9663 22.8811 17.9663 22.8811 17.9663 22.8673C17.9663 22.8398 17.98 22.8261 17.9938 22.7986C18.0075 22.7574 17.9938 22.7161 17.98 22.6886C17.9938 22.7024 18.0213 22.7299 18.0213 22.7574C18.035 22.7849 18.0488 22.8123 18.0488 22.8398C18.0488 22.8811 18.035 22.9223 18.035 22.9635C18.0488 22.9635 18.0763 22.9773 18.0763 23.0185ZM17.9113 22.6199C17.9526 22.6337 17.9526 22.6749 17.9663 22.7161C17.9663 22.7436 17.9526 22.7849 17.9526 22.8123C17.9526 22.8398 17.9526 22.8673 17.9663 22.8811C17.9801 22.8948 17.9938 22.8948 17.9938 22.9223C17.9938 22.936 17.98 22.9498 17.98 22.9635C17.9663 22.9498 17.9663 22.936 17.9663 22.9086C17.9663 22.8948 17.9526 22.8673 17.9526 22.8536C17.9526 22.8398 17.9526 22.8261 17.9526 22.7986C17.9526 22.7436 17.9251 22.6749 17.9113 22.6199ZM17.8838 23.2109C17.8838 23.2247 17.8976 23.2247 17.8976 23.2384C17.9113 23.2522 17.9113 23.3209 17.8838 23.3209C17.8838 23.2522 17.8151 23.2109 17.8289 23.1285C17.8289 23.1147 17.8426 23.0872 17.8426 23.0735C17.8563 23.0323 17.8701 22.991 17.8563 22.9498V22.936C17.8563 22.936 17.8838 22.8948 17.8838 22.8811C17.8976 22.8811 17.8976 22.9086 17.8976 22.9086C17.9113 22.936 17.9251 22.9635 17.9251 23.0048C17.9251 23.0323 17.9113 23.0735 17.8976 23.101C17.8838 23.1285 17.8563 23.1422 17.8563 23.1834C17.8701 23.1972 17.8838 23.2109 17.8838 23.2109ZM17.9113 22.6886C17.9251 22.7574 17.9113 22.8123 17.8838 22.8673C17.8701 22.8948 17.8426 22.9223 17.8289 22.9498C17.8289 22.9635 17.8426 22.9773 17.8289 22.991C17.8014 22.991 17.7876 22.9773 17.7601 22.9635C17.7601 22.991 17.8014 23.0048 17.8151 23.0048C17.8151 23.0185 17.8014 23.0323 17.8014 23.0323C17.7876 23.0323 17.7601 23.0185 17.7601 23.0048C17.7601 23.0048 17.7601 22.991 17.7464 22.991C17.7464 23.0185 17.7739 23.0323 17.7876 23.046C17.7876 23.0597 17.7739 23.0735 17.7601 23.0735C17.7327 23.0735 17.7189 23.0323 17.7189 23.0048C17.7052 23.0048 17.7052 23.0323 17.7052 23.046C17.6639 23.0323 17.6502 22.991 17.6502 22.9498C17.6639 22.9086 17.7327 22.9223 17.7327 22.8811C17.7327 22.8673 17.7327 22.8536 17.7327 22.8398C17.7327 22.8261 17.7327 22.8261 17.7189 22.8123C17.7189 22.8261 17.7327 22.8398 17.7189 22.8536C17.7052 22.8536 17.7052 22.8536 17.7052 22.8536C17.6777 22.8536 17.6502 22.8673 17.6364 22.8673C17.6227 22.8673 17.609 22.8673 17.5952 22.8673C17.5815 22.8673 17.5815 22.8673 17.5677 22.8673C17.5677 22.8536 17.5815 22.8398 17.5677 22.8261C17.554 22.8398 17.554 22.8536 17.554 22.8673C17.554 22.8811 17.5677 22.8948 17.5815 22.9086C17.609 22.9223 17.6364 22.9223 17.6502 22.936C17.6502 22.9498 17.6502 22.9635 17.6502 22.9773C17.6502 23.0185 17.609 23.046 17.5815 23.046C17.5815 23.0323 17.5952 23.0048 17.5815 23.0048C17.5677 23.0048 17.5677 23.0323 17.554 23.046C17.5402 23.0597 17.5127 23.0872 17.499 23.046C17.5127 23.0323 17.5402 23.0185 17.554 22.991C17.5402 22.991 17.5265 22.991 17.5127 23.0048C17.499 23.0185 17.4853 23.0185 17.4853 22.991C17.5127 22.991 17.5402 22.9773 17.554 22.9498C17.5402 22.9498 17.5127 22.9635 17.4853 22.9635V22.9498C17.444 22.8948 17.4165 22.8261 17.4028 22.7436C17.4028 22.6886 17.4165 22.6337 17.4303 22.5924C17.444 22.5787 17.444 22.565 17.4578 22.5512C17.4715 22.5375 17.4715 22.5237 17.499 22.51C17.5265 22.4962 17.554 22.4962 17.5815 22.4962C17.609 22.4962 17.6364 22.51 17.6639 22.5237C17.7052 22.5375 17.7189 22.51 17.7464 22.51C17.7876 22.51 17.8151 22.5237 17.8426 22.5375C17.8563 22.5375 17.8564 22.5512 17.8701 22.565C17.8838 22.6062 17.8976 22.6474 17.9113 22.6886ZM17.3478 22.7849C17.3478 22.8123 17.3478 22.8398 17.3478 22.8673C17.3478 22.8948 17.3203 22.9086 17.3203 22.936V22.9498V22.9635C17.3203 22.991 17.3203 23.0048 17.3203 23.0323C17.2928 22.991 17.2928 22.936 17.3066 22.8948C17.3203 22.8673 17.3341 22.8398 17.3341 22.7986C17.3341 22.7436 17.3341 22.6749 17.3478 22.6199C17.3616 22.5924 17.3753 22.565 17.389 22.5375C17.4028 22.5375 17.4028 22.5237 17.4165 22.5237C17.4578 22.4962 17.5127 22.4687 17.5815 22.4825C17.5677 22.4825 17.5402 22.4825 17.5127 22.4825C17.4578 22.51 17.4028 22.5375 17.3753 22.5924C17.3753 22.6062 17.3616 22.6337 17.3616 22.6612C17.3341 22.7161 17.3478 22.7436 17.3478 22.7849ZM17.1966 22.8123C17.2241 22.7711 17.2516 22.7436 17.2653 22.6886C17.2653 22.6886 17.2653 22.6886 17.2791 22.6886C17.2791 22.7711 17.2104 22.8123 17.1966 22.8948C17.1829 22.8811 17.1829 22.8398 17.1966 22.8261C17.2104 22.8261 17.1966 22.8123 17.1966 22.8123ZM17.2791 22.5924C17.2928 22.5924 17.2928 22.5787 17.3203 22.5787C17.3066 22.6062 17.3066 22.6474 17.3066 22.6886C17.3066 22.6886 17.2928 22.6886 17.2928 22.6749C17.2653 22.6474 17.2653 22.6062 17.2791 22.5924ZM17.2516 22.8536C17.2516 22.8398 17.2653 22.8261 17.2791 22.7986C17.2928 22.7711 17.3066 22.7299 17.3066 22.6886C17.3341 22.7849 17.2791 22.8673 17.2791 22.9498C17.2791 22.9773 17.2928 23.0048 17.2928 23.0323C17.3066 23.046 17.3066 23.0735 17.3066 23.101C17.2928 23.0872 17.2791 23.0597 17.2653 23.046C17.2653 23.0323 17.2516 23.0185 17.2516 23.0185C17.2241 22.9635 17.2241 22.8948 17.2516 22.8536ZM17.389 22.5924C17.4028 22.5787 17.4028 22.5787 17.389 22.5924C17.3753 22.6062 17.3753 22.6474 17.3616 22.6886C17.3616 22.6886 17.3616 22.6749 17.3616 22.6612C17.3616 22.6474 17.3753 22.6062 17.389 22.5924ZM17.3478 22.4275C17.3478 22.4413 17.3341 22.455 17.3341 22.4687C17.3203 22.4825 17.3203 22.4962 17.3066 22.51C17.2653 22.51 17.2516 22.5375 17.2379 22.565C17.2379 22.5787 17.2379 22.5924 17.2379 22.6199C17.2379 22.6337 17.2379 22.6337 17.2379 22.6474C17.2379 22.6612 17.2241 22.7024 17.2241 22.7161C17.2104 22.7436 17.1966 22.7574 17.1829 22.7849C17.1829 22.7849 17.1691 22.7986 17.1691 22.8123C17.1554 22.8398 17.1691 22.8948 17.1829 22.9086C17.1829 22.9223 17.1966 22.9223 17.1966 22.936C17.1966 22.9498 17.1966 22.9498 17.1966 22.9635C17.1966 22.9773 17.1966 22.991 17.1966 22.991C17.1966 23.0185 17.1829 23.046 17.1829 23.0597C17.1829 23.0735 17.1829 23.0872 17.1829 23.101C17.1829 23.156 17.2104 23.2109 17.2241 23.2384C17.2241 23.2522 17.2379 23.2522 17.2379 23.2659C17.2104 23.2522 17.1829 23.2384 17.1691 23.2109C17.1554 23.1834 17.1554 23.1422 17.1554 23.101C17.1554 23.0597 17.1279 23.0323 17.1279 22.991C17.1279 22.9635 17.1279 22.9498 17.1142 22.9223C17.1142 22.8948 17.1142 22.8811 17.1142 22.8536C17.1279 22.7986 17.1279 22.7299 17.1554 22.6749C17.1691 22.6337 17.1829 22.6062 17.1966 22.565C17.2379 22.51 17.2653 22.455 17.3203 22.4138C17.3478 22.4275 17.3478 22.4275 17.3478 22.4275C17.3616 22.4275 17.3616 22.4275 17.3478 22.4275ZM17.3066 23.4583C17.3066 23.4446 17.3066 23.4171 17.3066 23.4033C17.3066 23.4033 17.2928 23.3896 17.3066 23.3759C17.3066 23.3621 17.3203 23.3621 17.3203 23.3621C17.3341 23.3209 17.2928 23.2797 17.2791 23.2522C17.2379 23.1972 17.2241 23.156 17.2379 23.0597C17.2653 23.0872 17.2791 23.1147 17.2928 23.1285C17.2928 23.1697 17.2928 23.2247 17.3066 23.2522C17.3066 23.2659 17.3203 23.2797 17.3341 23.2934C17.3478 23.3071 17.3616 23.3209 17.3616 23.3346C17.3616 23.3621 17.3478 23.3759 17.3478 23.4033C17.3341 23.4583 17.3341 23.527 17.3616 23.5545C17.3753 23.5683 17.4028 23.582 17.4028 23.5958C17.4028 23.6095 17.3753 23.6233 17.3753 23.637C17.3478 23.6233 17.3341 23.5958 17.3203 23.5683C17.3203 23.5545 17.3066 23.5271 17.3066 23.5133C17.2928 23.4996 17.3066 23.4858 17.3066 23.4583ZM17.444 23.5133C17.4303 23.4721 17.4578 23.4308 17.4578 23.3759C17.4578 23.3484 17.444 23.3209 17.4303 23.2934C17.4165 23.2522 17.389 23.2247 17.389 23.1834C17.389 23.1285 17.4165 23.101 17.4303 23.046C17.4303 23.0323 17.444 23.0048 17.444 22.9773C17.4578 22.9773 17.444 22.991 17.4578 22.991C17.4578 23.0048 17.4715 23.0185 17.4715 23.0323C17.4715 23.0323 17.4715 23.046 17.4853 23.046C17.4853 23.0597 17.4715 23.0872 17.4715 23.101C17.4715 23.1285 17.4853 23.1422 17.4853 23.1697C17.4853 23.1834 17.4853 23.1972 17.4715 23.2109C17.4715 23.2384 17.4578 23.2659 17.4715 23.3071C17.4715 23.3209 17.4853 23.3484 17.4853 23.3621C17.499 23.3896 17.5127 23.4171 17.499 23.4583C17.499 23.4858 17.4853 23.527 17.4853 23.5545C17.4578 23.5408 17.444 23.5271 17.444 23.5133ZM17.4715 23.637C17.4853 23.6233 17.4715 23.6233 17.4715 23.637C17.499 23.6645 17.5127 23.692 17.499 23.7195C17.4853 23.7195 17.4715 23.7195 17.4578 23.7195C17.4715 23.692 17.4853 23.6507 17.4715 23.637ZM17.499 23.5683C17.499 23.5408 17.5127 23.5133 17.5127 23.4858C17.5127 23.4721 17.5127 23.4446 17.5127 23.4308C17.5127 23.3759 17.4578 23.3209 17.4715 23.2522C17.4853 23.2522 17.4715 23.2659 17.4853 23.2659C17.499 23.2659 17.499 23.2659 17.499 23.2522C17.5127 23.1972 17.4578 23.156 17.4853 23.0872C17.499 23.101 17.499 23.1147 17.5127 23.1147C17.5127 23.1285 17.5265 23.156 17.5265 23.1697C17.5265 23.1834 17.5127 23.1972 17.5127 23.2109C17.5127 23.2522 17.5402 23.2659 17.554 23.2934C17.554 23.3484 17.554 23.4034 17.5677 23.4446C17.5815 23.4721 17.5952 23.4858 17.609 23.4996C17.609 23.4996 17.6227 23.5133 17.6227 23.5271C17.6364 23.582 17.6364 23.637 17.5952 23.6645C17.5815 23.6782 17.5677 23.6782 17.554 23.692C17.5402 23.7057 17.5402 23.7195 17.5402 23.7195C17.5402 23.7057 17.5402 23.692 17.5402 23.6782C17.5402 23.6645 17.5265 23.6645 17.5265 23.6507C17.5127 23.6233 17.499 23.5958 17.499 23.5683ZM17.609 23.3896C17.609 23.4034 17.5952 23.4171 17.5952 23.4308C17.5677 23.4034 17.5952 23.3621 17.5952 23.3209C17.5952 23.2797 17.554 23.2522 17.5677 23.2109C17.5815 23.2247 17.5815 23.2247 17.5815 23.2522C17.5815 23.2522 17.5815 23.2659 17.5952 23.2659V23.2797C17.5952 23.2934 17.609 23.2934 17.609 23.3071C17.609 23.3209 17.5952 23.3346 17.5952 23.3621C17.609 23.3759 17.609 23.3896 17.609 23.3896ZM17.8289 23.692C17.8426 23.6645 17.8563 23.6233 17.8563 23.582C17.8563 23.5408 17.8426 23.5133 17.8426 23.4721C17.8563 23.4308 17.8701 23.4034 17.8976 23.3621C17.9113 23.3346 17.9251 23.3071 17.9251 23.2797C17.9251 23.2659 17.9251 23.2384 17.9251 23.2247C17.9251 23.2109 17.9113 23.1834 17.8976 23.1697C17.8976 23.156 17.9113 23.1422 17.9113 23.1285C17.9251 23.1147 17.9251 23.1147 17.9388 23.101C17.9388 23.101 17.9388 23.0872 17.9526 23.0872C17.9526 23.0735 17.9663 23.0597 17.9663 23.0323C17.9663 23.0735 17.9526 23.1285 17.9663 23.156C17.9663 23.156 17.9663 23.1697 17.98 23.1697C17.98 23.1697 17.98 23.1834 17.9938 23.1834C18.0075 23.2109 18.0213 23.2247 18.035 23.2384C18.035 23.2522 18.035 23.2797 18.035 23.2797C18.035 23.2934 18.0213 23.2934 18.0213 23.3209C18.0213 23.3484 18.035 23.3621 18.0213 23.3896C18.0213 23.4034 18.0075 23.4171 17.9938 23.4308C17.98 23.4583 17.9938 23.4858 17.9938 23.4996C17.9938 23.5133 17.9938 23.527 17.98 23.5408C17.98 23.582 17.9663 23.6095 17.9526 23.637C17.9388 23.637 17.9388 23.6507 17.9251 23.6507C17.9251 23.6507 17.9113 23.6645 17.8976 23.6645C17.8838 23.6507 17.8976 23.637 17.8976 23.637C17.9113 23.5958 17.9663 23.5408 17.9251 23.4858C17.9251 23.5133 17.9251 23.5408 17.9113 23.5683C17.9113 23.582 17.8838 23.582 17.8838 23.5958C17.8838 23.5958 17.8838 23.6095 17.8701 23.6095C17.8564 23.637 17.8701 23.6645 17.8563 23.692C17.8426 23.7195 17.7876 23.747 17.7464 23.7195C17.7876 23.747 17.8151 23.7195 17.8289 23.692ZM18.0075 22.4413C18.035 22.4413 18.0488 22.455 18.0625 22.4687C18.1037 22.5237 18.1037 22.6199 18.1312 22.6886C18.1312 22.7024 18.145 22.7161 18.145 22.7299C18.1587 22.7849 18.1587 22.8398 18.1587 22.8948C18.1587 22.9498 18.1587 23.0185 18.1587 23.0735C18.1587 23.1697 18.1862 23.2659 18.1725 23.3621C18.1725 23.3759 18.1725 23.3896 18.1725 23.4033C18.1587 23.4033 18.1587 23.3896 18.1587 23.3896C18.145 23.3621 18.145 23.3484 18.145 23.3209C18.145 23.3071 18.145 23.2797 18.145 23.2659C18.145 23.2109 18.145 23.156 18.1175 23.101C18.1175 23.0872 18.1037 23.0735 18.1037 23.0735C18.1037 23.0597 18.1175 23.0597 18.1175 23.046C18.1312 22.9773 18.0763 22.936 18.09 22.8673C18.09 22.8398 18.09 22.8123 18.09 22.7986C18.09 22.7299 18.0625 22.6749 18.035 22.6337C18.0488 22.6199 18.0763 22.6062 18.0763 22.5787C18.0763 22.5512 18.0763 22.5237 18.0763 22.4962C18.0763 22.4825 18.0625 22.455 18.0488 22.455C18.0213 22.4413 17.9801 22.455 17.9663 22.4687L17.9526 22.4825C17.9388 22.4825 17.9388 22.4962 17.9251 22.4962C17.9388 22.4687 17.9663 22.4413 18.0075 22.4413ZM17.8426 22.3176C17.8701 22.3176 17.8701 22.345 17.8976 22.345C17.9113 22.345 17.9388 22.345 17.9526 22.345C17.9663 22.345 17.98 22.3588 17.98 22.3725L17.9938 22.3863C17.9938 22.4 17.98 22.3863 17.98 22.4C17.9663 22.4138 17.9388 22.4275 17.9251 22.4413C17.9113 22.455 17.8838 22.4687 17.8563 22.4687C17.8426 22.4687 17.8289 22.4687 17.8151 22.4687C17.8014 22.4687 17.7876 22.4825 17.7739 22.4687C17.7876 22.455 17.8014 22.455 17.8151 22.455C17.8426 22.4413 17.8838 22.4275 17.8838 22.3725C17.8701 22.3725 17.8426 22.345 17.8426 22.3176ZM17.7189 22.2901C17.7327 22.2901 17.7464 22.2901 17.7601 22.3038C17.7739 22.3038 17.7876 22.3176 17.8014 22.3176C17.8151 22.3176 17.8426 22.3588 17.8426 22.3725C17.8426 22.3863 17.8426 22.4138 17.8289 22.4275C17.8151 22.4413 17.7876 22.455 17.7739 22.455C17.7601 22.455 17.7601 22.455 17.7464 22.4687C17.7327 22.4687 17.7327 22.4825 17.7189 22.4825C17.7189 22.4687 17.7327 22.4687 17.7327 22.455C17.7327 22.455 17.7464 22.4413 17.7464 22.4275C17.7739 22.4275 17.8289 22.4138 17.8289 22.3863C17.8289 22.3725 17.8151 22.3725 17.8151 22.3588C17.8151 22.3588 17.8151 22.345 17.8014 22.345C17.7876 22.3313 17.7739 22.3313 17.7601 22.3176C17.7601 22.3176 17.7464 22.3038 17.7327 22.3038C17.7327 22.3038 17.7189 22.3038 17.7189 22.2901ZM17.444 22.2213C17.5127 22.2351 17.5677 22.2626 17.6227 22.2901C17.6639 22.3038 17.6914 22.3176 17.7327 22.3313L17.7464 22.345C17.7601 22.345 17.7739 22.3588 17.7739 22.3588C17.7739 22.3588 17.7876 22.3588 17.7876 22.3725C17.7739 22.3725 17.7739 22.3725 17.7601 22.3588C17.7052 22.3313 17.6502 22.3038 17.5815 22.2901C17.5952 22.3038 17.609 22.3038 17.609 22.3038C17.6777 22.3176 17.7327 22.3588 17.7876 22.4C17.8014 22.4 17.8151 22.4138 17.8151 22.4275C17.8014 22.4275 17.7876 22.4275 17.7876 22.4138C17.7327 22.3725 17.6639 22.3313 17.5815 22.3176C17.5815 22.3313 17.5952 22.3313 17.609 22.3313C17.6502 22.345 17.6914 22.3588 17.7189 22.3863C17.7327 22.3863 17.7464 22.4 17.7464 22.4138C17.7601 22.4138 17.7739 22.4275 17.7739 22.4413C17.7601 22.455 17.7327 22.4413 17.7052 22.4275C17.6914 22.4138 17.6777 22.4138 17.6639 22.4C17.6364 22.3863 17.5952 22.3725 17.554 22.3725C17.5265 22.3725 17.5127 22.3725 17.4853 22.3588C17.4715 22.3588 17.4578 22.345 17.4303 22.345C17.4165 22.3588 17.444 22.3588 17.4578 22.3725H17.4715C17.499 22.3725 17.5265 22.3725 17.554 22.3863C17.5677 22.3863 17.609 22.4 17.609 22.4138C17.609 22.4275 17.5402 22.4138 17.5127 22.4138C17.4715 22.4138 17.444 22.4138 17.4028 22.4138C17.3753 22.4138 17.3341 22.4 17.3203 22.3863C17.3203 22.3725 17.3066 22.3725 17.3066 22.3588C17.3066 22.345 17.3066 22.345 17.3066 22.3176C17.3066 22.3038 17.2928 22.3038 17.2928 22.2901C17.2928 22.2763 17.2928 22.2901 17.3066 22.2901H17.3203C17.3203 22.2901 17.3341 22.2901 17.3478 22.2901C17.3616 22.2901 17.3616 22.2763 17.3753 22.2763C17.4165 22.2351 17.4303 22.2213 17.444 22.2213ZM17.4028 22.1664C17.4165 22.1664 17.4303 22.1801 17.4303 22.1801C17.4303 22.1939 17.4165 22.1939 17.389 22.1939C17.3753 22.1939 17.3753 22.2076 17.3616 22.2076H17.3478C17.3341 22.2076 17.3341 22.2076 17.3203 22.2213H17.3066C17.2928 22.2213 17.2928 22.2213 17.2928 22.2351C17.2791 22.2351 17.2791 22.2351 17.2653 22.2488C17.2516 22.2488 17.2241 22.2351 17.2379 22.2213C17.2379 22.2076 17.2791 22.2076 17.2928 22.2076C17.3066 22.2076 17.3341 22.2076 17.3478 22.1939C17.3753 22.1801 17.389 22.1664 17.4028 22.1664ZM17.4028 22.1251C17.4165 22.1389 17.4028 22.1526 17.389 22.1664C17.3616 22.1801 17.3066 22.1939 17.2653 22.1939C17.2516 22.1939 17.2241 22.1939 17.2241 22.1664C17.2928 22.1801 17.3753 22.1664 17.4028 22.1251ZM17.2653 21.7403C17.3066 21.8365 17.3341 21.9465 17.3616 22.0564C17.3616 22.0702 17.3753 22.0976 17.3753 22.1114C17.3753 22.1251 17.3203 22.1389 17.3066 22.1389C17.2928 22.1389 17.2791 22.1389 17.2653 22.1389C17.2516 22.1389 17.2516 22.1114 17.2379 22.0976C17.1966 22.0289 17.1279 21.7953 17.1004 21.7128C17.0867 21.6853 17.0867 21.6578 17.0867 21.6303C17.0867 21.6166 17.0867 21.5891 17.0867 21.5341C17.1279 21.5204 17.1691 21.5066 17.2241 21.5066C17.2241 21.5341 17.2379 21.5341 17.2379 21.5754C17.2379 21.5891 17.2379 21.6028 17.2379 21.6166V21.6578C17.2379 21.6716 17.2379 21.6853 17.2379 21.6991C17.2516 21.6991 17.2653 21.7266 17.2653 21.7403ZM17.2516 21.3555C17.2653 21.3692 17.2241 21.3829 17.2104 21.3829C17.1554 21.3967 17.1004 21.4242 17.0454 21.4517C17.0317 21.4654 17.0317 21.4792 17.0042 21.4654C17.0042 21.4517 17.0179 21.4517 17.0179 21.4379C17.0317 21.4379 17.0317 21.4242 17.0454 21.4242C17.0867 21.4104 17.1142 21.3829 17.1691 21.3692C17.1966 21.3692 17.2241 21.3692 17.2516 21.3555ZM17.2379 21.3417C17.2241 21.3417 17.2104 21.3417 17.1966 21.3417C17.1966 21.328 17.1966 21.3142 17.1829 21.3005C17.1966 21.3005 17.2104 21.2867 17.2241 21.2867C17.2241 21.3142 17.2379 21.328 17.2379 21.3417ZM17.1417 20.9294C17.1417 20.9431 17.1554 20.9431 17.1554 20.9569C17.1691 21.0118 17.1829 21.0668 17.1829 21.1081C17.1829 21.1355 17.1966 21.163 17.1966 21.1905C17.1966 21.218 17.2104 21.2455 17.2104 21.2592C17.1966 21.2592 17.1829 21.2592 17.1829 21.2592C17.1279 21.2592 17.0592 21.2592 16.9905 21.2867C16.9905 21.273 16.9905 21.273 16.9905 21.273C16.9905 21.273 16.9905 21.273 16.9905 21.2592C16.9905 21.2455 16.9905 21.2455 16.9905 21.218C16.9905 21.2043 16.9905 21.1768 16.9905 21.1905C16.9905 21.1768 16.963 21.1355 16.963 21.163C16.963 21.1768 16.963 21.1768 16.963 21.1905C16.963 21.2318 16.963 21.2318 16.963 21.2867C16.963 21.3005 16.963 21.3829 16.963 21.4104C16.9492 21.4104 16.9492 21.4104 16.9355 21.4104C16.9217 21.4104 16.908 21.4242 16.8943 21.4242C16.8805 21.4242 16.853 21.4379 16.8393 21.4242C16.8255 21.4242 16.798 21.4104 16.7843 21.4104C16.7706 21.4104 16.7568 21.3967 16.7431 21.3829C16.7018 21.3692 16.6881 21.4104 16.6469 21.4104C16.6606 21.3692 16.6881 21.328 16.7156 21.2867C16.7431 21.2318 16.7843 21.1768 16.8255 21.1355C16.8393 21.1218 16.853 21.0943 16.8805 21.0806C16.8942 21.0531 16.9217 21.0256 16.9492 21.0118C16.963 21.0118 16.963 20.9981 16.9767 20.9981C16.963 21.0393 16.9492 21.0668 16.9217 21.0943C16.908 21.1081 16.908 21.1081 16.8943 21.1218C16.8805 21.1218 16.8805 21.1355 16.8668 21.1355C16.8668 21.163 16.8943 21.163 16.908 21.1493C16.9217 21.1355 16.9355 21.1081 16.963 21.0806C17.0042 21.0118 17.0592 20.9294 17.1279 20.8744C17.1279 20.8881 17.1417 20.9156 17.1417 20.9294ZM16.207 22.6474C16.1933 22.6474 16.1796 22.6474 16.1658 22.6337C16.1658 22.4825 16.1658 22.3313 16.1796 22.2076C16.1796 22.1664 16.1796 22.1389 16.1796 22.0976C16.1796 22.0564 16.1796 22.0289 16.1796 22.0014C16.1796 21.919 16.1795 21.8502 16.1933 21.754C16.207 21.7403 16.2345 21.7265 16.2483 21.7128C16.262 21.754 16.2483 21.7953 16.2483 21.8365C16.2483 21.8777 16.262 21.919 16.2483 21.9602C16.2483 21.9739 16.2345 21.9877 16.2345 22.0014C16.2345 22.0152 16.2345 22.0289 16.2208 22.0427C16.2208 22.0564 16.2208 22.0839 16.207 22.1114V22.1251C16.207 22.1251 16.207 22.1251 16.207 22.1389C16.207 22.2901 16.207 22.4687 16.207 22.6474ZM16.1796 22.7161C16.1796 22.7849 16.1796 22.8536 16.1658 22.9223C16.1658 22.9498 16.1658 22.9773 16.1658 23.0048C16.1658 23.0323 16.1658 23.0597 16.1658 23.0735C16.1521 23.0735 16.1521 23.0597 16.1383 23.0597C16.1521 22.936 16.1658 22.7986 16.1796 22.6612C16.1933 22.6886 16.1796 22.7024 16.1796 22.7161ZM16.317 21.8915C16.317 21.8777 16.3307 21.864 16.3445 21.8502C16.3582 21.809 16.372 21.7953 16.3995 21.754C16.4132 21.7403 16.4269 21.7265 16.4407 21.7128C16.4819 21.7265 16.5232 21.7266 16.5644 21.7266C16.5781 21.7266 16.5919 21.7266 16.6056 21.7266C16.6194 21.7266 16.6331 21.7403 16.6469 21.754C16.6606 21.754 16.6881 21.754 16.7156 21.754C16.7018 21.7815 16.6743 21.7953 16.6469 21.8228C16.6194 21.8365 16.6056 21.864 16.5781 21.8915C16.5369 21.9327 16.4957 21.9877 16.4544 22.0289C16.4132 22.0839 16.3857 22.1251 16.3445 22.1801C16.317 22.2213 16.2895 22.2626 16.2758 22.3038C16.262 22.3176 16.262 22.3313 16.2483 22.345C16.2483 22.2626 16.262 22.1801 16.262 22.0976C16.262 22.0564 16.2758 22.0289 16.2895 21.9877C16.3032 21.9602 16.3032 21.919 16.317 21.8915ZM16.2895 21.6853C16.2895 21.6716 16.2895 21.6578 16.2895 21.6578C16.2895 21.6303 16.3032 21.6166 16.317 21.6029C16.3307 21.6166 16.317 21.6441 16.3307 21.6578C16.3307 21.6853 16.3445 21.7265 16.3445 21.754C16.3445 21.7815 16.3445 21.7953 16.3307 21.809C16.317 21.8228 16.317 21.8502 16.3032 21.864C16.2895 21.7953 16.2895 21.7403 16.2895 21.6853ZM16.4407 21.6991C16.4407 21.6578 16.4407 21.6303 16.4407 21.6029C16.4407 21.6303 16.4407 21.6716 16.4407 21.6991ZM16.8393 21.5066C16.8668 21.4929 16.8805 21.4929 16.8943 21.4929C16.8943 21.4929 16.8942 21.5066 16.8805 21.5066C16.8668 21.5341 16.8668 21.5616 16.8393 21.5754C16.8255 21.5891 16.8118 21.5754 16.7843 21.5754C16.7431 21.5341 16.6606 21.5341 16.6194 21.5616C16.6056 21.5754 16.5919 21.5891 16.5644 21.5754C16.5644 21.5616 16.5919 21.5479 16.6056 21.5479C16.6331 21.5341 16.6606 21.5204 16.6881 21.5066C16.7018 21.5066 16.7156 21.4929 16.7431 21.4929C16.7431 21.5204 16.7568 21.5341 16.7843 21.5204C16.7843 21.5204 16.798 21.5204 16.8118 21.5066C16.8255 21.5066 16.8255 21.5066 16.8393 21.5066ZM16.4819 22.4C16.4544 22.4 16.4544 22.4413 16.4407 22.455C16.4132 22.4962 16.3995 22.5375 16.3857 22.5924C16.3445 22.7024 16.3032 22.8123 16.262 22.9223C16.262 22.936 16.262 22.9498 16.2483 22.9498C16.2483 22.936 16.2483 22.9223 16.2483 22.9086C16.2483 22.8261 16.2483 22.7436 16.2483 22.6612C16.2483 22.6337 16.262 22.6062 16.262 22.565C16.262 22.5375 16.262 22.5237 16.262 22.4962C16.262 22.4825 16.262 22.455 16.2758 22.4413C16.2758 22.4275 16.2895 22.4 16.2895 22.3863C16.2895 22.3725 16.3032 22.3725 16.3032 22.3588C16.3307 22.2763 16.372 22.2076 16.4132 22.1526C16.4544 22.0976 16.4957 22.0427 16.5369 22.0014C16.5919 21.9327 16.6469 21.8777 16.7156 21.8365C16.7568 21.809 16.798 21.7815 16.8255 21.7403C16.8393 21.7266 16.8393 21.7128 16.853 21.6991C16.853 21.7128 16.853 21.7266 16.8393 21.7403C16.8255 21.7678 16.798 21.809 16.7706 21.8365C16.7293 21.9052 16.6743 21.9602 16.6331 22.0289C16.6194 22.0702 16.5919 22.0976 16.5644 22.1389C16.5094 22.2488 16.4544 22.3588 16.3857 22.4687C16.372 22.51 16.3445 22.5375 16.3307 22.5787C16.3445 22.5787 16.3445 22.565 16.3582 22.5512C16.4407 22.4138 16.5232 22.2626 16.6194 22.1251C16.6606 22.0564 16.7156 21.9739 16.7706 21.9052C16.8118 21.8502 16.8393 21.7953 16.8805 21.7403C16.8942 21.7266 16.908 21.6991 16.9217 21.6853C16.9355 21.6716 16.9492 21.7128 16.9355 21.7266C16.9355 21.7403 16.9217 21.754 16.9217 21.7678C16.908 21.809 16.8943 21.8365 16.8668 21.8777C16.8393 21.919 16.8118 21.9739 16.798 22.0152C16.7568 22.1114 16.7018 22.2076 16.6469 22.2901C16.6194 22.3313 16.5919 22.3863 16.5644 22.4275C16.4957 22.5512 16.4269 22.6749 16.3582 22.7986C16.3582 22.8123 16.3445 22.8261 16.3307 22.8261C16.3307 22.8123 16.3445 22.7986 16.3445 22.7849C16.372 22.7161 16.3995 22.6474 16.4407 22.5787C16.4544 22.5375 16.4819 22.4962 16.4957 22.4413C16.4819 22.4413 16.4957 22.4138 16.4819 22.4ZM16.6056 21.6853C16.5919 21.6578 16.6056 21.6303 16.6056 21.6166C16.6194 21.6028 16.6469 21.5754 16.6743 21.5754C16.7156 21.5754 16.7706 21.5891 16.7843 21.6166C16.798 21.6578 16.7843 21.7128 16.7431 21.7266C16.7156 21.7403 16.6331 21.7265 16.6056 21.6853ZM16.5506 21.5754C16.5369 21.5891 16.5232 21.5891 16.4957 21.5891C16.4957 21.5754 16.5094 21.5754 16.5232 21.5616C16.5369 21.5479 16.5369 21.5479 16.5506 21.5341C16.5781 21.5341 16.5919 21.5204 16.6056 21.5066C16.6056 21.5341 16.5781 21.5479 16.5506 21.5754ZM16.5506 21.6853C16.5369 21.6991 16.5369 21.6716 16.5369 21.6441C16.5369 21.6166 16.5232 21.5891 16.5506 21.5891C16.5369 21.6303 16.5506 21.6578 16.5506 21.6853ZM16.2345 23.2659C16.2345 23.3346 16.2345 23.3896 16.2483 23.4583C16.1933 23.4446 16.1383 23.4446 16.0833 23.4583L16.0696 23.4721C16.0696 23.4858 16.0833 23.5133 16.0971 23.5133C16.1108 23.5133 16.1108 23.5133 16.1246 23.5271C16.1383 23.5271 16.1658 23.5133 16.1933 23.5271C16.207 23.5271 16.207 23.5408 16.2208 23.5408C16.2345 23.5408 16.2483 23.5545 16.2483 23.5545C16.262 23.5683 16.2758 23.5958 16.2895 23.6095C16.3032 23.6507 16.3032 23.7195 16.317 23.7607C16.3307 23.8019 16.3307 23.8432 16.3445 23.8844C16.3307 23.8844 16.3307 23.8844 16.317 23.8844C16.2895 23.8844 16.262 23.8844 16.2345 23.8844C16.2208 23.8844 16.1933 23.8844 16.1658 23.8844C16.1108 23.7057 16.0696 23.5133 16.0284 23.3209C16.0421 23.3071 16.0833 23.3071 16.0971 23.3071C16.1383 23.2934 16.1933 23.2934 16.2345 23.2934C16.207 23.2659 16.2208 23.2659 16.2345 23.2659ZM16.317 23.6095C16.317 23.5958 16.3307 23.5683 16.3445 23.5545C16.3582 23.5408 16.372 23.5133 16.3857 23.4996C16.4269 23.4446 16.4544 23.3896 16.4957 23.3346C16.5094 23.3209 16.5232 23.2934 16.5369 23.2797C16.5506 23.2522 16.5781 23.2247 16.5919 23.1972C16.5919 23.1834 16.6056 23.1834 16.6056 23.1697C16.6194 23.1834 16.6056 23.1972 16.6056 23.2109C16.5919 23.2797 16.5781 23.3484 16.5506 23.4033C16.5506 23.4033 16.5094 23.4583 16.5369 23.4721C16.5506 23.4721 16.5644 23.4446 16.5644 23.4308C16.5919 23.3759 16.6056 23.3346 16.6194 23.2659C16.6331 23.2109 16.6469 23.156 16.6743 23.101C16.6881 23.0872 16.6881 23.0597 16.7018 23.046C16.7156 23.0323 16.7156 23.0323 16.7293 23.0185C16.7293 23.046 16.7293 23.0872 16.7156 23.1285C16.7018 23.1834 16.7018 23.2384 16.6881 23.2797C16.6743 23.3346 16.6606 23.4034 16.6469 23.4583C16.6331 23.4858 16.6331 23.5133 16.6194 23.5408C16.5919 23.6233 16.5644 23.7057 16.5369 23.7882C16.5369 23.8019 16.5232 23.8157 16.5232 23.8294C16.5094 23.8432 16.5094 23.8707 16.4957 23.8707C16.4819 23.8707 16.4682 23.8707 16.4544 23.8707C16.3995 23.8569 16.3582 23.8432 16.3307 23.8157C16.3307 23.7882 16.317 23.7607 16.317 23.7332C16.317 23.692 16.3032 23.6507 16.317 23.6095ZM16.6194 22.9498C16.6056 22.9773 16.5919 23.0048 16.5644 23.0323C16.5506 23.0597 16.5369 23.0872 16.5094 23.1147C16.4682 23.156 16.4269 23.2109 16.3857 23.2522C16.3445 23.2934 16.317 23.3346 16.2895 23.3896L16.2758 23.4033C16.2758 23.3759 16.262 23.3621 16.262 23.3346C16.2483 23.2659 16.2483 23.1697 16.2483 23.101C16.2483 23.046 16.262 23.0048 16.2895 22.9635C16.2895 22.9498 16.3032 22.936 16.3032 22.9223C16.3307 22.8536 16.3582 22.7849 16.3995 22.7299C16.4269 22.6749 16.4544 22.6337 16.4819 22.5924C16.5369 22.4962 16.6056 22.4138 16.6469 22.3176C16.6881 22.2488 16.7156 22.1664 16.7568 22.0839C16.7843 22.0289 16.8118 21.9877 16.8255 21.9327C16.8393 21.8915 16.8668 21.864 16.8943 21.8365C16.8943 21.8365 16.8943 21.8365 16.908 21.8365C16.9217 21.8365 16.908 21.8777 16.908 21.8915C16.908 21.9052 16.8943 21.9327 16.8943 21.9465C16.853 22.1114 16.798 22.2626 16.7568 22.4138C16.7431 22.4413 16.7293 22.4687 16.7293 22.4962C16.7156 22.5237 16.7156 22.5649 16.7018 22.5924C16.7018 22.6062 16.6881 22.6199 16.6743 22.6337C16.6606 22.6474 16.6606 22.6612 16.6606 22.6749C16.6469 22.7024 16.6331 22.7299 16.6194 22.7436C16.6056 22.7574 16.6056 22.7711 16.5919 22.7849C16.5781 22.8123 16.5506 22.8398 16.5506 22.8811C16.5506 22.8948 16.5369 22.9223 16.5506 22.936C16.5644 22.936 16.5919 22.9086 16.5919 22.8948C16.6056 22.8811 16.6056 22.8536 16.6194 22.8398C16.6743 22.7299 16.7293 22.6062 16.7706 22.4825C16.8118 22.3588 16.853 22.2351 16.8943 22.0976C16.908 22.0702 16.908 22.0289 16.9217 22.0014C16.9217 21.9877 16.9217 21.9739 16.9355 21.9739C16.9355 22.0152 16.9217 22.0564 16.9217 22.0976C16.9217 22.1389 16.908 22.1664 16.8943 22.2076C16.8805 22.2763 16.853 22.345 16.8393 22.4138C16.798 22.5512 16.7568 22.6749 16.6881 22.7986C16.6743 22.8261 16.6606 22.8536 16.6469 22.8948C16.6606 22.8948 16.6331 22.9223 16.6194 22.9498ZM16.9492 21.6441V21.6166C16.9492 21.6166 16.9492 21.6029 16.9492 21.5891V21.5754C16.9492 21.5891 16.9492 21.6029 16.9492 21.6303C16.9492 21.6441 16.9492 21.6578 16.9492 21.6578C16.9492 21.6578 16.9492 21.6441 16.9492 21.6441ZM16.9492 20.8744C16.9355 20.9019 16.8943 20.9294 16.8668 20.9431C16.8118 20.9844 16.7431 21.0256 16.6881 21.0806C16.6743 21.0943 16.6606 21.1081 16.6469 21.1218C16.6331 21.1355 16.6056 21.1493 16.6056 21.1905C16.6331 21.1905 16.6469 21.163 16.6606 21.1493C16.7156 21.1081 16.7568 21.0668 16.798 21.0256C16.798 21.0256 16.8118 21.0256 16.8118 21.0118C16.8393 20.9844 16.8668 20.9706 16.908 20.9431C16.9217 20.9294 16.9355 20.9156 16.963 20.9019H16.9767C16.9905 20.8881 17.0042 20.8744 17.0317 20.8744C17.0454 20.8744 17.0454 20.8744 17.0592 20.8607C17.0729 20.8607 17.1004 20.8332 17.1279 20.8607C17.1142 20.8744 17.0867 20.8881 17.0729 20.9019C17.0454 20.9156 17.018 20.9431 16.9905 20.9569C16.9767 20.9706 16.9767 20.9706 16.963 20.9844C16.9217 21.0118 16.8943 21.0531 16.8668 21.0943C16.853 21.1218 16.8255 21.1355 16.8118 21.163C16.7843 21.2043 16.7431 21.2455 16.7156 21.2867C16.6606 21.3692 16.6056 21.4654 16.5232 21.5341C16.5094 21.5479 16.4407 21.5891 16.4407 21.5341C16.4544 21.5341 16.4682 21.5341 16.4819 21.5341C16.5094 21.5204 16.5232 21.4929 16.5369 21.4792C16.5506 21.4654 16.5644 21.4517 16.5506 21.4379C16.5369 21.4379 16.5232 21.4654 16.5094 21.4792C16.4957 21.4929 16.4819 21.5066 16.4544 21.5066C16.3995 21.5066 16.372 21.4792 16.372 21.4104C16.372 21.3967 16.372 21.328 16.372 21.3142C16.3857 21.2867 16.3995 21.273 16.4269 21.2592C16.4682 21.2318 16.4957 21.2043 16.5369 21.1768C16.5506 21.163 16.5644 21.163 16.5644 21.1493C16.5919 21.1355 16.6194 21.1218 16.6331 21.0943C16.6881 21.0531 16.7568 21.0256 16.8255 20.9844C16.853 20.9706 16.8805 20.9569 16.908 20.9431C16.9217 20.8881 16.9355 20.8744 16.9492 20.8744ZM16.8255 20.7095C16.8255 20.7095 16.8255 20.6957 16.8255 20.682C16.8255 20.6682 16.8255 20.6545 16.8255 20.6545C16.8255 20.6957 16.8393 20.7232 16.8393 20.7507C16.8393 20.7782 16.8255 20.8057 16.8118 20.8332C16.7431 20.8607 16.6743 20.9019 16.6194 20.9431C16.6056 20.9019 16.5919 20.8607 16.5781 20.8057C16.5781 20.7782 16.5644 20.7645 16.5781 20.7507C16.5781 20.737 16.5919 20.7232 16.5919 20.7095C16.6056 20.7232 16.6194 20.7232 16.6194 20.737C16.6469 20.7507 16.6743 20.7782 16.7156 20.7782C16.7293 20.7782 16.7431 20.7782 16.7568 20.7782C16.7706 20.7782 16.798 20.7782 16.8118 20.7782C16.8255 20.7782 16.8255 20.7507 16.8255 20.737C16.8255 20.7232 16.8255 20.7095 16.8255 20.7095ZM16.853 20.8057C16.853 20.7919 16.853 20.7782 16.8668 20.7645C16.8805 20.7645 16.8943 20.7782 16.908 20.7782C16.8943 20.7919 16.8668 20.7919 16.853 20.8057ZM16.5232 20.3384C16.5232 20.3109 16.5369 20.2971 16.5369 20.2834C16.5369 20.2697 16.5506 20.2697 16.5506 20.2559C16.5919 20.2147 16.6331 20.2009 16.6881 20.1734C16.6881 20.1597 16.6881 20.146 16.6881 20.1322C16.6881 20.146 16.6881 20.1597 16.7018 20.1734C16.7431 20.1872 16.7706 20.2009 16.798 20.2284C16.8255 20.2559 16.853 20.2834 16.8668 20.3246C16.8668 20.3521 16.8668 20.3659 16.8805 20.3796C16.8942 20.3934 16.908 20.4071 16.8943 20.4346C16.8943 20.5171 16.8393 20.627 16.7843 20.6682C16.7568 20.682 16.7156 20.7095 16.6743 20.7095C16.6331 20.7095 16.6056 20.682 16.5781 20.6545C16.5644 20.6408 16.5369 20.5995 16.5232 20.572C16.4957 20.5308 16.4819 20.4896 16.4819 20.4346C16.4957 20.4071 16.5232 20.3796 16.5232 20.3384ZM16.5369 20.7645C16.5506 20.8194 16.5506 20.8607 16.5644 20.9156C16.5644 20.9294 16.5781 20.9431 16.5781 20.9569C16.5644 20.9706 16.5506 20.9844 16.5232 20.9844C16.4957 20.9294 16.4957 20.8607 16.4957 20.7782C16.5094 20.7782 16.5232 20.7645 16.5369 20.7645ZM16.4819 21.0531C16.4957 21.0668 16.5232 21.0668 16.5232 21.0943C16.5232 21.1081 16.4819 21.1355 16.4682 21.1493H16.4544C16.4544 21.1355 16.4682 21.1218 16.4682 21.1218C16.4819 21.1081 16.4682 21.0806 16.4682 21.0806C16.4544 21.0668 16.4682 21.0668 16.4819 21.0531ZM16.1933 21.2867C16.207 21.218 16.207 21.1493 16.2345 21.0806C16.2483 21.0256 16.262 20.9706 16.2895 20.9156C16.3032 20.9019 16.3032 20.8881 16.317 20.8744C16.317 20.8744 16.317 20.8607 16.3307 20.8607C16.3445 20.8469 16.3582 20.8332 16.3857 20.8194H16.3995C16.4132 20.8057 16.4407 20.8057 16.4682 20.7919C16.4682 20.8469 16.4682 20.8881 16.4819 20.9431C16.4819 20.9706 16.4957 20.9981 16.4957 21.0118C16.4544 21.0393 16.4269 21.0668 16.3857 21.0806C16.372 21.0668 16.3857 21.0531 16.372 21.0531C16.372 21.0668 16.3582 21.0668 16.3582 21.0806C16.3582 21.0943 16.372 21.1081 16.372 21.1218C16.372 21.1355 16.372 21.1905 16.372 21.218C16.372 21.2318 16.3582 21.2867 16.3582 21.3142C16.3582 21.328 16.3582 21.3417 16.3582 21.3555C16.317 21.3417 16.2483 21.328 16.207 21.3142C16.1795 21.3142 16.1795 21.3005 16.1933 21.2867ZM16.1521 21.4379C16.2208 21.4379 16.2758 21.4654 16.317 21.4929V21.5066C16.262 21.4792 16.207 21.4654 16.1521 21.4379ZM15.8222 21.5616V21.5479L15.8359 21.5341C15.8359 21.5204 15.8359 21.5066 15.8497 21.5066C15.9184 21.5204 16.0009 21.5341 16.0696 21.5616C16.0833 21.5616 16.0971 21.5754 16.1108 21.5754C16.1246 21.5754 16.1383 21.6029 16.1383 21.6029C16.1521 21.6029 16.1521 21.6029 16.1658 21.6029C16.1933 21.5754 16.1521 21.5479 16.1246 21.5479C16.1246 21.5341 16.1246 21.5204 16.1246 21.5204H16.1521C16.1933 21.5341 16.2483 21.5479 16.2758 21.5616C16.262 21.6166 16.2345 21.6441 16.2208 21.6991C16.207 21.7128 16.1933 21.754 16.1658 21.754C16.1521 21.754 16.1108 21.7403 16.0971 21.7403C16.0696 21.7403 16.0559 21.7266 16.0284 21.7266C16.0009 21.7266 15.9871 21.7128 15.9734 21.6991C15.9047 21.6716 15.8497 21.6441 15.7947 21.6166C15.7947 21.5754 15.8222 21.5754 15.8222 21.5616ZM15.8085 21.4654H15.8222C15.8085 21.4654 15.7947 21.4929 15.8085 21.5066C15.7947 21.5204 15.7947 21.5204 15.7947 21.5341C15.781 21.5341 15.781 21.5479 15.781 21.5616L15.7672 21.5754C15.7672 21.5754 15.7672 21.5754 15.7672 21.5891C15.7535 21.5891 15.7535 21.6028 15.7397 21.6166C15.7397 21.6166 15.7397 21.6029 15.726 21.6029C15.7672 21.5616 15.781 21.5066 15.8085 21.4654ZM15.7672 21.4379H15.781C15.7947 21.4654 15.781 21.4929 15.7672 21.5204C15.7535 21.5341 15.7397 21.5754 15.726 21.5754C15.7122 21.5754 15.6985 21.5754 15.6985 21.5616C15.6985 21.5616 15.7122 21.5479 15.726 21.5341C15.726 21.5204 15.7535 21.4792 15.7672 21.4379ZM15.4374 21.2043C15.4511 21.2043 15.4511 21.218 15.4511 21.218C15.4648 21.2318 15.4786 21.2455 15.4923 21.2592C15.4786 21.2455 15.4511 21.2592 15.4374 21.2455C15.4374 21.2318 15.4236 21.2043 15.4374 21.2043ZM15.5473 21.3142C15.5336 21.3142 15.5198 21.3005 15.5061 21.3005C15.4786 21.2867 15.4374 21.3005 15.4236 21.3005C15.4099 21.2318 15.5611 21.2592 15.5473 21.3142ZM15.4236 21.3142C15.4236 21.3142 15.4511 21.3142 15.4511 21.3005C15.4786 21.3005 15.4923 21.3142 15.5198 21.328C15.5336 21.3417 15.5473 21.3417 15.5473 21.3555C15.5473 21.3692 15.5336 21.3692 15.5198 21.3692C15.4923 21.3692 15.4786 21.3555 15.4511 21.3555C15.4374 21.3555 15.4374 21.3692 15.4236 21.3692C15.4236 21.3555 15.4236 21.328 15.4236 21.3142ZM15.4374 21.3692C15.4511 21.3555 15.4923 21.3555 15.5198 21.3692C15.5336 21.3692 15.5473 21.3829 15.5473 21.3967C15.5198 21.3967 15.4786 21.3829 15.4511 21.4104C15.4374 21.3967 15.4374 21.3829 15.4374 21.3692ZM15.4923 21.4242C15.4786 21.4242 15.4786 21.4379 15.4786 21.4517C15.4648 21.4517 15.4511 21.4104 15.4786 21.3967C15.5061 21.3829 15.5611 21.3967 15.5611 21.4242C15.5473 21.4379 15.5061 21.4242 15.4923 21.4242ZM15.5336 21.4517C15.5336 21.4379 15.5611 21.4379 15.5611 21.4242C15.5611 21.4104 15.5473 21.4104 15.5473 21.3967C15.5611 21.3967 15.5611 21.4104 15.5748 21.4242C15.5748 21.4242 15.6023 21.4517 15.616 21.4517C15.6298 21.4517 15.6573 21.4517 15.6435 21.4242C15.6298 21.4242 15.616 21.4242 15.6023 21.4104C15.5885 21.3967 15.5748 21.3692 15.5611 21.3555C15.5748 21.3417 15.5611 21.328 15.5473 21.3142C15.5473 21.2867 15.5473 21.273 15.5336 21.2592C15.5611 21.273 15.5748 21.273 15.6023 21.2867C15.6435 21.3142 15.671 21.3417 15.671 21.3967C15.6848 21.4104 15.7122 21.4104 15.7122 21.4242C15.6985 21.4654 15.6985 21.4929 15.671 21.5066C15.6573 21.4929 15.6435 21.4792 15.616 21.4654C15.6023 21.4792 15.5336 21.4792 15.5198 21.4654C15.5473 21.4929 15.5336 21.4654 15.5336 21.4517ZM15.8634 22.7986C15.8359 22.6612 15.7947 22.5237 15.7672 22.3725C15.7535 22.3313 15.7535 22.3038 15.7397 22.2626C15.726 22.2213 15.726 22.1939 15.7122 22.1526C15.671 21.9465 15.6023 21.7266 15.5611 21.5204C15.5885 21.5341 15.6298 21.5341 15.6573 21.5341C15.6573 21.5616 15.6573 21.5891 15.6985 21.5891C15.6985 21.6029 15.6985 21.6166 15.7122 21.6303C15.7397 21.6303 15.7535 21.6303 15.7672 21.6166C15.8909 21.6716 16.0009 21.7265 16.1521 21.754C16.1521 21.9052 16.1383 22.0564 16.1383 22.2213C16.1383 22.2763 16.1246 22.3313 16.1246 22.3863C16.1246 22.4825 16.1108 22.5924 16.1108 22.6886C16.0971 22.7574 16.0971 22.8398 16.0833 22.9086C16.0833 22.936 16.0833 22.9635 16.0833 22.991C16.0833 23.0185 16.0696 23.046 16.0833 23.0597L16.0971 23.0735C16.1246 23.101 16.1795 23.1147 16.2208 23.1422C16.2208 23.156 16.2208 23.156 16.2208 23.1697C16.1383 23.1834 16.0559 23.1972 15.9734 23.2109C15.9459 23.0735 15.9047 22.936 15.8634 22.7986ZM16.0696 24.4067C16.0833 24.4204 16.0971 24.4479 16.0971 24.4617C16.0833 24.4479 16.0833 24.4204 16.0696 24.4067ZM16.1108 24.1868C16.0696 24.2005 16.0146 24.2005 15.9734 24.2143C15.9459 24.2143 15.9322 24.2143 15.9047 24.2143C15.8634 24.2143 15.8359 24.2143 15.8085 24.2005C15.7947 24.1868 15.781 24.1868 15.7672 24.173C15.7535 24.1593 15.7397 24.1455 15.7535 24.1043C15.7535 24.1043 15.7535 24.1043 15.7535 24.0906V24.0768C15.7535 24.0631 15.7672 24.0631 15.7672 24.0493C15.7672 24.0356 15.7535 24.0218 15.7535 24.0218C15.726 24.0218 15.7122 24.0218 15.7122 24.0356C15.7122 24.0356 15.7122 24.0356 15.7122 24.0493L15.6985 24.0631C15.6985 24.0631 15.6848 24.0631 15.671 24.0631C15.6573 24.0631 15.6435 24.0631 15.6298 24.0493C15.6023 24.0356 15.5748 24.0081 15.5611 23.9806C15.5611 23.9531 15.5473 23.9531 15.5473 23.9256C15.5473 23.9119 15.5473 23.8844 15.5611 23.8707C15.5611 23.8569 15.5885 23.8432 15.5748 23.8157L15.5611 23.8019C15.5611 23.7882 15.5611 23.7882 15.5473 23.7744C15.5336 23.7744 15.5198 23.7744 15.5198 23.7882C15.5061 23.8019 15.5061 23.8432 15.4923 23.8569C15.4923 23.8981 15.4923 23.9256 15.4923 23.9669C15.4923 23.9944 15.5061 23.9944 15.5198 24.0218C15.5336 24.0356 15.5473 24.0631 15.5748 24.0768C15.5885 24.0906 15.6298 24.1043 15.6298 24.1318C15.6435 24.1318 15.6573 24.1455 15.6848 24.1593C15.6985 24.173 15.7397 24.173 15.7535 24.2005C15.7672 24.2005 15.7947 24.2143 15.8085 24.228C15.8772 24.2555 15.9322 24.283 16.0009 24.3105C16.0284 24.3242 16.0559 24.338 16.0696 24.3517C16.0833 24.3655 16.0971 24.3792 16.1108 24.3929C16.0971 24.3929 16.0833 24.3654 16.0696 24.3792C16.0696 24.3929 16.0833 24.4067 16.0971 24.4204C16.0971 24.4204 16.0971 24.4204 16.0971 24.4342L16.1108 24.4479C16.0971 24.4479 16.0971 24.4342 16.0833 24.4204C16.0833 24.4067 16.0696 24.4067 16.0558 24.4067V24.4204L16.0421 24.4067C16.0284 24.4204 16.0558 24.4342 16.0558 24.4342C16.0421 24.4342 16.0421 24.4204 16.0284 24.4204V24.4342C16.0284 24.4342 16.0284 24.4204 16.0146 24.4204C16.0146 24.4342 16.0146 24.4342 16.0146 24.4479C16.0146 24.4617 16.0284 24.4617 16.0284 24.4754C16.0284 24.5166 16.0146 24.5579 16.0284 24.5854C16.0009 24.5579 16.0146 24.5166 16.0146 24.4754C16.0146 24.4617 16.0009 24.4342 15.9871 24.4204C15.9322 24.3517 15.8359 24.2967 15.7397 24.2692C15.726 24.2555 15.6848 24.2555 15.6573 24.2418C15.5885 24.228 15.5336 24.2005 15.4786 24.173C15.4511 24.1593 15.4236 24.1318 15.4099 24.1043C15.3961 24.0906 15.3824 24.0631 15.3686 24.0493C15.3549 24.0356 15.3549 24.0218 15.3549 23.9944C15.3549 23.9806 15.3549 23.9669 15.3549 23.9394C15.3549 23.9119 15.3549 23.8981 15.3549 23.8707C15.3549 23.8294 15.3824 23.7607 15.3961 23.7332C15.4099 23.692 15.4374 23.6645 15.4648 23.637C15.4923 23.6095 15.5198 23.582 15.5473 23.5408C15.5748 23.4996 15.5885 23.4583 15.6298 23.4308C15.6435 23.4171 15.671 23.4034 15.6985 23.3896C15.7672 23.3484 15.8359 23.3346 15.9322 23.3209C15.9734 23.4721 16.0146 23.637 16.0558 23.7882C16.0558 23.8157 16.0696 23.8294 16.0696 23.8569C16.0421 23.8569 15.9734 23.8294 15.9596 23.8432C15.9322 23.8569 15.9596 23.8844 15.9871 23.8844H15.9734C15.9596 23.8844 15.9459 23.8981 15.9322 23.8981H15.9184C15.9047 23.8981 15.8909 23.9119 15.8909 23.9256C15.8772 23.9394 15.8909 23.9669 15.9184 23.9531C15.9322 23.9394 15.9459 23.9256 15.9596 23.9119C16.0009 23.8981 16.0421 23.8844 16.0833 23.8844C16.0971 23.9531 16.1108 24.0081 16.1246 24.0768C16.0833 24.0768 16.0284 24.0906 15.9871 24.0768C15.9596 24.0631 15.9459 24.0631 15.9184 24.0768L15.9322 24.0906C15.9322 24.1181 15.8909 24.1043 15.8909 24.0906C15.8772 24.1181 15.9184 24.1455 15.9596 24.1593H15.9734C16.0284 24.1593 16.0971 24.1455 16.1383 24.1318C16.1521 24.1868 16.1246 24.1868 16.1108 24.1868ZM16.207 24.1593C16.207 24.1455 16.2208 24.1455 16.2208 24.1455C16.2758 24.1318 16.3445 24.1318 16.4132 24.1181H16.4269C16.3582 24.1455 16.2758 24.1455 16.207 24.1593ZM16.372 24.0906C16.3032 24.0906 16.2483 24.0906 16.1933 24.1043C16.1795 24.0356 16.1658 23.9806 16.1521 23.9119C16.2208 23.9119 16.2895 23.9256 16.3582 23.9256C16.372 23.9394 16.372 23.9394 16.372 23.9531C16.3857 23.9669 16.3995 23.9806 16.4132 23.9806C16.4269 23.9944 16.4269 23.9944 16.4407 24.0081L16.4544 24.0218C16.4682 24.0356 16.4682 24.0356 16.4819 24.0493C16.4682 24.0631 16.4544 24.0631 16.4407 24.0768C16.4269 24.0906 16.3995 24.0906 16.372 24.0906ZM16.5232 24.2143C16.5232 24.2005 16.5506 24.2005 16.5506 24.2143C16.5506 24.2418 16.5094 24.2418 16.5232 24.2143ZM16.7018 24.0906C16.6881 24.1181 16.6881 24.1455 16.6606 24.173H16.6469C16.6194 24.1868 16.6194 24.2555 16.5781 24.228C16.5644 24.2005 16.6056 24.2005 16.6194 24.2143C16.6194 24.2005 16.6056 24.2005 16.5781 24.2005C16.5781 24.173 16.6056 24.1593 16.6194 24.1455C16.6194 24.1318 16.6194 24.1318 16.6194 24.1318C16.6056 24.1181 16.5919 24.1318 16.5919 24.1455C16.5919 24.1593 16.5644 24.173 16.5644 24.1868C16.5506 24.2005 16.5506 24.2143 16.5369 24.2005C16.5369 24.1593 16.5644 24.1593 16.5781 24.1318C16.5781 24.1318 16.5781 24.1318 16.5781 24.1181C16.5506 24.1181 16.5644 24.1455 16.5369 24.1593C16.5232 24.173 16.5232 24.2005 16.5094 24.2143H16.4957V24.2005C16.4957 24.2005 16.4957 24.2005 16.5094 24.1868C16.4957 24.1593 16.5232 24.1318 16.5369 24.1181C16.5232 24.0906 16.4957 24.1455 16.4957 24.1593C16.4957 24.173 16.4957 24.1868 16.4819 24.1868C16.4682 24.1868 16.4819 24.1455 16.4819 24.1318C16.4819 24.1181 16.4957 24.1181 16.5094 24.1043C16.4957 24.1043 16.4819 24.1181 16.4819 24.1181C16.4819 24.1181 16.4819 24.1318 16.4682 24.1318C16.4544 24.1318 16.4682 24.1181 16.4682 24.1043C16.4819 24.0906 16.4819 24.0768 16.5094 24.0768C16.5232 24.0768 16.5232 24.0631 16.5232 24.0493C16.5369 24.0356 16.5919 24.0493 16.6194 24.0493C16.6331 24.0493 16.6606 24.0493 16.6743 24.0631C16.6881 24.0631 16.7156 24.0631 16.7156 24.0768C16.7156 24.0768 16.7018 24.0768 16.7018 24.0906ZM16.8118 23.0323C16.8118 23.1697 16.798 23.3071 16.798 23.4446C16.798 23.6095 16.7843 23.7744 16.7706 23.9119C16.7431 23.9119 16.7156 23.8981 16.6743 23.8844C16.6331 23.8844 16.6056 23.8707 16.5644 23.8707C16.6194 23.692 16.6743 23.5133 16.7156 23.3071C16.7431 23.1834 16.7706 23.0735 16.7843 22.9498C16.8118 22.9635 16.8118 23.0185 16.8118 23.0323ZM16.7706 22.8673C16.7568 22.8948 16.7293 22.9086 16.7156 22.936C16.7018 22.9498 16.7018 22.9635 16.6881 22.9635C16.7568 22.7849 16.8393 22.6062 16.8943 22.4138C16.9217 22.3176 16.9492 22.2213 16.9767 22.1251C17.0042 22.0152 17.0179 21.9052 17.0179 21.7953C17.0317 21.809 17.0454 21.8228 17.0454 21.8502C17.0729 21.919 17.0867 21.9877 17.1004 22.0564C17.1142 22.1114 17.1142 22.1526 17.1142 22.2076C17.1142 22.2351 17.1142 22.2626 17.1142 22.2901C17.1142 22.3176 17.1142 22.345 17.1142 22.3725C17.1142 22.4 17.0867 22.4275 17.0729 22.455C17.0592 22.4825 17.0454 22.51 17.0179 22.5375C16.9905 22.5924 16.9492 22.6337 16.908 22.6886C16.8668 22.7436 16.8118 22.8123 16.7706 22.8673ZM16.9492 23.2934C16.9355 23.1697 16.9355 23.0323 16.9492 22.9086C16.9492 22.8948 16.9492 22.8673 16.9492 22.8536C16.9492 22.8261 16.9492 22.7986 16.9767 22.7711C16.9905 22.7574 17.0042 22.7574 17.0179 22.7436C17.0317 22.7299 17.0317 22.7299 17.0454 22.7161C17.0454 22.7024 17.0592 22.6749 17.0592 22.6612C17.0729 22.9223 17.0317 23.101 17.0042 23.3346C17.0042 23.4033 16.9905 23.4583 16.9905 23.5271C16.963 23.4858 16.963 23.3896 16.9492 23.2934ZM16.9905 23.747C16.9767 23.747 16.963 23.747 16.9492 23.7607C16.9217 23.637 16.8942 23.4858 16.8805 23.3484C16.8668 23.1972 16.853 23.046 16.853 22.8948C16.8668 22.8948 16.8668 22.8811 16.8805 22.8948C16.8942 22.9086 16.8943 22.9773 16.8943 23.0048C16.8943 23.1147 16.908 23.2384 16.908 23.3484C16.908 23.4171 16.9217 23.4996 16.9355 23.5683C16.9492 23.6233 16.9767 23.692 16.9905 23.747ZM16.8255 23.8432C16.8255 23.6782 16.8393 23.4996 16.8393 23.3209C16.853 23.3209 16.8393 23.3346 16.8393 23.3484C16.853 23.4171 16.853 23.4996 16.8668 23.5683C16.8805 23.6507 16.908 23.7195 16.908 23.8019C16.8943 23.8157 16.8668 23.8157 16.853 23.8157C16.853 23.8294 16.8393 23.8432 16.8255 23.8432ZM17.2379 24.1043C17.2104 24.0906 17.1829 24.0631 17.1417 24.0493C17.1279 24.0493 17.1142 24.0493 17.1004 24.0493C17.1004 24.0631 17.1142 24.0631 17.1279 24.0631C17.1554 24.0631 17.1829 24.0768 17.1966 24.0906C17.2104 24.0906 17.2241 24.1043 17.2241 24.1181C17.2104 24.1455 17.1691 24.1043 17.1691 24.0906C17.1554 24.0906 17.1554 24.0768 17.1417 24.0768C17.1279 24.0768 17.1142 24.0768 17.1142 24.0768C17.1004 24.0768 17.1004 24.0768 17.0867 24.0631C17.0867 24.0906 17.1416 24.0768 17.1554 24.1043C17.1554 24.1043 17.1554 24.1043 17.1554 24.1181L17.1691 24.1318V24.1181C17.2104 24.1043 17.2104 24.1455 17.1829 24.1593C17.1554 24.173 17.1279 24.1455 17.1142 24.1455C17.0729 24.1455 17.0454 24.1455 17.0179 24.1455C16.9905 24.1455 16.9767 24.1181 16.963 24.1043C16.9492 24.0906 16.9217 24.0768 16.8943 24.0768C16.908 24.0493 16.9217 24.0218 16.9355 23.9944C16.9492 23.9806 17.0042 23.9531 17.0317 23.9669C17.0454 23.9669 17.0729 23.9806 17.0867 23.9806C17.1004 23.9806 17.1004 23.9944 17.1142 23.9944C17.1279 24.0081 17.1279 24.0218 17.1417 24.0218C17.1691 24.0356 17.1966 24.0356 17.2241 24.0356C17.2379 24.0356 17.2379 24.0356 17.2379 24.0493C17.2379 24.0493 17.2379 24.0631 17.2241 24.0631C17.2104 24.0631 17.2104 24.0493 17.2104 24.0493C17.1966 24.0356 17.1554 24.0356 17.1279 24.0356C17.1279 24.0356 17.1417 24.0356 17.1417 24.0493C17.1829 24.0631 17.2104 24.0768 17.2379 24.0906C17.2241 24.0906 17.2516 24.0906 17.2379 24.1043ZM18.2 24.0081C18.2137 24.0356 18.2274 24.0493 18.2274 24.0768C18.2137 24.0906 18.2137 24.1043 18.2 24.1043C18.2 24.0906 18.2 24.0631 18.1862 24.0631C18.1862 24.0631 18.1862 24.0768 18.1725 24.0768C18.1587 24.0768 18.1587 24.0631 18.145 24.0631C18.145 24.0768 18.1587 24.0906 18.1587 24.1043C18.1587 24.1455 18.1312 24.1593 18.1037 24.1593C18.1037 24.1455 18.1312 24.1455 18.1312 24.1318C18.1312 24.1181 18.1175 24.1043 18.1037 24.0906C18.09 24.0906 18.1037 24.1043 18.09 24.1043C18.0763 24.1043 18.0763 24.0768 18.0488 24.0906C18.0625 24.1043 18.0625 24.1181 18.0488 24.1318C18.035 24.1455 18.0075 24.1455 17.9938 24.1455C17.9663 24.1455 17.9388 24.1455 17.9113 24.1181C17.8976 24.1043 17.8976 24.0906 17.8838 24.0768C17.8701 24.0631 17.8563 24.0631 17.8426 24.0493C17.8289 24.0493 17.8289 24.0356 17.8289 24.0218C17.8151 24.0081 17.8014 24.0081 17.7876 23.9944C17.7464 23.9806 17.6777 23.9531 17.6227 23.9531C17.5265 23.9394 17.4165 23.9531 17.3341 23.9256C17.3066 23.9256 17.2653 23.9119 17.2379 23.9119C17.1966 23.9119 17.1691 23.9256 17.1417 23.9119C17.1142 23.9119 17.1004 23.8844 17.0867 23.8569C17.0729 23.7882 17.0729 23.7195 17.0317 23.6645C17.0179 23.637 17.0179 23.6095 17.0317 23.582C17.0317 23.5545 17.0454 23.527 17.0454 23.4996C17.0454 23.4721 17.0454 23.4446 17.0592 23.4171C17.0592 23.3759 17.0867 23.3209 17.1004 23.2934C17.1142 23.2934 17.1279 23.3209 17.1279 23.3209C17.1554 23.3346 17.1829 23.3484 17.1966 23.3621C17.2104 23.3621 17.2104 23.3759 17.2241 23.3896C17.2516 23.4446 17.2379 23.5133 17.2653 23.5683C17.2653 23.582 17.2791 23.582 17.2791 23.5958C17.2516 23.5958 17.2104 23.5958 17.1966 23.6233C17.2104 23.6507 17.2516 23.6233 17.2791 23.6233C17.3066 23.6233 17.3478 23.637 17.3616 23.6507C17.3753 23.6645 17.389 23.692 17.4165 23.692C17.444 23.7057 17.499 23.7057 17.5402 23.7057C17.5815 23.7057 17.6364 23.7195 17.6639 23.7195C17.7189 23.7332 17.7876 23.7607 17.8289 23.7744C17.8426 23.7744 17.8426 23.7744 17.8563 23.7882C17.8701 23.7882 17.8701 23.8019 17.8838 23.8019C17.8976 23.8157 17.9251 23.8157 17.9526 23.8157C17.9801 23.8157 17.9938 23.8294 18.0213 23.8294C18.035 23.8432 18.0625 23.8432 18.09 23.8569C18.1037 23.8569 18.1037 23.8707 18.1175 23.8707C18.1312 23.8707 18.145 23.8707 18.1587 23.8707C18.1725 23.8707 18.1862 23.8844 18.2 23.8981C18.2274 23.9119 18.2412 23.9394 18.2549 23.9669C18.2274 24.0218 18.2274 23.9944 18.2 24.0081ZM18.4748 23.9944C18.4611 23.9806 18.4336 23.9806 18.4199 23.9806C18.3924 23.9806 18.3511 23.9669 18.3237 23.9669C18.2962 23.9669 18.2549 23.9531 18.2274 23.9531C18.2412 23.9394 18.2824 23.9394 18.3099 23.9394C18.3649 23.9394 18.4611 23.9394 18.4748 23.9669C18.4748 23.9669 18.4748 23.9806 18.4748 23.9944ZM18.6948 23.9119C18.7085 23.9256 18.7222 23.9394 18.7222 23.9531C18.7222 23.9531 18.7222 23.9669 18.7085 23.9669C18.6948 23.9669 18.6948 23.9256 18.6535 23.9256C18.6535 23.9256 18.6398 23.9256 18.6398 23.9394C18.626 23.9669 18.6947 23.9806 18.6673 24.0218C18.6673 24.0356 18.6398 24.0356 18.6123 24.0356C18.6123 24.0218 18.626 24.0218 18.626 24.0081C18.626 23.9806 18.5848 23.9531 18.5573 23.9806C18.5573 24.0081 18.5848 24.0218 18.5711 24.0356C18.5573 24.0493 18.5298 24.0493 18.5161 24.0356C18.5161 24.0356 18.5298 24.0356 18.5436 24.0356C18.5436 24.0356 18.5436 24.0356 18.5573 24.0218C18.5573 24.0081 18.5436 24.0081 18.5298 23.9944C18.5161 23.9806 18.5161 23.9806 18.5023 23.9669C18.5023 23.9119 18.4611 23.9119 18.4061 23.8981C18.3237 23.8981 18.2412 23.8844 18.1587 23.8707C18.1587 23.8294 18.1312 23.8294 18.1037 23.8157C18.0625 23.8019 18.0213 23.8019 17.98 23.7882C17.9663 23.7882 17.9388 23.7744 17.9251 23.7607C17.9251 23.747 17.9526 23.7332 17.9663 23.7195C18.0075 23.692 18.0488 23.6645 18.09 23.6233C18.1725 23.637 18.2274 23.6782 18.2962 23.7057C18.3099 23.7195 18.3374 23.7195 18.3511 23.7332C18.3649 23.747 18.3924 23.747 18.4061 23.7607C18.4886 23.7882 18.6123 23.7607 18.681 23.8019C18.7085 23.8157 18.7222 23.8432 18.7222 23.8707C18.7085 23.8707 18.7085 23.8294 18.6948 23.8294C18.681 23.8294 18.681 23.8432 18.681 23.8432C18.681 23.8981 18.681 23.9119 18.6948 23.9119ZM17.9663 24.0631C17.9388 24.0493 17.9251 24.0218 17.9113 23.9944C17.9113 23.9944 17.8976 23.9806 17.8838 23.9806C17.8701 23.9806 17.8701 23.9669 17.8563 23.9669C17.8289 23.9531 17.8014 23.9531 17.7739 23.9394C17.7601 23.9394 17.7601 23.9394 17.7464 23.9394C17.7327 23.9394 17.7189 23.9256 17.7052 23.9256C17.6639 23.9119 17.609 23.9256 17.5677 23.9119C17.499 23.9119 17.4303 23.8981 17.3616 23.8844C17.3341 23.8844 17.2928 23.8707 17.2653 23.8707C17.2516 23.8707 17.2516 23.8569 17.2379 23.8569C17.2104 23.8569 17.1966 23.8569 17.1691 23.8569C17.1554 23.8569 17.1554 23.8707 17.1417 23.8707C17.1279 23.8707 17.1279 23.8432 17.1004 23.8569C17.0867 23.8707 17.0867 23.8844 17.0867 23.8981C17.0867 23.8981 17.1142 23.9119 17.1142 23.9256C17.1279 23.9394 17.1416 23.9256 17.1554 23.9119C17.2104 23.8981 17.2653 23.9256 17.3066 23.9256C17.4303 23.9394 17.5815 23.9394 17.6914 23.9669C17.7052 23.9669 17.7327 23.9669 17.7464 23.9806C17.8014 23.9944 17.8289 24.0356 17.8701 24.0493C17.8976 24.0768 17.9113 24.1043 17.9526 24.1181C17.9801 24.1181 18.0075 24.1181 18.0075 24.1043C18.0488 24.0631 17.9938 24.0768 17.9663 24.0631ZM16.6743 20.5445H16.6881C16.7018 20.5445 16.7293 20.5583 16.7431 20.5445C16.7706 20.5308 16.7431 20.4896 16.7431 20.4621C16.7431 20.4483 16.7431 20.4346 16.7568 20.4208C16.7568 20.4208 16.8118 20.4483 16.853 20.4208C16.853 20.4208 16.8668 20.4208 16.8668 20.4071V20.3934C16.8668 20.3934 16.853 20.4071 16.853 20.3934C16.8255 20.3796 16.8118 20.3659 16.7843 20.3796C16.7568 20.3796 16.7431 20.3934 16.7431 20.3934C16.7293 20.3521 16.8255 20.3384 16.853 20.3659C16.853 20.3521 16.8393 20.3384 16.8393 20.3384C16.8118 20.3109 16.7431 20.3384 16.7293 20.3521C16.7156 20.3659 16.7156 20.4346 16.7156 20.4621C16.7156 20.4758 16.7293 20.4758 16.7293 20.5033C16.7293 20.5171 16.7293 20.5171 16.7156 20.5308C16.7018 20.5308 16.6743 20.5171 16.6743 20.5445ZM16.8118 20.3934C16.8255 20.4071 16.8118 20.4071 16.8118 20.3934C16.8255 20.3934 16.8255 20.3934 16.8255 20.4071C16.8255 20.4071 16.8118 20.4208 16.798 20.4208C16.8118 20.4208 16.8255 20.4208 16.8118 20.3934C16.8255 20.4071 16.8255 20.4071 16.8118 20.3934ZM16.7843 20.3934C16.7843 20.4071 16.7843 20.4071 16.7843 20.3934C16.7843 20.4071 16.7843 20.4208 16.7843 20.4208C16.7568 20.4208 16.7431 20.4071 16.7431 20.4071C16.7431 20.4071 16.7706 20.4071 16.7843 20.3934ZM16.5644 20.4346C16.5644 20.4346 16.5919 20.4483 16.6056 20.4483C16.6606 20.4483 16.6743 20.4071 16.6743 20.4071C16.6743 20.3659 16.6469 20.3384 16.6194 20.3384C16.6056 20.3384 16.5781 20.3384 16.5781 20.3521C16.5644 20.3659 16.5506 20.3796 16.5506 20.3934C16.5644 20.3934 16.5919 20.3659 16.6331 20.3796C16.6606 20.3796 16.6743 20.4071 16.6606 20.4208C16.6469 20.4071 16.6469 20.4071 16.6331 20.4071C16.5919 20.3934 16.5644 20.4208 16.5506 20.4346C16.5506 20.4346 16.5506 20.4346 16.5369 20.4346C16.5369 20.4208 16.5506 20.4208 16.5644 20.4346ZM16.6194 20.3934C16.6194 20.3934 16.6331 20.3934 16.6469 20.4071C16.6469 20.4071 16.6331 20.4208 16.6194 20.4208C16.6194 20.4208 16.6331 20.4208 16.6194 20.3934C16.6331 20.4071 16.6331 20.4071 16.6194 20.3934ZM16.5919 20.3934C16.5919 20.4071 16.5919 20.4071 16.5919 20.3934C16.5919 20.4071 16.5919 20.4208 16.5919 20.4208C16.5644 20.4208 16.5506 20.4071 16.5506 20.4071C16.5506 20.4071 16.5781 20.4071 16.5919 20.3934Z"
        fill="black"
      />
      <path
        d="M16.7041 3.5L14.6699 18.7699L16.7041 17.6841V3.5Z"
        fill="#EF7D00"
      />
      <path
        d="M12.3597 20.8749L4.51172 18.3047L12.8133 23.0877L12.3597 20.8749Z"
        fill="#EF7D00"
      />
      <path
        d="M28.8954 18.3047L19.4531 19.3218L21.0612 20.8611L28.8954 18.3047Z"
        fill="#EF7D00"
      />
      <path
        d="M19.4238 25.9598L24.413 32.7082L20.3447 23.9531L19.4238 25.9598Z"
        fill="#EF7D00"
      />
      <path
        d="M8.99219 32.7075L16.2492 26.2752L13.9814 25.9453L8.99219 32.7075Z"
        fill="#EF7D00"
      />
      <path
        d="M16.9922 26.124L19.3012 25.7941L20.2358 23.7188L16.9922 26.124Z"
        fill="#EF7D00"
      />
      <path
        d="M13.1855 23.7188L14.1064 25.7804L16.4292 26.1103L13.1855 23.7188Z"
        fill="#EF7D00"
      />
      <path
        d="M14.2157 19.3906L12.5664 20.93L13.02 23.1703L14.2157 19.3906Z"
        fill="#EF7D00"
      />
      <path
        d="M19.2051 19.3906L20.8544 20.93L20.3871 23.1703L19.2051 19.3906Z"
        fill="#EF7D00"
      />
      <path
        d="M18.7639 19.0469L16.7023 17.9336L14.6406 19.0469H18.7639Z"
        fill="#EF7D00"
      />
    </svg>
  );
};
export const CanaraBank = (props) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.7282 29.8517L18.6523 24.6709L15.7024 24.2657L14.043 26.2657C13.682 26.7012 13.0797 26.4395 12.7659 26.2161L4.26376 20.1514C3.94201 19.922 4.21361 19.5193 4.54728 19.4642L13.0663 18.062L14.0842 16.3281L0.783061 18.5178C0.28752 18.5983 -0.0893493 19.1643 0.362992 19.5352L12.8379 29.7772C13.2788 30.1392 14.2237 30.52 14.7282 29.8517Z"
        fill="#FFB600"
      />
      <path
        d="M23.0248 4.14613L33.2613 22.7974C34.3055 24.6987 33.2563 26.6788 31.4663 26.4325L19.6002 24.8029L20.777 22.7949L29.3402 23.9012C30.2305 24.0234 30.1371 23.4116 29.7617 22.7259L22.5401 7.67003C22.3877 7.39297 21.8723 7.24848 21.6975 7.54789L13.7033 21.1658C13.4665 21.5695 13.4005 21.8381 13.9149 21.9086L17.2963 22.3456L15.7014 24.2672L11.4084 23.6773C10.608 23.5671 10.2579 22.8466 10.7321 22.0387L21.0297 4.49569C21.493 3.7072 22.3778 2.96836 23.0248 4.14613Z"
        fill="#019EEC"
      />
      <path
        d="M20.1374 22.7132L20.9675 21.6164L24.6295 16.7822C25.4443 15.7072 25.2735 14.4892 24.1667 14.6704L17.7078 15.734L16.8846 17.4361L20.3484 16.8656C21.0952 16.7429 21.2431 17.591 20.6607 18.2931L18.3136 21.1214L17.2967 22.3463L14.4883 25.7312L16.7987 27.12L20.1374 22.7132Z"
        fill="#FFB500"
      />
    </svg>
  );
};
export const CentralBankOfIndia = (props) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M31.3628 16.6339L23.0459 8.48408H21.0363H17.7413V7.53698H21.0363H23.0459L31.9199 16.5782L31.3628 16.6339ZM28.629 16.6896L23.0459 11.2736H21.0363H17.7413V10.3265L21.0363 10.2708H23.0459L29.2418 16.6339L28.629 16.6896ZM21.0363 28.6915L17.9642 31.7636L17.8528 31.095L21.0363 27.8558L25.9469 22.7781V17.4178H26.894L26.9497 22.8338L21.0363 28.6915ZM21.0363 25.0066L23.213 22.7184V17.3581H24.1601L24.2158 22.7741L21.0323 25.9019L17.9045 28.974L17.7931 28.3612L21.0363 25.0066ZM14.1718 18.6992L12.3851 16.8567L14.1718 15.1257L17.801 11.5522L21.096 15.0143L22.9941 17.0239L21.096 18.922L17.6339 22.3284L14.1718 18.6992ZM14.1718 26.6262H12.1065L3.23244 17.585L3.84527 17.4736L12.1622 25.6234H14.1718H17.4668V26.5705L14.1718 26.6262ZM6.57912 17.4696L12.1622 22.8855H14.1718H17.4668V23.8326L14.1718 23.8883H12.1065L5.91058 17.5253L6.57912 17.4696ZM17.3553 5.80595L14.1718 9.1566L11.9951 11.4448V16.805H11.048L10.9923 11.4448L14.1758 8.26124L17.3036 5.18914L17.3553 5.80595ZM14.1718 5.4677L17.2439 2.45529L17.3553 3.06812L14.2275 6.30735L9.31695 11.3851V16.7453H8.36985L8.31414 11.3851L14.1718 5.4677ZM23.2727 5.86166V0H17.3553L14.1718 3.40637L6.63483 11.3333H1V17.0836L11.8837 28.4169V34H17.411L20.9845 30.3708L28.3544 22.8895H33.8261V16.5822L23.2727 5.86166Z"
        fill="#CE0F3E"
      />
    </svg>
  );
};
export const HdfcBank = (props) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2762_11017)">
        <path d="M0 1.56817e-06H34V34H0V1.56817e-06Z" fill="#ED232A" />
        <path
          d="M5.95117 5.95229H28.0536V28.0547H5.95117V5.95229Z"
          fill="white"
        />
        <path
          d="M15.3008 1.56817e-06H18.6994V34H15.3008V1.56817e-06Z"
          fill="white"
        />
        <path d="M0 15.3045H34V18.7031H0V15.3045Z" fill="white" />
        <path
          d="M11.9023 11.9011H22.1027V22.1016H11.9023V11.9011Z"
          fill="#004C8F"
        />
      </g>
      <defs>
        <clipPath id="clip0_2762_11017">
          <rect width="34" height="34" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const IciciBank = (props) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.3625 7.95086C17.6696 0.697448 26.5343 -1.18505 30.0818 3.75887C33.6293 8.70279 30.5115 18.6954 23.2043 25.9488C15.8972 33.2559 7.03252 35.1357 3.43133 30.1381C-0.0597629 25.1431 3.05804 15.2016 10.3625 7.95086Z"
        fill="#F06321"
      />
      <path
        d="M15.1984 4.08303C14.3927 4.67384 13.5871 5.37205 12.7815 6.12666C6.3874 12.4643 3.69924 21.1679 6.87078 25.521C10.147 29.8714 17.9912 28.2602 24.5464 21.8661C28.0939 18.4287 30.4571 14.4516 31.4239 10.7456C31.6924 8.00649 31.3165 5.58689 30.0812 3.76078C27.2883 -0.106272 21.2702 0.213295 15.1984 4.08303Z"
        fill="#AE282E"
      />
      <path
        d="M24.4404 4.8876V5.04873C24.3868 5.96178 23.8496 7.08966 22.8828 8.05643C21.4327 9.45286 19.4991 9.98995 18.6908 9.187C17.7778 8.32766 18.3176 6.44516 19.7677 4.94131C21.2715 3.49116 23.2051 3.00778 24.0107 3.86712C24.2792 4.13567 24.4404 4.45792 24.4404 4.8876ZM18.8546 29.5481C15.4145 32.1262 11.8697 33.4179 8.42969 32.8808C9.87983 32.9345 11.0641 31.3205 12.0309 29.1722C12.9976 26.9701 13.5347 24.9291 14.0181 22.9929C14.7163 19.9315 14.77 17.7831 14.3941 17.2998C13.8033 16.5452 12.5142 16.709 11.0077 17.5683C10.2558 17.998 9.28902 17.7294 10.4196 16.333C11.6012 14.9366 16.1665 11.6039 17.7777 11.0668C19.6065 10.5834 21.6475 11.2817 20.9493 13.2689C20.4632 14.719 14.1255 31.2668 18.8546 29.5481Z"
        fill="white"
      />
    </svg>
  );
};
export const IdbiBank = (props) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.0025 32.3361C19.1024 32.3361 21.2022 31.7529 22.9521 30.6446C24.002 30.003 24.9936 29.1864 25.7519 28.2531C26.2768 27.6698 26.6268 27.0282 27.0351 26.3866C27.6767 25.1034 28.2017 23.7035 28.3183 22.2452C28.4933 20.612 28.3767 18.9788 27.91 17.4039C27.5601 16.2374 27.0351 15.0708 26.3351 14.0792C25.4019 12.6793 24.177 11.4544 22.7188 10.5794C22.3688 10.3461 22.1355 10.1711 21.7855 9.93783C21.3189 9.58785 20.5023 9.17955 19.919 9.64618C19.3357 10.2295 19.3357 11.1627 19.2774 11.921C19.2774 17.4623 19.219 22.9452 19.2774 28.4864C19.219 28.9531 19.394 29.5364 18.9274 29.7697C18.4607 30.0613 17.8775 30.2363 17.2942 30.353C16.8275 30.4696 16.3609 30.2946 15.8943 30.178C15.486 30.0613 15.0777 29.8863 14.786 29.5947C14.3777 29.2447 14.611 28.6031 14.5527 28.0781L14.5527 11.1627C14.4944 10.5794 14.3777 9.82117 13.8528 9.47119C13.6194 9.35454 13.3278 9.35454 13.0361 9.47119C12.3945 9.64618 11.8696 10.2295 11.2863 10.5211C10.353 11.1044 9.47808 11.746 8.71981 12.621C8.07819 13.2626 7.55323 14.0209 7.0866 14.8375C6.38665 16.0624 5.86169 17.4039 5.62837 18.8038C5.39506 20.0871 5.39506 21.4286 5.57005 22.7119C5.86169 24.6951 6.73662 26.5616 7.96153 28.1365C9.18644 29.7113 10.878 30.8196 12.6862 31.6362C14.0861 32.0445 15.5443 32.3361 17.0025 32.3361ZM17.0025 6.49642H17.4691C17.5858 6.49642 17.6441 6.43809 17.7608 6.43809L17.9941 6.32143C18.0524 6.26311 18.1691 6.26311 18.2274 6.20478L18.4607 6.08812L18.6357 5.91313C18.7524 5.8548 18.7524 5.73814 18.869 5.67981L19.044 5.50483C19.1024 5.38817 19.1607 5.32985 19.219 5.21319L19.3357 4.97987L19.4523 4.74655L19.5107 4.51323C19.569 4.39658 19.5107 4.27992 19.569 4.22159V3.52164C19.5107 3.40499 19.5107 3.28833 19.5107 3.17167L19.4523 2.93835C19.394 2.70504 19.2773 2.53005 19.1607 2.35506L18.9857 2.18008C18.9274 2.06342 18.8107 2.00509 18.7524 1.88843C18.6357 1.88843 18.5774 1.77178 18.5191 1.71345L18.3441 1.59679C18.2858 1.53846 18.2274 1.48013 18.1691 1.48013C18.0524 1.4218 17.9358 1.36347 17.7608 1.30514C17.7025 1.24681 17.6441 1.18849 17.5275 1.24682L16.7109 1.24682C16.5942 1.30515 16.4776 1.24681 16.3609 1.30514C16.2442 1.36347 16.1276 1.36348 16.0109 1.42181L15.7776 1.53846C15.661 1.53846 15.6026 1.65512 15.5443 1.65512L15.311 1.83011C15.1943 1.83011 15.1943 1.94677 15.136 2.0051L14.961 2.18008C14.8443 2.29673 14.7277 2.47172 14.6694 2.64671C14.6694 2.70504 14.611 2.76337 14.5527 2.88003L14.436 3.11334C14.436 3.23 14.436 3.28833 14.3777 3.40499C14.3777 3.6383 14.3194 3.81329 14.3777 4.04661C14.3777 4.16327 14.3777 4.27992 14.436 4.33825C14.436 4.45491 14.4944 4.57156 14.5527 4.68822C14.5527 4.80488 14.611 4.80489 14.6694 4.92154L14.786 5.15486C14.8443 5.27151 14.961 5.38817 15.0193 5.50483L15.1943 5.67981L15.3693 5.8548L15.6026 6.02979C15.7193 6.08812 15.8359 6.08812 15.8943 6.20478L16.1276 6.2631L16.3609 6.32143C16.4776 6.32143 16.5359 6.37977 16.6525 6.37977C16.7109 6.49642 16.8859 6.43809 17.0025 6.49642Z"
        fill="#F58220"
      />
      <path
        d="M22.6033 1.83075C22.8949 1.18913 23.6532 0.722493 24.2948 1.18912C25.578 2.00573 26.5696 3.23064 27.6779 4.28056C29.1361 5.68046 30.4193 7.25534 31.3526 9.06353C32.2859 10.9301 32.8691 12.9716 32.9275 15.0714C33.1608 17.1713 32.8108 19.3294 32.1692 21.3126C30.886 25.104 28.2028 28.4288 24.7031 30.3536C19.8035 33.0951 13.5039 32.9201 8.72096 30.0036C4.1713 27.3205 1.25486 22.1875 1.02154 16.9379C0.904885 14.5465 1.25486 12.0966 2.24645 9.88014C3.17971 7.66364 4.7546 5.73878 6.50447 4.10557C7.49606 3.11398 8.42932 2.00573 9.5959 1.24746C10.1209 0.839154 10.8791 0.955812 11.1708 1.5391C11.7541 2.47236 12.1624 3.63894 12.104 4.74719C11.9874 6.61372 10.2958 7.78029 9.01261 8.88854C7.43773 10.1718 6.3878 11.9217 5.51287 13.6715C4.69627 15.4214 4.28796 17.2879 4.34629 19.2711C4.34629 23.4125 6.38781 27.5538 9.77089 30.0036C11.9874 31.5785 14.6705 32.4534 17.3536 32.3368C21.0867 32.2785 24.5864 30.3536 26.8613 27.4372C28.8445 24.8707 29.8944 21.5459 29.6611 18.2795C29.5444 16.2963 28.9611 14.3715 28.0278 12.6216C27.1529 11.0467 25.9863 9.64683 24.6448 8.53858C23.5948 7.60531 22.3699 6.67205 22.02 5.27215C21.7283 4.10557 22.1366 2.939 22.6033 1.83075Z"
        fill="#F58220"
      />
    </svg>
  );
};
export const IndianBank = (props) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8641 18.826C17.8851 18.847 17.9061 18.868 17.9271 18.8891C25.9768 7.20345 40.2265 18.1955 28.6249 28.9563L30.8107 30.995L30.0541 31.7306L19.9868 30.932L19.7556 25.5095C17.8221 31.4784 6.40968 34.0215 3.59336 22.0206L0.587891 22.6091L5.25373 14.7276L5.92628 13.992L11.0125 17.0395C4.81236 12.2476 9.49921 0.51996 22.677 5.24885L23.0554 3.65154L23.7279 3L28.9192 11.7642L28.1626 12.5629L18.4736 16.1989L19.6085 13.1303C15.4681 11.5961 13.6817 16.2619 17.8851 18.9731C17.8641 18.9311 17.8641 18.868 17.8641 18.826ZM12.6518 18.0274L15.4681 19.7087L14.6484 20.4443L12.1684 20.3813C12.3996 24.0803 18.0743 24.1644 17.8851 18.9941C15.7834 19.0152 14.0389 18.6579 12.6518 18.0274ZM17.9482 18.9311C18.7889 19.8979 19.3563 20.8647 19.6926 21.7895L20.3441 21.0959L22.593 23.2817C25.6615 20.4443 22.1937 16.1148 17.9482 18.9311Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3603 19.728C25.8302 30.3837 6.83062 38.8957 3.06852 22.9226L0 23.427L5.25432 14.7469L14.649 20.5056L11.4124 21.1571C12.2321 25.1715 17.1711 24.604 17.3603 19.728C17.3182 19.749 17.2972 19.77 17.2762 19.791C2.39597 20.0853 5.54856 0.160886 22.1522 6.06674L22.9719 3.79688L28.0791 12.5611L17.8647 17.0167L19.0627 13.9482C14.8592 12.414 13.0517 17.0798 17.2552 19.791C24.7794 7.51693 39.8067 19.0554 28.0791 29.8583L29.8866 31.7499L19.441 31.8129L19.6722 21.8928L22.0051 24.1626C25.1367 21.2622 21.6058 16.9117 17.3603 19.728Z"
        fill="#F4BB4F"
      />
    </svg>
  );
};
export const KotakMahindra = (props) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 16.7611C1 9.16162 8.16312 3 17.0003 3C25.8375 3 33 9.16162 33 16.7611C33 24.3606 25.8369 30.5222 17.0003 30.5222C8.16373 30.5222 1 24.3615 1 16.7611Z"
        fill="#003874"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2866 7.41183L19.0039 6.18359L19.0222 26.2787L15.2734 27.5347L15.2866 7.41183Z"
        fill="#ED1C24"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.0327 18.1454C28.684 21.02 27.0715 23.9241 23.5507 23.9296C21.4952 23.9332 19.8895 22.5259 18.7775 20.8039V18.8094C20.169 19.5003 21.4696 20.2418 23.0475 20.2644C24.9913 20.2931 26.749 19.5458 27.4759 18.1451H29.0331L29.0327 18.1454ZM17.2631 19.9504C15.6479 21.8973 14.087 23.8859 11.1625 23.8859C7.03164 23.8859 5.07227 19.8921 5.07227 16.5531C5.07227 13.3448 6.60352 9.54688 10.6279 9.54688C12.3733 9.54688 14.0535 10.6143 15.055 11.7434L15.0519 14.4668C14.2152 13.9035 12.341 13.3509 11.1173 13.3311C8.56533 13.2883 6.31545 14.3945 6.35451 16.9135C6.38106 18.6477 8.09937 19.8265 9.80882 19.8265C12.427 19.8265 14.0132 17.4347 15.3388 15.6194C15.8702 14.9264 16.3956 14.2288 16.9149 13.5267C18.3872 11.4693 20.0909 9.59112 23.0155 9.59112C26.4606 9.59112 28.3947 12.368 28.9415 15.2267H27.3852C26.7597 14.2996 25.5565 13.7323 24.3713 13.7323C21.6646 13.7323 20.0473 16.2224 18.6936 18.0557L17.2594 19.9501"
        fill="white"
      />
    </svg>
  );
};
export const PunjabNational = (props) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2762_10973)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.343 0.457376H4.65616C3.53427 0.468674 2.46241 0.923361 1.67459 1.72217C0.886764 2.52098 0.446964 3.59904 0.451203 4.72097V29.2987C0.446888 30.4207 0.886674 31.4988 1.67453 32.2976C2.46239 33.0965 3.53432 33.5512 4.65626 33.5624H29.3431C30.4664 33.5547 31.5406 33.1012 32.3297 32.3017C33.1187 31.5021 33.558 30.422 33.5508 29.2987V4.7131C33.5581 3.58975 33.1188 2.5095 32.3298 1.70991C31.5407 0.910325 30.4663 0.456855 29.343 0.449219"
          fill="#9F1A45"
        />
        <path
          d="M29.3434 33.9841H4.65657C3.41876 33.9764 2.23457 33.4779 1.36379 32.5982C0.493022 31.7184 0.00678781 30.5291 0.0117682 29.2913V4.7111C0.00607401 3.47281 0.491993 2.28287 1.36284 1.40252C2.23369 0.522168 3.41829 0.0233669 4.65657 0.015625H29.3433C30.5816 0.0233922 31.7662 0.522202 32.637 1.40255C33.5079 2.28289 33.9938 3.47282 33.9881 4.7111V29.2886C33.9931 30.5264 33.5069 31.7157 32.6361 32.5955C31.7653 33.4752 30.5811 33.9737 29.3433 33.9814M4.65657 0.892434C3.65083 0.900171 2.68923 1.30659 1.9828 2.0225C1.27637 2.73842 0.882808 3.70534 0.888481 4.7111V29.2886C0.882859 30.2944 1.27643 31.2613 1.98285 31.9772C2.68927 32.6931 3.65084 33.0996 4.65657 33.1074H29.3433C30.349 33.0996 31.3106 32.6931 32.017 31.9772C32.7234 31.2613 33.117 30.2944 33.1114 29.2886V4.7111C33.1163 3.70557 32.7225 2.73909 32.0162 2.02333C31.3099 1.30757 30.3488 0.900884 29.3433 0.892338L4.65657 0.892434Z"
          fill="#9F1A45"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.2062 7.30364C18.213 7.3194 19.1927 7.63234 20.0222 8.20315C20.8517 8.77397 21.494 9.57719 21.8684 10.5119C22.2428 11.4466 22.3326 12.4711 22.1266 13.4568C21.9206 14.4424 21.4278 15.3451 20.7103 16.0516C19.9928 16.758 19.0826 17.2367 18.0939 17.4274C17.1052 17.6182 16.0822 17.5124 15.1534 17.1236C14.2246 16.7347 13.4314 16.08 12.8735 15.2418C12.3156 14.4035 12.0179 13.4191 12.0178 12.4122C12.0224 11.7359 12.1603 11.0671 12.4236 10.4442C12.6869 9.8212 13.0705 9.25628 13.5524 8.78172C14.0343 8.30724 14.6051 7.93247 15.2321 7.67885C15.8591 7.42524 16.5299 7.29767 17.2062 7.30364ZM23.2101 4.78013H29.2378V29.235H23.2074V22.3065C17.8991 24.2465 12.9372 24.4171 8.37236 19.9508C6.48562 17.9869 5.42244 15.3087 5.86746 10.6399C5.94472 9.92581 5.60094 6.6134 4.76953 4.77734H10.1125C12.6201 8.75859 9.3317 13.8377 13.1744 17.0835C18.4081 20.4731 22.9756 16.4199 23.1967 12.7611L23.2101 4.78013Z"
          fill="#FEBD30"
        />
      </g>
      <defs>
        <clipPath id="clip0_2762_10973">
          <rect width="34" height="34" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Sbi = (props) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2762_11047)">
        <path
          d="M15.9124 33.9306C11.5251 33.6481 7.41963 31.6702 4.46438 28.4152C1.50914 25.1602 -0.0642042 20.8834 0.0771187 16.4893C0.218442 12.0952 2.06335 7.92827 5.22164 4.86992C8.37994 1.81157 12.604 0.101563 17.0004 0.101562C21.3968 0.101563 25.6208 1.81157 28.7791 4.86992C31.9374 7.92827 33.7823 12.0952 33.9236 16.4893C34.0649 20.8834 32.4916 25.1602 29.5364 28.4152C26.5811 31.6702 22.4757 33.6481 18.0884 33.9306V20.0586C18.7572 19.8041 19.3157 19.3233 19.6668 18.6997C20.0179 18.0761 20.1393 17.3492 20.01 16.6454C19.8806 15.9416 19.5087 15.3053 18.9588 14.8473C18.409 14.3893 17.716 14.1385 17.0004 14.1385C16.2848 14.1385 15.5918 14.3893 15.0419 14.8473C14.4921 15.3053 14.1201 15.9416 13.9908 16.6454C13.8614 17.3492 13.9828 18.0761 14.3339 18.6997C14.685 19.3233 15.2435 19.8041 15.9124 20.0586"
          fill="#1166DD"
        />
      </g>
      <defs>
        <clipPath id="clip0_2762_11047">
          <rect width="34" height="34" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Uco = (props) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2762_11011)">
        <path
          d="M29.0655 28.2496H23.5453V22.0263L28.2452 17.0921L18.6152 6.63762V9.27843L24.7213 16.4434L18.6152 22.7253V34H29.0697L34.707 28.3626V5.81315L29.0111 0H6.69596L1 5.81315V28.3626L6.57878 34H17.0918V22.7253L10.9857 16.4434L17.0918 9.27843V6.63762L7.46184 17.0921L12.1576 22.0263V28.2496H6.63737V5.70015H28.8939L29.0655 28.2496ZM13.6223 16.096C13.6223 13.6896 15.5601 11.7518 17.9079 11.7518C20.3144 11.7518 22.1935 13.6896 22.1935 16.096C22.1935 18.5025 20.2558 20.4402 17.9079 20.4402C15.5601 20.3816 13.6223 18.4439 13.6223 16.096Z"
          fill="#0044AA"
        />
      </g>
      <defs>
        <clipPath id="clip0_2762_11011">
          <rect width="34" height="34" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const UnionBankOfIndia = (props) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.072 2.43359H24.6053C24.7336 2.47312 24.8699 2.45571 25.0006 2.47865C26.7448 2.64837 28.4739 3.17192 29.9505 4.12889C30.5456 4.51339 31.088 4.9764 31.5792 5.48612C31.9557 5.91208 32.3159 6.35629 32.6086 6.84528C32.7979 7.13497 32.9442 7.44899 33.0992 7.75748C33.5484 8.72053 33.8168 9.76319 33.923 10.8188C33.952 10.9894 33.9387 11.1635 33.9691 11.3341C33.9854 11.5414 33.9713 11.7496 33.9755 11.9577C33.97 12.1979 33.9929 12.4401 33.9525 12.6781C33.9285 13.2931 33.8342 13.9034 33.7195 14.508C33.6562 14.8684 33.5448 15.2178 33.4732 15.5763C32.7473 18.4821 32.0204 21.3881 31.2939 24.2938C31.1751 24.8323 31.0297 25.3644 30.9 25.9004C30.8107 26.2443 30.7239 26.5981 30.5241 26.8977C30.3781 27.1327 30.186 27.3356 29.9751 27.5133C29.4706 27.9161 28.8208 28.1049 28.1811 28.111C27.9094 28.0866 27.6352 28.0515 27.3762 27.9609C27.1059 27.8544 26.8336 27.7259 26.6368 27.5056C26.3515 27.254 26.197 26.8759 26.1735 26.5011C26.142 26.2656 26.2078 26.0309 26.2658 25.8045C26.6102 24.4271 26.9541 23.0497 27.2991 21.6725C27.4492 21.091 27.5788 20.5044 27.7284 19.9228C28.2295 17.9168 28.732 15.9108 29.2329 13.9043C29.3545 13.4131 29.4297 12.9111 29.4651 12.4066C29.4565 12.018 29.4872 11.6274 29.4369 11.2412C29.3855 10.758 29.2766 10.2782 29.0872 9.82926C28.9214 9.39334 28.666 8.99557 28.3589 8.64617C28.2718 8.51432 28.1308 8.4372 28.0255 8.32331C27.9768 8.27243 27.9241 8.22548 27.8679 8.18289C27.544 7.93632 27.1982 7.71104 26.8195 7.55817C26.4903 7.39592 26.1389 7.28203 25.784 7.19053C25.2928 7.04984 24.7861 6.95889 24.2753 6.93512C24.0472 6.89393 23.8151 6.91964 23.5853 6.91107C23.4043 6.9025 23.2277 6.95032 23.0472 6.94507C22.201 7.02422 21.3691 7.21514 20.5732 7.51284C20.0474 7.69583 19.5496 7.94627 19.06 8.2086C18.4774 8.55523 17.9115 8.93697 17.412 9.39721C17.2395 9.57301 17.0629 9.74495 16.8901 9.92047C16.5535 10.3133 16.237 10.734 16.0371 11.215C15.8215 11.9171 15.6396 12.6294 15.4417 13.337C15.2012 14.2523 14.9544 15.1656 14.7244 16.0836C14.4468 17.1218 14.195 18.1672 13.9015 19.2016C13.7688 19.6353 13.635 20.069 13.5007 20.5024C13.4393 20.7396 13.3895 20.984 13.2759 21.2032C12.9188 21.9855 12.1434 22.5452 11.3023 22.6917C10.7293 22.8034 10.107 22.7263 9.60809 22.412C9.46297 22.3 9.3054 22.1964 9.20009 22.0432C8.97895 21.785 8.85428 21.4561 8.80923 21.1216C8.80287 20.9641 8.74095 20.801 8.80895 20.6481C9.49392 18.4027 10.0382 16.1178 10.6372 13.8487C10.9703 12.5689 11.3023 11.2888 11.6752 10.0197C11.7575 9.70901 11.893 9.41545 12.0406 9.13101C12.4431 8.28738 12.9981 7.52362 13.6206 6.82925C13.8647 6.586 14.1077 6.34137 14.3523 6.09839C14.7404 5.76807 15.1235 5.43 15.5451 5.14197C15.7563 4.9681 15.9984 4.83984 16.2223 4.68422C17.1171 4.11673 18.0771 3.65593 19.073 3.29548C19.3191 3.21366 19.5584 3.11083 19.8103 3.0467C20.3396 2.88997 20.8745 2.74927 21.4182 2.65363C21.8392 2.56545 22.2676 2.52647 22.6933 2.46842C22.8194 2.45405 22.9496 2.47423 23.072 2.43359Z"
        fill="#00579C"
      />
      <path
        d="M5.25809 6.79997C5.40736 6.79471 5.55386 6.75961 5.70313 6.76182C6.09233 6.7972 6.48817 6.8547 6.84448 7.02497C7.088 7.15627 7.33153 7.31162 7.48163 7.55156C7.69724 7.82438 7.71189 8.19783 7.64389 8.52539C7.45177 9.27035 7.27735 10.0208 7.07529 10.7636C6.85166 11.6633 6.6261 12.5628 6.40137 13.4623C6.23414 14.1467 6.04617 14.8256 5.8817 15.5106C5.6871 16.2912 5.49001 17.0707 5.29679 17.8519C5.129 18.4677 4.98084 19.0891 4.82494 19.7086C4.64858 20.3745 4.50982 21.0556 4.50014 21.7466C4.46697 21.9263 4.47527 22.1088 4.50208 22.2884C4.51286 23.0113 4.6754 23.7305 4.97614 24.3878C5.12209 24.6532 5.26583 24.9227 5.45988 25.1571C5.60998 25.3255 5.74598 25.5079 5.92427 25.6483C6.12163 25.8004 6.30573 25.9717 6.52549 26.0928C6.75547 26.2393 7.0001 26.3593 7.24667 26.4754C7.80145 26.6938 8.3764 26.864 8.96435 26.966C9.51194 27.0448 10.0673 27.0984 10.6207 27.0542C12.0069 26.9707 13.3694 26.5727 14.5992 25.93C15.329 25.5607 15.9976 25.0778 16.6077 24.5355C16.9532 24.2015 17.2841 23.8488 17.5497 23.4466C17.7114 23.2006 17.8853 22.9527 17.9602 22.6638C18.6889 20.1467 19.3058 17.5998 19.9809 15.0688C20.1193 14.5693 20.2866 14.0784 20.4328 13.5811C20.5721 13.122 20.7886 12.6789 21.11 12.319C21.2806 12.0901 21.5158 11.9207 21.7527 11.7664C22.2622 11.4397 22.8855 11.3159 23.484 11.3731C23.7709 11.4076 24.0581 11.4778 24.3132 11.6183C24.6306 11.7667 24.9081 12.0124 25.0706 12.3251C25.2304 12.6197 25.2337 12.9749 25.1629 13.2953C24.7085 14.8093 24.3046 16.3379 23.9146 17.8695C23.3767 19.9303 22.8592 21.9971 22.266 24.0431C22.2149 24.2284 22.1378 24.4053 22.056 24.5789C21.9147 24.9194 21.7295 25.2401 21.539 25.5555C21.2007 26.1077 20.8148 26.6321 20.3726 27.1056C20.192 27.332 19.9698 27.52 19.7716 27.7303C19.3758 28.0922 18.9664 28.4418 18.5316 28.7581C17.8485 29.2634 17.1108 29.6915 16.3512 30.0702C15.999 30.2278 15.6518 30.3964 15.29 30.5324C14.976 30.6687 14.6454 30.761 14.3242 30.8782C13.8272 31.0394 13.3202 31.1629 12.811 31.2766C12.6175 31.3147 12.4213 31.3393 12.2286 31.3808C11.9317 31.4338 11.6307 31.4559 11.3333 31.5018C11.1807 31.5292 11.022 31.4949 10.873 31.5433H9.33973C9.28318 31.5267 9.22477 31.5172 9.16587 31.5151C8.94639 31.511 8.73161 31.459 8.51268 31.4471C7.85037 31.3573 7.19304 31.2238 6.557 31.0175C5.84051 30.8102 5.15747 30.4998 4.50236 30.146C4.02967 29.8756 3.58464 29.5605 3.16199 29.2175C3.03179 29.0992 2.88833 28.9944 2.76864 28.8637C2.57984 28.6649 2.36921 28.4861 2.19866 28.2699C1.05704 26.9735 0.339999 25.3255 0.102829 23.6183C0.0552843 23.3479 0.0475445 23.0721 0 22.802V21.2369C0.0279186 21.1327 0.0254308 21.0246 0.0364877 20.9188C0.11665 20.1511 0.231088 19.3832 0.441169 18.6391C0.766241 17.3601 1.07335 16.0761 1.40975 14.8002C1.66572 13.7727 1.92279 12.7458 2.17986 11.7186C2.42173 10.8166 2.6354 9.90694 2.86649 9.00222C2.92731 8.77831 2.96213 8.54502 3.06469 8.33521C3.18161 8.09555 3.30628 7.85175 3.50088 7.66516C3.5968 7.57256 3.68664 7.4736 3.78753 7.38626C4.20271 7.04653 4.72819 6.85691 5.25809 6.79997Z"
        fill="#DA251C"
      />
    </svg>
  );
};

/* <----- BANK ICONS END -----> */

export const personLogo = (props) => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="37.931" height="38" rx="18.9655" fill="#7367F0" />
      <rect
        width="37.931"
        height="38"
        rx="18.9655"
        fill="white"
        fill-opacity="0.5"
      />
      <mask
        id="mask0_2698_18785"
        masktype="luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="38"
        height="38"
      >
        <rect width="37.931" height="38" rx="18.9655" fill="white" />
      </mask>
      <g mask="url(#mask0_2698_18785)">
        <rect
          x="-0.161133"
          y="2.26953"
          width="38.0923"
          height="35.8893"
          fill="url(#pattern0_2698_18785)"
        />
      </g>
      <defs>
        <pattern
          id="pattern0_2698_18785"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use transform="scale(0.00378788 0.00401606)" />
        </pattern>
        <image id="image0_2698_18785" width="264" height="249" />
      </defs>
    </svg>
  );
};

/* <----- Dashboard-Square-02 Icon -----> */
export const DashboardSquare02Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M2 6C2 4.11438 2 3.17157 2.58579 2.58579C3.17157 2 4.11438 2 6 2C7.88562 2 8.82843 2 9.41421 2.58579C10 3.17157 10 4.11438 10 6V8C10 9.88562 10 10.8284 9.41421 11.4142C8.82843 12 7.88562 12 6 12C4.11438 12 3.17157 12 2.58579 11.4142C2 10.8284 2 9.88562 2 8V6Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M2 19C2 18.0681 2 17.6022 2.15224 17.2346C2.35523 16.7446 2.74458 16.3552 3.23463 16.1522C3.60218 16 4.06812 16 5 16H7C7.93188 16 8.39782 16 8.76537 16.1522C9.25542 16.3552 9.64477 16.7446 9.84776 17.2346C10 17.6022 10 18.0681 10 19C10 19.9319 10 20.3978 9.84776 20.7654C9.64477 21.2554 9.25542 21.6448 8.76537 21.8478C8.39782 22 7.93188 22 7 22H5C4.06812 22 3.60218 22 3.23463 21.8478C2.74458 21.6448 2.35523 21.2554 2.15224 20.7654C2 20.3978 2 19.9319 2 19Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M14 16C14 14.1144 14 13.1716 14.5858 12.5858C15.1716 12 16.1144 12 18 12C19.8856 12 20.8284 12 21.4142 12.5858C22 13.1716 22 14.1144 22 16V18C22 19.8856 22 20.8284 21.4142 21.4142C20.8284 22 19.8856 22 18 22C16.1144 22 15.1716 22 14.5858 21.4142C14 20.8284 14 19.8856 14 18V16Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M14 5C14 4.06812 14 3.60218 14.1522 3.23463C14.3552 2.74458 14.7446 2.35523 15.2346 2.15224C15.6022 2 16.0681 2 17 2H19C19.9319 2 20.3978 2 20.7654 2.15224C21.2554 2.35523 21.6448 2.74458 21.8478 3.23463C22 3.60218 22 4.06812 22 5C22 5.93188 22 6.39782 21.8478 6.76537C21.6448 7.25542 21.2554 7.64477 20.7654 7.84776C20.3978 8 19.9319 8 19 8H17C16.0681 8 15.6022 8 15.2346 7.84776C14.7446 7.64477 14.3552 7.25542 14.1522 6.76537C14 6.39782 14 5.93188 14 5Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
  </svg>
);

/* <----- Back Arrow Icon -----> */
export const BackArrowIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M11.5 18C11.5 18 5.50001 13.5811 5.5 12C5.49999 10.4188 11.5 6 11.5 6"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5 18C18.5 18 12.5 13.5811 12.5 12C12.5 10.4188 18.5 6 18.5 6"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Category Icon -----> */
export const CategoryIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M3 4.5C3 3.67157 3.67157 3 4.5 3H6.5C7.32843 3 8 3.67157 8 4.5V6.5C8 7.32843 7.32843 8 6.5 8H4.5C3.67157 8 3 7.32843 3 6.5V4.5Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M3 17.5C3 16.6716 3.67157 16 4.5 16H6.5C7.32843 16 8 16.6716 8 17.5V19.5C8 20.3284 7.32843 21 6.5 21H4.5C3.67157 21 3 20.3284 3 19.5V17.5Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M8.00002 18.5H21M16 5.5H8.00002M16.3235 7.67649L7.64868 16.3513"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 4.5C16 3.67157 16.6716 3 17.5 3H19.5C20.3284 3 21 3.67157 21 4.5V6.5C21 7.32843 20.3284 8 19.5 8H17.5C16.6716 8 16 7.32843 16 6.5V4.5Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M18 21L19.3883 20.0537C20.4628 19.3213 21 18.9551 21 18.5C21 18.0449 20.4628 17.6787 19.3883 16.9463L18 16"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Product Icon -----> */
export const ProductIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M9.5 9C8.0449 8.5 7.26946 7.98853 7.5 6C7.62989 4.87968 8 4 7 3L9.5 2C9.66667 3.16667 10.5 4.5 12 5C13.5 4.5 14.3333 3.16667 14.5 2L17 3C16 4 16.3701 4.87968 16.5 6C16.7305 7.98853 15.9551 8.5 14.5 9"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 12H15.5C15 11 15 10 15 9H9C9 10 9 11 8.5 12Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.3124 21.4483C17.5989 22.1839 19.2888 22.1672 20.5946 21.4316C20.9541 21.2254 21.142 20.7479 20.8721 20.4605C18.9447 18.4075 17.4975 15.9016 16.4925 13.3545C16.2273 12.6825 16.0947 12.3465 15.8401 12.1732C15.5855 12 15.2432 12 14.5585 12H9.44152C8.75684 12 8.41451 12 8.1599 12.1732C7.90529 12.3465 7.77271 12.6825 7.50755 13.3545C6.50254 15.9016 5.05527 18.4075 3.12788 20.4605C2.85805 20.7479 3.04595 21.2254 3.40544 21.4316C4.71122 22.1672 6.40105 22.1839 7.68763 21.4483C8.49414 20.9969 9.51189 20.9969 10.2992 21.4483C10.8231 21.7434 11.4622 22 12 22C12.5378 22 13.1769 21.7434 13.7008 21.4483C14.4881 20.9969 15.5059 20.9969 16.3124 21.4483Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
  </svg>
);

/* <----- Blog Icon -----> */
export const BlogIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M19.7502 11V10C19.7502 6.22876 19.7502 4.34315 18.5786 3.17157C17.407 2 15.5214 2 11.7502 2H10.7503C6.97907 2 5.09346 2 3.92189 3.17156C2.75032 4.34312 2.7503 6.22872 2.75027 9.99993L2.75024 14C2.7502 17.7712 2.75019 19.6568 3.92172 20.8284C5.09329 21.9999 6.97897 22 10.7502 22"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.25024 7H15.2502M7.25024 12H15.2502"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M13.2502 20.8268V22H14.4236C14.833 22 15.0377 22 15.2217 21.9238C15.4058 21.8475 15.5505 21.7028 15.84 21.4134L20.6636 16.5894C20.9366 16.3164 21.0731 16.1799 21.1461 16.0327C21.285 15.7525 21.285 15.4236 21.1461 15.1434C21.0731 14.9961 20.9366 14.8596 20.6636 14.5866C20.3905 14.3136 20.254 14.1771 20.1067 14.1041C19.8265 13.9653 19.4975 13.9653 19.2173 14.1041C19.0701 14.1771 18.9335 14.3136 18.6605 14.5866L18.6605 14.5866L13.8369 19.4106C13.5474 19.7 13.4027 19.8447 13.3265 20.0287C13.2502 20.2128 13.2502 20.4174 13.2502 20.8268Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Gallery Icon -----> */
export const GalleryIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M6 17.9745C6.1287 19.2829 6.41956 20.1636 7.07691 20.8209C8.25596 22 10.1536 22 13.9489 22C17.7442 22 19.6419 22 20.8209 20.8209C22 19.6419 22 17.7442 22 13.9489C22 10.1536 22 8.25596 20.8209 7.07691C20.1636 6.41956 19.2829 6.1287 17.9745 6"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M2 10C2 6.22876 2 4.34315 3.17157 3.17157C4.34315 2 6.22876 2 10 2C13.7712 2 15.6569 2 16.8284 3.17157C18 4.34315 18 6.22876 18 10C18 13.7712 18 15.6569 16.8284 16.8284C15.6569 18 13.7712 18 10 18C6.22876 18 4.34315 18 3.17157 16.8284C2 15.6569 2 13.7712 2 10Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M2 11.1185C2.61902 11.0398 3.24484 11.001 3.87171 11.0023C6.52365 10.9533 9.11064 11.6763 11.1711 13.0424C13.082 14.3094 14.4247 16.053 15 18"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinejoin="round"
    />
    <path
      d="M12.9998 7H13.0088"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Testimonial Icon -----> */
export const TestimonialIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M6.51331 16H10.5133M6.51331 11H14.5133"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M10.0133 22H11.0133"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M7.50993 22C6.36069 21.975 5.58621 22 4.58688 21.775C3.53758 21.5 2.88801 20.85 2.66317 19.55C2.43831 18.7 2.5106 14.9238 2.51327 11.325C2.51533 8.53219 2.53385 5.99934 2.7631 5.475C3.08789 4.35 3.83739 3.55 6.16084 3.525M16.0292 3.525C16.8287 3.6 18.9184 3.525 19.327 5.825C19.5491 7.075 19.5019 8.85 19.5019 10.975M8.18449 5.5C9.23379 5.525 12.6065 5.5 13.7558 5.5C14.905 5.5 15.5123 4.55409 15.5046 3.675C15.4967 2.77925 14.7051 2.08017 13.9307 2C12.9813 2 8.95897 2 8.1595 2C7.23512 2.05 6.61054 2.8 6.5106 3.55C6.41067 4.575 7.16017 5.45 8.18449 5.5Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M18.2776 14.375C16.9035 15.775 14.2553 18.275 14.2553 18.45C14.0417 18.7468 13.8555 19.35 13.7306 20.2C13.5737 20.9879 13.3858 21.675 13.6057 21.875C13.8256 22.075 14.6535 21.9064 15.5294 21.725C16.229 21.65 16.8785 21.4 17.2033 21.15C17.678 20.7298 20.9009 17.475 21.2756 17.05C21.5504 16.675 21.5754 15.975 21.3356 15.55C21.2007 15.25 20.3512 14.45 20.0764 14.225C19.5767 13.925 18.8772 13.875 18.2776 14.375Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
  </svg>
);

/* <----- Inquiry Icon -----> */
export const InquiryIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M22 7.28342C22 9.92499 19.7611 12.0668 17 12.0668C16.6753 12.0672 16.3516 12.0372 16.0327 11.9773C15.8031 11.9342 15.6883 11.9127 15.6082 11.9249C15.5281 11.9371 15.4145 11.9975 15.1874 12.1183C14.545 12.4599 13.7959 12.5806 13.0755 12.4466C13.3493 12.1098 13.5363 11.7057 13.6188 11.2725C13.6688 11.0075 13.545 10.7501 13.3594 10.5617C12.5166 9.70583 12 8.5526 12 7.28342C12 4.64184 14.2388 2.50006 17 2.50006C19.7611 2.50006 22 4.64184 22 7.28342Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinejoin="round"
    />
    <path
      d="M15.4922 7.5H15.5003M18.4922 7.5H18.5003"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M7.50189 21.5001H4.71817C4.39488 21.5001 4.07021 21.4546 3.77327 21.327C2.80666 20.9117 2.31624 20.3633 2.08769 20.0202C1.95764 19.8251 1.97617 19.5764 2.11726 19.389C3.23716 17.9015 5.83846 17.0031 7.50665 17.003C9.17484 17.0031 11.7714 17.9015 12.8913 19.389C13.0324 19.5764 13.0509 19.8251 12.9209 20.0202C12.6923 20.3633 12.2019 20.9117 11.2353 21.327C10.9383 21.4546 10.6137 21.5001 10.2904 21.5001H7.50189Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.2854 11.7889C10.2854 13.3202 9.04129 14.5616 7.50664 14.5616C5.97199 14.5616 4.72791 13.3202 4.72791 11.7889C4.72791 10.2576 5.97199 9.01624 7.50664 9.01624C9.04129 9.01624 10.2854 10.2576 10.2854 11.7889Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Target Region Icon -----> */
export const MarketAreaIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M22 10.5V9.71749C22 7.77787 22 6.80807 21.4142 6.2055C20.8284 5.60294 19.8856 5.60294 18 5.60294H15.9214C15.004 5.60294 14.9964 5.60116 14.1715 5.18834L10.8399 3.52114C9.44884 2.82504 8.75332 2.47699 8.01238 2.50118C7.27143 2.52537 6.59877 2.91808 5.25345 3.70351L4.02558 4.42037C3.03739 4.99729 2.54329 5.28576 2.27164 5.76564C2 6.24553 2 6.82993 2 7.99873V16.2157C2 17.7514 2 18.5193 2.34226 18.9467C2.57001 19.231 2.88916 19.4222 3.242 19.4856C3.77226 19.5808 4.42148 19.2018 5.71987 18.4437C6.60156 17.929 7.45011 17.3944 8.50487 17.5394C9.38869 17.6608 10.21 18.2185 11 18.6138"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 2.5L8 17.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinejoin="round"
    />
    <path
      d="M15 5.5V9.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 12C19.9353 12 22 14.0165 22 16.4629C22 18.9482 19.9017 20.6924 17.9635 21.8783C17.8223 21.9581 17.6625 22 17.5 22C17.3375 22 17.1777 21.9581 17.0365 21.8783C15.1019 20.6808 13 18.9568 13 16.4629C13 14.0165 15.0647 12 17.5 12Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M17.5 16.5H17.509"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Delete-02 Icon -----> */
export const Delete02Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M19.5 5.5L18.8803 15.5251C18.7219 18.0864 18.6428 19.3671 18.0008 20.2879C17.6833 20.7431 17.2747 21.1273 16.8007 21.416C15.8421 22 14.559 22 11.9927 22C9.42312 22 8.1383 22 7.17905 21.4149C6.7048 21.1257 6.296 20.7408 5.97868 20.2848C5.33688 19.3626 5.25945 18.0801 5.10461 15.5152L4.5 5.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M3 5.5H21M16.0557 5.5L15.3731 4.09173C14.9196 3.15626 14.6928 2.68852 14.3017 2.39681C14.215 2.3321 14.1231 2.27454 14.027 2.2247C13.5939 2 13.0741 2 12.0345 2C10.9688 2 10.436 2 9.99568 2.23412C9.8981 2.28601 9.80498 2.3459 9.71729 2.41317C9.32164 2.7167 9.10063 3.20155 8.65861 4.17126L8.05292 5.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M9.5 16.5L9.5 10.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M14.5 16.5L14.5 10.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
  </svg>
);

/* <----- Team Icon -----> */
export const TeamIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M20.7739 18C21.5232 18 22.1192 17.5285 22.6543 16.8691C23.7498 15.5194 21.9512 14.4408 21.2652 13.9126C20.5679 13.3756 19.7893 13.0714 18.9999 13M17.9999 11C19.3806 11 20.4999 9.88071 20.4999 8.5C20.4999 7.11929 19.3806 6 17.9999 6"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M3.2259 18C2.47659 18 1.88061 17.5285 1.34548 16.8691C0.250028 15.5194 2.04861 14.4408 2.73458 13.9126C3.43191 13.3756 4.21052 13.0714 4.99994 13M5.49994 11C4.11923 11 2.99994 9.88071 2.99994 8.5C2.99994 7.11929 4.11923 6 5.49994 6"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M8.08368 15.1112C7.0619 15.743 4.38286 17.0331 6.01458 18.6474C6.81166 19.436 7.6994 20 8.8155 20H15.1843C16.3004 20 17.1881 19.436 17.9852 18.6474C19.6169 17.0331 16.9379 15.743 15.9161 15.1112C13.52 13.6296 10.4797 13.6296 8.08368 15.1112Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4999 7.5C15.4999 9.433 13.9329 11 11.9999 11C10.0669 11 8.49988 9.433 8.49988 7.5C8.49988 5.567 10.0669 4 11.9999 4C13.9329 4 15.4999 5.567 15.4999 7.5Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
  </svg>
);

/* <----- Setting Icon -----> */
export const SettingIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M21.011 14.0965C21.5329 13.9558 21.7939 13.8854 21.8969 13.7508C22 13.6163 22 13.3998 22 12.9669V11.0332C22 10.6003 22 10.3838 21.8969 10.2493C21.7938 10.1147 21.5329 10.0443 21.011 9.90358C19.0606 9.37759 17.8399 7.33851 18.3433 5.40087C18.4817 4.86799 18.5509 4.60156 18.4848 4.44529C18.4187 4.28902 18.2291 4.18134 17.8497 3.96596L16.125 2.98673C15.7528 2.77539 15.5667 2.66972 15.3997 2.69222C15.2326 2.71472 15.0442 2.90273 14.6672 3.27873C13.208 4.73448 10.7936 4.73442 9.33434 3.27864C8.95743 2.90263 8.76898 2.71463 8.60193 2.69212C8.43489 2.66962 8.24877 2.77529 7.87653 2.98663L6.15184 3.96587C5.77253 4.18123 5.58287 4.28891 5.51678 4.44515C5.45068 4.6014 5.51987 4.86787 5.65825 5.4008C6.16137 7.3385 4.93972 9.37763 2.98902 9.9036C2.46712 10.0443 2.20617 10.1147 2.10308 10.2492C2 10.3838 2 10.6003 2 11.0332V12.9669C2 13.3998 2 13.6163 2.10308 13.7508C2.20615 13.8854 2.46711 13.9558 2.98902 14.0965C4.9394 14.6225 6.16008 16.6616 5.65672 18.5992C5.51829 19.1321 5.44907 19.3985 5.51516 19.5548C5.58126 19.7111 5.77092 19.8188 6.15025 20.0341L7.87495 21.0134C8.24721 21.2247 8.43334 21.3304 8.6004 21.3079C8.76746 21.2854 8.95588 21.0973 9.33271 20.7213C10.7927 19.2644 13.2088 19.2643 14.6689 20.7212C15.0457 21.0973 15.2341 21.2853 15.4012 21.3078C15.5682 21.3303 15.7544 21.2246 16.1266 21.0133L17.8513 20.034C18.2307 19.8187 18.4204 19.711 18.4864 19.5547C18.5525 19.3984 18.4833 19.132 18.3448 18.5991C17.8412 16.6616 19.0609 14.6226 21.011 14.0965Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
  </svg>
);

export const HomeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M12 17H12.009"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 8.5V13.5C20 17.2712 20 19.1569 18.8284 20.3284C17.6569 21.5 15.7712 21.5 12 21.5C8.22876 21.5 6.34315 21.5 5.17157 20.3284C4 19.1569 4 17.2712 4 13.5V8.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M22 10.5L17.6569 6.33548C14.9902 3.77849 13.6569 2.5 12 2.5C10.3431 2.5 9.00981 3.77849 6.34315 6.33548L2 10.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
  </svg>
);

export const TermsAndConditionsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M11 7L17 7"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M7 7L8 7"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M7 12L8 12"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M7 17L8 17"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M11 12L17 12"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M11 17L17 17"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
  </svg>
);

export const PrivacyPolicyIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M10.2892 21.9614H9.39111C6.14261 21.9614 4.51836 21.9614 3.50918 20.9363C2.5 19.9111 2.5 18.2612 2.5 14.9614V9.96139C2.5 6.66156 2.5 5.01165 3.50918 3.98653C4.51836 2.9614 6.14261 2.9614 9.39111 2.9614H12.3444C15.5929 2.9614 17.4907 3.01658 18.5 4.04171C19.5092 5.06683 19.5 6.66156 19.5 9.96139V11.1478"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9453 2V4M10.9453 2V4M5.94531 2V4"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 15H11M7 10H15"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      opacity="0.93"
      d="M20.7598 14.8785C19.8544 13.8641 19.3112 13.9245 18.7076 14.1056C18.2851 14.166 16.8365 15.8568 16.2329 16.3952C15.2419 17.3743 14.2464 18.3823 14.1807 18.5138C13.9931 18.8188 13.8186 19.3592 13.7341 19.963C13.5771 20.8688 13.3507 21.8885 13.6375 21.9759C13.9242 22.0632 14.7239 21.8954 15.6293 21.7625C16.2329 21.6538 16.6554 21.533 16.9572 21.3519C17.3797 21.0983 18.1644 20.2046 19.5164 18.8761C20.3644 17.9833 21.1823 17.3664 21.4238 16.7626C21.6652 15.8568 21.3031 15.3737 20.7598 14.8785Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
  </svg>
);

export const AboutUsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M20.5 16.9286V10C20.5 6.22876 20.5 4.34315 19.3284 3.17157C18.1569 2 16.2712 2 12.5 2H11.5C7.72876 2 5.84315 2 4.67157 3.17157C3.5 4.34315 3.5 6.22876 3.5 10V19.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M20.5 17H6C4.61929 17 3.5 18.1193 3.5 19.5C3.5 20.8807 4.61929 22 6 22H20.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M20.5 22C19.1193 22 18 20.8807 18 19.5C18 18.1193 19.1193 17 20.5 17"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M15 7L9 7"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 11L9 11"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowRight02Icon2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M9.00005 6C9.00005 6 15 10.4189 15 12C15 13.5812 9 18 9 18"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
/* <----- Building-03 Icon -----> */
export const Building03Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M16 10L18.1494 10.6448C19.5226 11.0568 20.2092 11.2628 20.6046 11.7942C21 12.3256 21 13.0425 21 14.4761V22"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinejoin="round"
    />
    <path
      d="M8 9L11 9M8 13L11 13"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 22V19C12 18.0572 12 17.5858 11.7071 17.2929C11.4142 17 10.9428 17 10 17H9C8.05719 17 7.58579 17 7.29289 17.2929C7 17.5858 7 18.0572 7 19V22"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinejoin="round"
    />
    <path
      d="M2 22L22 22"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M3 22V6.71724C3 4.20649 3 2.95111 3.79118 2.32824C4.58237 1.70537 5.74742 2.04355 8.07752 2.7199L13.0775 4.17122C14.4836 4.57937 15.1867 4.78344 15.5933 5.33965C16 5.89587 16 6.65344 16 8.16857V22"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Clock-05 Icon -----> */
export const Clock05Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M12 22C6.47715 22 2.00004 17.5228 2.00004 12C2.00004 6.47715 6.47719 2 12 2C16.4777 2 20.2257 4.94289 21.5 9H19"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 8V12L14 14"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.9551 13C21.9848 12.6709 22 12.3373 22 12M15 22C15.3416 21.8876 15.6753 21.7564 16 21.6078M20.7906 17C20.9835 16.6284 21.1555 16.2433 21.305 15.8462M18.1925 20.2292C18.5369 19.9441 18.8631 19.6358 19.1688 19.3065"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Crop Icon -----> */
export const CropIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M4 2V4M22 20H20M16.5 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14V7.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 22L20 12C20 8.22877 20 6.34315 18.8284 5.17158C17.6569 4 15.7712 4 12 4L2 4"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- ReturnRequest Icon -----> */
export const ReturnRequestIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M3 13V8H21V13C21 16.7712 21 18.6569 19.8284 19.8284C18.6569 21 16.7712 21 13 21H11C7.22876 21 5.34315 21 4.17157 19.8284C3 18.6569 3 16.7712 3 13Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 8L3.86538 6.07692C4.53654 4.58547 4.87211 3.83975 5.55231 3.41987C6.23251 3 7.105 3 8.85 3H15.15C16.895 3 17.7675 3 18.4477 3.41987C19.1279 3.83975 19.4635 4.58547 20.1346 6.07692L21 8"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M12 8V3"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M8.5 13.5H14C15.1046 13.5 16 14.3954 16 15.5C16 16.6046 15.1046 17.5 14 17.5H13M10 11.5L8 13.5L10 15.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- User Icon -----> */
export const UserStoryIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M12 2C17.5237 2 22 6.47778 22 12C22 17.5222 17.5237 22 12 22"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 21.5C7.81163 21.0953 6.69532 20.5107 5.72302 19.7462M5.72302 4.25385C6.69532 3.50059 7.81163 2.90473 9 2.5M2 10.2461C2.21607 9.08813 2.66019 7.96386 3.29638 6.94078M2 13.7539C2.21607 14.9119 2.66019 16.0361 3.29638 17.0592"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 16.5C10.0726 14.302 13.9051 14.1986 16 16.5M14.2179 9.75C14.2179 10.9926 13.2215 12 11.9925 12C10.7634 12 9.76708 10.9926 9.76708 9.75C9.76708 8.50736 10.7634 7.5 11.9925 7.5C13.2215 7.5 14.2179 8.50736 14.2179 9.75Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
  </svg>
);

/* <----- Wallet-Done-01 Icon -----> */
export const WalletDone01Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M2 19C2 19 3 19 4 21C4 21 7.17647 16 10 15"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 21H16C18.8284 21 20.2426 21 21.1213 20.1213C22 19.2426 22 17.8284 22 15V13C22 10.1716 22 8.75736 21.1213 7.87868C20.2426 7 18.8284 7 16 7H10M2 15V11C2 7.22876 2 5.34315 3.17157 4.17157C4.34315 3 6.22876 3 10 3H14C14.93 3 15.395 3 15.7765 3.10222C16.8117 3.37962 17.6204 4.18827 17.8978 5.22354C18 5.60504 18 6.07003 18 7"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M16 13.5C16 14.3284 16.6716 15 17.5 15C18.3284 15 19 14.3284 19 13.5C19 12.6716 18.3284 12 17.5 12C16.6716 12 16 12.6716 16 13.5Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
  </svg>
);

/* <----- Logout-03 Icon -----> */
export const Logout03Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M15 17.625C14.9264 19.4769 13.3831 21.0494 11.3156 20.9988C10.8346 20.987 10.2401 20.8194 9.05112 20.484C6.18961 19.6768 3.70555 18.3203 3.10956 15.2815C3 14.723 3 14.0944 3 12.8373L3 11.1627C3 9.90561 3 9.27705 3.10956 8.71846C3.70555 5.67965 6.18961 4.32316 9.05112 3.51603C10.2401 3.18064 10.8346 3.01295 11.3156 3.00119C13.3831 2.95061 14.9264 4.52307 15 6.37501"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M21 12H10M21 12C21 11.2998 19.0057 9.99153 18.5 9.5M21 12C21 12.7002 19.0057 14.0085 18.5 14.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Cancel-01 Icon -----> */
export const Cancel01Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M19.0005 4.99988L5.00049 18.9999M5.00049 4.99988L19.0005 18.9999"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Checkmark-Badge-04 Icon -----> */
export const CheckmarkBadge04Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M14.2618 3.59937C13.1956 2.53312 12.6625 2 12 2C11.3375 2 10.8044 2.53312 9.73815 3.59937C9.09832 4.2392 8.46427 4.53626 7.55208 4.53626C6.7556 4.53626 5.62243 4.38178 5 5.00944C4.38249 5.63214 4.53628 6.76065 4.53628 7.55206C4.53628 8.46428 4.2392 9.09832 3.59935 9.73817C2.53312 10.8044 2.00001 11.3375 2 12C2.00002 12.6624 2.53314 13.1956 3.59938 14.2618C4.31616 14.9786 4.53628 15.4414 4.53628 16.4479C4.53628 17.2444 4.38181 18.3776 5.00949 19C5.63218 19.6175 6.76068 19.4637 7.55206 19.4637C8.52349 19.4637 8.99128 19.6537 9.68457 20.347C10.2749 20.9374 11.0663 22 12 22C12.9337 22 13.7251 20.9374 14.3154 20.347C15.0087 19.6537 15.4765 19.4637 16.4479 19.4637C17.2393 19.4637 18.3678 19.6175 18.9905 19M20.4006 9.73817C21.4669 10.8044 22 11.3375 22 12C22 12.6624 21.4669 13.1956 20.4006 14.2618C19.6838 14.9786 19.4637 15.4414 19.4637 16.4479C19.4637 17.2444 19.6182 18.3776 18.9905 19M18.9905 19H19"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 9.5L12 13L21.0002 3"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Plus-Minus-Square-01 Icon -----> */
export const PlusMinusSquare01Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M12 7.5V13.8636M15.5 10.6818H8.5M15.5 16.5H8.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Minus-Plus-Square-01 Icon -----> */
export const MinusPlusSquare01Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M12 16.5V10.1364M15.5 13.3182H8.5M15.5 7.5H8.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Add-01 Icon -----> */
export const Add01Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M12 4V20"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 12H20"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- More-Vertical-Circle-01 Icon -----> */
export const MoreVerticalIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M11.992 12H12.001"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9842 18H11.9932"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9998 6H12.0088"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Arrow-Right-01 Icon -----> */
export const ArrowRightIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    color={props.color}
    viewBox="0 0 24 24"
    fill="none"
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.00005 6L15 12L9 18"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeMiterlimit="16"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Arrow-Left-01 Icon -----> */
export const ArrowLeftIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    color={props.color}
    viewBox="0 0 24 24"
    fill="none"
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 6L9 12.0001L15 18"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeMiterlimit="16"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- User-List Icon -----> */
export const UserListIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M5.08069 15.2964C3.86241 16.0335 0.668175 17.5386 2.61368 19.422C3.56404 20.342 4.62251 21 5.95325 21H13.5468C14.8775 21 15.936 20.342 16.8863 19.422C18.8318 17.5386 15.6376 16.0335 14.4193 15.2964C11.5625 13.5679 7.93752 13.5679 5.08069 15.2964Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M17 5L22 5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 8L22 8"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 11L22 11"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- View-Off-Slash Icon -----> */
export const ViewOffSlashIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M19.439 15.439C20.3636 14.5212 21.0775 13.6091 21.544 12.955C21.848 12.5287 22 12.3155 22 12C22 11.6845 21.848 11.4713 21.544 11.045C20.1779 9.12944 16.6892 5 12 5C11.0922 5 10.2294 5.15476 9.41827 5.41827M6.74742 6.74742C4.73118 8.1072 3.24215 9.94266 2.45604 11.045C2.15201 11.4713 2 11.6845 2 12C2 12.3155 2.15201 12.5287 2.45604 12.955C3.8221 14.8706 7.31078 19 12 19C13.9908 19 15.7651 18.2557 17.2526 17.2526"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.85786 10C9.32783 10.53 9 11.2623 9 12.0711C9 13.6887 10.3113 15 11.9289 15C12.7377 15 13.47 14.6722 14 14.1421"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M3 3L21 21"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Eye Icon -----> */
export const EyeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M2 8C2 8 6.47715 3 12 3C17.5228 3 22 8 22 8"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M21.544 13.045C21.848 13.4713 22 13.6845 22 14C22 14.3155 21.848 14.5287 21.544 14.955C20.1779 16.8706 16.6892 21 12 21C7.31078 21 3.8221 16.8706 2.45604 14.955C2.15201 14.5287 2 14.3155 2 14C2 13.6845 2.15201 13.4713 2.45604 13.045C3.8221 11.1294 7.31078 7 12 7C16.6892 7 20.1779 11.1294 21.544 13.045Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M15 14C15 12.3431 13.6569 11 12 11C10.3431 11 9 12.3431 9 14C9 15.6569 10.3431 17 12 17C13.6569 17 15 15.6569 15 14Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
  </svg>
);

/* <----- Facebook-02 Icon -----> */
export const Facebook02Icon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    color={props.color}
    viewBox="0 0 24 24"
    fill="none"
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.55869 10.2083C4.47617 10.2083 4.25024 10.4146 4.25024 11.4028V13.1944C4.25024 14.1826 4.47617 14.3889 5.55869 14.3889H8.17557V21.5556C8.17557 22.5438 8.40149 22.75 9.48401 22.75H12.1009C13.1834 22.75 13.4093 22.5438 13.4093 21.5556V14.3889H16.3477C17.1687 14.3889 17.3803 14.2432 17.6058 13.5226L18.1666 11.7309C18.5529 10.4965 18.3148 10.2083 16.9085 10.2083H13.4093V7.22222C13.4093 6.56255 13.9951 6.02778 14.7178 6.02778H18.4418C19.5243 6.02778 19.7502 5.82154 19.7502 4.83333V2.44444C19.7502 1.45624 19.5243 1.25 18.4418 1.25H14.7178C11.1046 1.25 8.17557 3.92386 8.17557 7.22222V10.2083H5.55869Z"
      fill={props.color}
    />
  </svg>
);

/* <----- New-Twitter Icon -----> */
export const NewTwitterIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    color={props.color}
    viewBox="0 0 24 24"
    fill="none"
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.3569 2.78113C2.52359 2.45513 2.85886 2.25 3.225 2.25H8.1C8.41308 2.25 8.70711 2.40034 8.89041 2.65415L13.5354 9.08571L20.0856 2.53557C20.4663 2.15481 21.0837 2.15481 21.4644 2.53557C21.8452 2.91633 21.8452 3.53367 21.4644 3.91443L14.6919 10.687L21.5654 20.2041C21.7798 20.501 21.8098 20.8929 21.6431 21.2189C21.4764 21.5449 21.1411 21.75 20.775 21.75H15.9C15.5869 21.75 15.2929 21.5997 15.1096 21.3459L10.4646 14.9143L3.91443 21.4644C3.53367 21.8452 2.91634 21.8452 2.53557 21.4644C2.15481 21.0837 2.15481 20.4663 2.53557 20.0856L9.30811 13.313L2.43459 3.79585C2.22022 3.49903 2.19021 3.10713 2.3569 2.78113Z"
      fill={props.color}
    />
  </svg>
);

/* <----- Google Icon -----> */
export const GoogleIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    color={props.color}
    viewBox="0 0 24 24"
    fill="none"
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM8 12C8 9.79086 9.79086 8 12 8C13.1048 8 14.1035 8.44662 14.8284 9.17157C15.219 9.5621 15.8521 9.5621 16.2426 9.17157C16.6332 8.78105 16.6332 8.14788 16.2426 7.75736C15.1579 6.67267 13.6566 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 11.4477 17.5523 11 17 11H12C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13H15.874C15.4299 14.7252 13.8638 16 12 16C9.79086 16 8 14.2091 8 12Z"
      fill={props.color}
    />
  </svg>
);

/* <----- Linkedin-02 Icon -----> */
export const Linkedin02Icon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    color={props.color}
    viewBox="0 0 24 24"
    fill="none"
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 9H4.5C3.55719 9 3.08579 9 2.79289 9.29289C2.5 9.58579 2.5 10.0572 2.5 11V19.5C2.5 20.4428 2.5 20.9142 2.79289 21.2071C3.08579 21.5 3.55719 21.5 4.5 21.5H5C5.94281 21.5 6.41421 21.5 6.70711 21.2071C7 20.9142 7 20.4428 7 19.5V11C7 10.0572 7 9.58579 6.70711 9.29289C6.41421 9 5.94281 9 5 9Z"
      fill={props.color}
    />
    <path
      d="M7 4.75C7 5.99264 5.99264 7 4.75 7C3.50736 7 2.5 5.99264 2.5 4.75C2.5 3.50736 3.50736 2.5 4.75 2.5C5.99264 2.5 7 3.50736 7 4.75Z"
      fill={props.color}
    />
    <path
      d="M11.826 9H11C10.0572 9 9.58579 9 9.29289 9.29289C9 9.58579 9 10.0572 9 11V19.5C9 20.4428 9 20.9142 9.29289 21.2071C9.58579 21.5 10.0572 21.5 11 21.5H11.5C12.4428 21.5 12.9142 21.5 13.2071 21.2071C13.5 20.9142 13.5 20.4428 13.5 19.5L13.5001 16.0001C13.5001 14.3433 14.0281 13.0001 15.5879 13.0001C16.3677 13.0001 17 13.6717 17 14.5001V19.0001C17 19.9429 17 20.4143 17.2929 20.7072C17.5857 21.0001 18.0572 21.0001 19 21.0001H19.4987C20.4413 21.0001 20.9126 21.0001 21.2055 20.7073C21.4984 20.4145 21.4985 19.9432 21.4987 19.0006L21.5001 13.5002C21.5001 11.015 19.1364 9.00024 16.7968 9.00024C15.4649 9.00024 14.2767 9.65309 13.5001 10.674C13.5 10.0439 13.5 9.72893 13.3632 9.495C13.2765 9.34686 13.1531 9.22353 13.005 9.13687C12.7711 9 12.4561 9 11.826 9Z"
      fill={props.color}
    />
  </svg>
);

/* <----- Dashboard-Circle Icon -----> */
export const DashboardCircleIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <circle
      cx="17.75"
      cy="6.25"
      r="4.25"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <circle
      cx="6.25"
      cy="6.25"
      r="4.25"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <circle
      cx="17.75"
      cy="17.75"
      r="4.25"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <circle
      cx="6.25"
      cy="17.75"
      r="4.25"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
  </svg>
);

/* <----- Hourglass Icon -----> */
export const HourglassIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M19 2V5C19 8.86599 15.866 12 12 12M5 2V5C5 8.86599 8.13401 12 12 12M12 12C15.866 12 19 15.134 19 19V22M12 12C8.13401 12 5 15.134 5 19V22"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M4 2H20M20 22H4"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
  </svg>
);

/* <----- Task-Edit-02 Icon -----> */
export const TaskEdit02Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M7.01428 16.0029H11.0143M7.01428 11.0053H15.0143"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M10.0143 21.9999H11.0143"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M7.51083 21.9999C6.33921 21.9749 5.53921 21.9 4.76421 21.6751C3.71491 21.4002 2.94905 20.4757 2.72421 19.1763C2.43921 17.9519 2.53921 14.9284 2.51416 11.3302C2.51623 8.53874 2.3892 5.85787 2.8392 4.33362C3.1142 3.83386 3.3392 2.00976 7.06421 2.03475C7.68921 2.00976 14.3142 1.95978 15.3642 2.05973C18.8642 2.1347 19.2142 3.93381 19.4142 5.63298C19.541 6.88236 19.5142 8.88138 19.5142 11.0053M7.01421 2.00976C7.31421 3.63396 7.28921 4.68344 8.38921 4.93332C8.86421 5.00828 9.9495 5.00628 11.1142 5.00828C12.1538 5.01007 13.2142 5.01945 13.6892 4.90833C14.8642 4.63347 14.7392 3.18418 15.0392 2.00976"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M18.2786 14.3787C16.9045 15.778 14.2563 18.2768 14.2563 18.4517C14.0427 18.7483 13.8565 19.3512 13.7316 20.2008C13.5747 20.9884 13.3868 21.6751 13.6067 21.875C13.8266 22.0749 14.6545 21.9064 15.5304 21.7251C16.2299 21.6501 16.8795 21.4002 17.2043 21.1504C17.679 20.7304 20.9018 17.4772 21.2766 17.0524C21.5514 16.6776 21.5764 15.9779 21.3365 15.5531C21.2016 15.2533 20.3522 14.4536 20.0774 14.2288C19.5777 13.9289 18.8782 13.8789 18.2786 14.3787Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
  </svg>
);

/* <----- Time-Schedule Icon -----> */
export const TimeScheduleIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M12 8V12L13.5 13.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.5454 16.4534C21.1818 17.337 22 17.7789 22 18.5C22 19.2211 21.1818 19.663 19.5454 20.5466L18.4311 21.1484C17.1744 21.827 16.5461 22.1663 16.2439 21.9196C15.504 21.3154 16.6567 19.7561 16.9403 19.2037C17.2277 18.644 17.2225 18.3459 16.9403 17.7963C16.6567 17.2439 15.504 15.6846 16.2439 15.0804C16.5461 14.8337 17.1744 15.173 18.4311 15.8516L19.5454 16.4534Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M13.0261 21.948C12.6888 21.9824 12.3464 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 12.6849 21.9311 13.3538 21.8 14"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
  </svg>
);

/* <----- Share-02 Icon -----> */
export const Share02Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M9 4.5C5.50442 5.70104 3 8.94175 3 12.7511C3 13.9579 3.25134 15.1076 3.70591 16.1534M15 4.5C18.4956 5.70104 21 8.94175 21 12.7511C21 13.7736 20.8195 14.7552 20.4879 15.6674M16.5 20.3296C15.1762 21.074 13.6393 21.5 12 21.5C10.3607 21.5 8.82378 21.074 7.5 20.3296"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M15 5C15 6.65685 13.6569 8 12 8C10.3431 8 9 6.65685 9 5C9 3.34315 10.3431 2 12 2C13.6569 2 15 3.34315 15 5Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <circle
      cx="5"
      cy="19"
      r="3"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <circle
      cx="19"
      cy="19"
      r="3"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
  </svg>
);

/* <----- Checkmark-Circle-04 Icon -----> */
export const CheckmarkCircle04Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M15 2.4578C14.053 2.16035 13.0452 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 10.9548 21.8396 9.94704 21.5422 9"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M8.5 9.5L12 13L21.0002 3"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Information-Circle Icon -----> */
export const InformationCircleIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M12.2422 17V12C12.2422 11.5286 12.2422 11.2929 12.0957 11.1464C11.9493 11 11.7136 11 11.2422 11"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.992 8H12.001"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Circle-Arrow-Left-Right Icon -----> */
export const CircleArrowLeftRightIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M8.5 9.3L15.5 9.3M8.5 9.3C8.5 8.59598 10.25 7.5 10.25 7.5M8.5 9.3C8.5 10.004 10.25 11.1 10.25 11.1M15.5 14.7H8.5M15.5 14.7C15.5 13.996 13.75 12.9 13.75 12.9M15.5 14.7C15.5 15.404 13.75 16.5 13.75 16.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Cancel-Circle Icon -----> */
export const CancelCircleIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M14.9994 15L9 9M9.00064 15L15 9"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
  </svg>
);

/* <----- Money-Send-02 Icon -----> */
export const MoneySend02Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M7 6.67011C5.93408 6.67011 4.91969 6.5508 4 6.33552C3.04003 6.11081 2 6.8021 2 7.80858V18.8175C2 19.6259 2 20.0301 2.19412 20.4469C2.30483 20.6846 2.55696 21.008 2.75898 21.1714C3.11319 21.4578 3.4088 21.527 4 21.6654C4.91969 21.8807 5.93408 22 7 22C8.91707 22 10.6675 21.6141 12 20.978C13.3325 20.342 15.0829 19.956 17 19.956C18.0659 19.956 19.0803 20.0753 20 20.2906C20.96 20.5153 22 19.824 22 18.8175V7.80858C22 7.00021 22 6.59603 21.8059 6.17921C21.6952 5.94149 21.443 5.61811 21.241 5.45475C20 4.43872 18 5.44223 18 5.44223"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M14.5 13.5C14.5 14.8807 13.3807 16 12 16C10.6193 16 9.5 14.8807 9.5 13.5C9.5 12.1193 10.6193 11 12 11C13.3807 11 14.5 12.1193 14.5 13.5Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M5.5 14.5L5.5 14.509"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5 12.4922L18.5 12.5012"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 4.5C9.99153 3.9943 11.2998 2 12 2M14.5 4.5C14.0085 3.9943 12.7002 2 12 2M12 2V8"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Cancel-Circle-Half-Dot Icon -----> */
export const CancelCircleHalfDotIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M15 9L12 12M12 12L9 15M12 12L15 15M12 12L9 9"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47714 17.5228 1.99998 12 1.99998"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 8.49998C2.86239 7.67055 3.3189 6.89164 3.85601 6.17676M6.17681 3.85597C6.89168 3.31886 7.67058 2.86237 8.5 2.49998"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Coins-01 Icon -----> */
export const Coins01Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <ellipse
      cx="15.5"
      cy="11"
      rx="6.5"
      ry="2"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M22 15.5C22 16.6046 19.0899 17.5 15.5 17.5C11.9101 17.5 9 16.6046 9 15.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M22 11V19.8C22 21.015 19.0899 22 15.5 22C11.9101 22 9 21.015 9 19.8V11"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <ellipse
      cx="8.5"
      cy="4"
      rx="6.5"
      ry="2"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M6 11C4.10819 10.7698 2.36991 10.1745 2 9M6 16C4.10819 15.7698 2.36991 15.1745 2 14"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M6 21C4.10819 20.7698 2.36991 20.1745 2 19L2 4"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M15 6V4"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
  </svg>
);

/* <----- Layers-01 Icon -----> */
export const Layers01Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M8.64298 3.14559L6.93816 3.93362C4.31272 5.14719 3 5.75397 3 6.75C3 7.74603 4.31272 8.35281 6.93817 9.56638L8.64298 10.3544C10.2952 11.1181 11.1214 11.5 12 11.5C12.8786 11.5 13.7048 11.1181 15.357 10.3544L17.0618 9.56638C19.6873 8.35281 21 7.74603 21 6.75C21 5.75397 19.6873 5.14719 17.0618 3.93362L15.357 3.14559C13.7048 2.38186 12.8786 2 12 2C11.1214 2 10.2952 2.38186 8.64298 3.14559Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.788 11.0972C20.9293 11.2959 21 11.5031 21 11.7309C21 12.7127 19.6873 13.3109 17.0618 14.5072L15.357 15.284C13.7048 16.0368 12.8786 16.4133 12 16.4133C11.1214 16.4133 10.2952 16.0368 8.64298 15.284L6.93817 14.5072C4.31272 13.3109 3 12.7127 3 11.7309C3 11.5031 3.07067 11.2959 3.212 11.0972"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.3767 16.2661C20.7922 16.5971 21 16.927 21 17.3176C21 18.2995 19.6873 18.8976 17.0618 20.0939L15.357 20.8707C13.7048 21.6236 12.8786 22 12 22C11.1214 22 10.2952 21.6236 8.64298 20.8707L6.93817 20.0939C4.31272 18.8976 3 18.2995 3 17.3176C3 16.927 3.20778 16.5971 3.62334 16.2661"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Bacteria Icon -----> */
export const BacteriaIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="15"
      cy="8"
      r="2"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 12.5L6.20943 12.735C6.59836 13.1714 7.25402 13.052 7.5 12.5C7.74598 11.948 8.40164 11.8286 8.79057 12.265L9 12.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8413 18L15.9521 17.6549C16.1579 17.014 15.6742 16.4273 15 16.5C14.3258 16.5727 13.8421 15.986 14.0479 15.3451L14.1587 15"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.009 13H19"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.00896 17H9"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00896 8H8"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Money-Add-02 Icon -----> */
export const MoneyAdd02Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M12 19C10.6675 19.6224 8.91707 20 7 20C5.93408 20 4.91969 19.8833 4 19.6726C3.4088 19.5372 3.11319 19.4695 2.75898 19.1892C2.55696 19.0294 2.30483 18.7129 2.19412 18.4803C2 18.0725 2 17.677 2 16.886V6.11397C2 5.12914 3.04003 4.45273 4 4.6726C4.91969 4.88325 5.93408 5 7 5C8.91707 5 10.6675 4.62236 12 4C13.3325 3.37764 15.0829 3 17 3C18.0659 3 19.0803 3.11675 20 3.3274C20.5912 3.46281 20.8868 3.53051 21.241 3.81079C21.443 3.97064 21.6952 4.28705 21.8059 4.51966C22 4.92751 22 5.32299 22 6.11397V11.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M18.5 21L18.5 14M15 17.5H22"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M14.5 11.5C14.5 12.8807 13.3807 14 12 14C10.6193 14 9.5 12.8807 9.5 11.5C9.5 10.1193 10.6193 9 12 9C13.3807 9 14.5 10.1193 14.5 11.5Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M5.5 12.5L5.5 12.509"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Money-Remove-02 Icon -----> */
export const MoneyRemove02Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M12 19C10.6675 19.6224 8.91707 20 7 20C5.93408 20 4.91969 19.8833 4 19.6726C3.4088 19.5372 3.11319 19.4695 2.75898 19.1892C2.55696 19.0294 2.30483 18.7129 2.19412 18.4803C2 18.0725 2 17.677 2 16.886V6.11397C2 5.12914 3.04003 4.45273 4 4.6726C4.91969 4.88325 5.93408 5 7 5C8.91707 5 10.6675 4.62236 12 4C13.3325 3.37764 15.0829 3 17 3C18.0659 3 19.0803 3.11675 20 3.3274C20.5912 3.46281 20.8868 3.53051 21.241 3.81079C21.443 3.97064 21.6952 4.28705 21.8059 4.51966C22 4.92751 22 5.32299 22 6.11397V12"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M15 18H22"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M5.5 13L5.5 13.009"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5 10.9922L18.5 11.0012"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Money-Receive-Flow-02 Icon -----> */
export const MoneyReceiveFlow02Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M19 5C19.3437 5.05019 19.6777 5.11301 20 5.18745C20.5912 5.324 20.8868 5.39228 21.241 5.6749C21.443 5.83609 21.6952 6.15516 21.8059 6.38973C22 6.80099 22 7.1998 22 7.99742V18.8599C22 19.853 20.96 20.5351 20 20.3134C19.0803 20.1009 18.0659 19.9832 17 19.9832C15.0829 19.9832 13.3325 20.364 12 20.9916C10.6675 21.6192 8.91707 22 7 22C5.93408 22 4.91969 21.8823 4 21.6699C3.4088 21.5333 3.11319 21.465 2.75898 21.1824C2.55696 21.0212 2.30483 20.7021 2.19412 20.4676C2 20.0563 2 19.6575 2 18.8599V7.99742C2 7.00432 3.04003 6.32223 4 6.54395C4.32232 6.6184 4.65627 6.68121 5 6.7314"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M14.5 13.5C14.5 14.8807 13.3807 16 12 16C10.6193 16 9.5 14.8807 9.5 13.5C9.5 12.1193 10.6193 11 12 11C13.3807 11 14.5 12.1193 14.5 13.5Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M5.5 14.5L5.5 14.509"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5 12.4922L18.5 12.5012"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 2V6M8 5L8 7M16 3V5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
  </svg>
);

/* <----- Whatsapp Icon -----> */
export const WhatsappIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.3789 2.27907 14.6926 2.78382 15.8877C3.06278 16.5481 3.20226 16.8784 3.21953 17.128C3.2368 17.3776 3.16334 17.6521 3.01642 18.2012L2 22L5.79877 20.9836C6.34788 20.8367 6.62244 20.7632 6.87202 20.7805C7.12161 20.7977 7.45185 20.9372 8.11235 21.2162C9.30745 21.7209 10.6211 22 12 22Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinejoin="round"
    />
    <path
      d="M8.58815 12.3773L9.45909 11.2956C9.82616 10.8397 10.2799 10.4153 10.3155 9.80826C10.3244 9.65494 10.2166 8.96657 10.0008 7.58986C9.91601 7.04881 9.41086 7 8.97332 7C8.40314 7 8.11805 7 7.83495 7.12931C7.47714 7.29275 7.10979 7.75231 7.02917 8.13733C6.96539 8.44196 7.01279 8.65187 7.10759 9.07169C7.51023 10.8548 8.45481 12.6158 9.91948 14.0805C11.3842 15.5452 13.1452 16.4898 14.9283 16.8924C15.3481 16.9872 15.558 17.0346 15.8627 16.9708C16.2477 16.8902 16.7072 16.5229 16.8707 16.165C17 15.8819 17 15.5969 17 15.0267C17 14.5891 16.9512 14.084 16.4101 13.9992C15.0334 13.7834 14.3451 13.6756 14.1917 13.6845C13.5847 13.7201 13.1603 14.1738 12.7044 14.5409L11.6227 15.4118"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
  </svg>
);

/* <----- Smart-Phone-01 Icon -----> */
export const SmartPhone01Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M5 9C5 5.70017 5 4.05025 6.02513 3.02513C7.05025 2 8.70017 2 12 2C15.2998 2 16.9497 2 17.9749 3.02513C19 4.05025 19 5.70017 19 9V15C19 18.2998 19 19.9497 17.9749 20.9749C16.9497 22 15.2998 22 12 22C8.70017 22 7.05025 22 6.02513 20.9749C5 19.9497 5 18.2998 5 15V9Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M11 19H13"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 2L9.089 2.53402C9.28188 3.69129 9.37832 4.26993 9.77519 4.62204C10.1892 4.98934 10.7761 5 12 5C13.2239 5 13.8108 4.98934 14.2248 4.62204C14.6217 4.26993 14.7181 3.69129 14.911 2.53402L15 2"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Rss-Error Icon -----> */
export const RssErrorIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <circle
      cx="17"
      cy="7"
      r="5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M22.75 13.4937C22.75 13.0795 22.4142 12.7437 22 12.7437C21.5858 12.7437 21.25 13.0795 21.25 13.4937H22.75ZM20.5342 20.7543L21.0198 21.3258V21.3258L20.5342 20.7543ZM3.44705 6.23317L2.96137 5.66166H2.96137L3.44705 6.23317ZM12.9915 21.25C12.5773 21.25 12.2415 21.5858 12.2415 22C12.2415 22.4142 12.5773 22.75 12.9915 22.75V21.25ZM13.9925 21.9956L13.9871 21.2456L13.9806 21.2457L13.9925 21.9956ZM1.25025 10.9727C1.23966 11.3868 1.56675 11.731 1.98083 11.7416C2.39491 11.7522 2.73917 11.4251 2.74975 11.0111L1.25025 10.9727ZM9.26038 5.74991C9.67455 5.74352 10.0051 5.4026 9.99873 4.98844C9.99234 4.57427 9.65142 4.2437 9.23725 4.25009L9.26038 5.74991ZM21.25 13.4937C21.25 15.5235 21.2478 16.9573 21.076 18.0434C20.9098 19.0938 20.5995 19.7145 20.0485 20.1828L21.0198 21.3258C21.9347 20.5483 22.3573 19.5438 22.5576 18.2778C22.7522 17.0475 22.75 15.4739 22.75 13.4937H21.25ZM12.9915 22.75C13.3534 22.75 13.6053 22.7489 13.7674 22.7478C13.8485 22.7472 13.9071 22.7466 13.9457 22.7462C13.9651 22.746 13.9794 22.7458 13.9891 22.7457C13.9939 22.7456 13.9976 22.7456 14.0001 22.7455C14.0014 22.7455 14.0023 22.7455 14.0031 22.7455C14.0034 22.7455 14.0037 22.7455 14.0039 22.7455C14.004 22.7455 14.0041 22.7455 14.0042 22.7455C14.0042 22.7455 14.0043 22.7455 14.0043 22.7455C14.0043 22.7455 14.0043 22.7455 14.0043 22.7455C14.0043 22.7455 14.0044 22.7455 13.9925 21.9956C13.9806 21.2457 13.9806 21.2457 13.9806 21.2457C13.9806 21.2457 13.9807 21.2457 13.9807 21.2457C13.9807 21.2457 13.9807 21.2457 13.9807 21.2457C13.9807 21.2457 13.9807 21.2457 13.9806 21.2457C13.9806 21.2457 13.9805 21.2457 13.9803 21.2457C13.9799 21.2457 13.9792 21.2457 13.9782 21.2457C13.9763 21.2457 13.9732 21.2458 13.969 21.2458C13.9605 21.2459 13.9473 21.2461 13.9291 21.2463C13.8927 21.2467 13.8361 21.2473 13.757 21.2478C13.5988 21.2489 13.3503 21.25 12.9915 21.25V22.75ZM13.9979 22.7455C15.7037 22.7333 17.0832 22.6875 18.2019 22.5013C19.3334 22.313 20.2597 21.9718 21.0198 21.3258L20.0485 20.1828C19.5666 20.5923 18.9303 20.8594 17.9555 21.0217C16.9679 21.1861 15.6976 21.2333 13.9871 21.2456L13.9979 22.7455ZM2.74975 11.0111C2.81163 8.59113 3.08942 7.52134 3.93273 6.80467L2.96137 5.66166C1.55911 6.85335 1.31136 8.58282 1.25025 10.9727L2.74975 11.0111ZM9.23725 4.25009C6.33117 4.2949 4.34751 4.48368 2.96137 5.66166L3.93273 6.80467C4.84512 6.02929 6.25834 5.79621 9.26038 5.74991L9.23725 4.25009Z"
      fill="currentColor"
    />
    <path
      d="M2.98242 21H2.9914"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 9H17.009"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 6.5V4.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 17.2349C4.49328 17.2349 6.77053 19.5 6.77053 21.9996M10 21.9996C10 17.5 5.99511 14 2.04522 14"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
  </svg>
);

/* <----- Note-04 Icon -----> */
export const Note04Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M17 2V4M12 2V4M7 2V4"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 16V9C3.5 6.17157 3.5 4.75736 4.37868 3.87868C5.25736 3 6.67157 3 9.5 3H14.5C17.3284 3 18.7426 3 19.6213 3.87868C20.5 4.75736 20.5 6.17157 20.5 9V12C20.5 16.714 20.5 19.0711 19.0355 20.5355C17.5711 22 15.214 22 10.5 22H9.5C6.67157 22 5.25736 22 4.37868 21.1213C3.5 20.2426 3.5 18.8284 3.5 16Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M8 15H12M8 10H16"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M20.5 14.5C20.5 15.8807 19.3807 17 18 17C17.5007 17 16.912 16.9125 16.4265 17.0426C15.9951 17.1582 15.6582 17.4951 15.5426 17.9265C15.4125 18.412 15.5 19.0007 15.5 19.5C15.5 20.8807 14.3807 22 13 22"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Arrow-Right-02 Icon -----> */
export const ArrowRight02Icon = (props) => (
  <svg
    width={props.width}
    height={props.width}
    viewBox="0 0 24 24"
    fill="none"
    color={props.color}
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    {...props}
  >
    <path
      d="M15.0001 17L20 12L15 7"
      stroke={props.color}
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 12H20"
      stroke={props.color}
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Arrow-Left-02 Icon -----> */
export const ArrowLeft02Icon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 24 24"
    fill="none"
    color={props.color}
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.99996 16.9998L4 11.9997L9 6.99976"
      stroke={props.color}
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 12H20"
      stroke={props.color}
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Black-Hole Icon -----> */
export const BlackHoleIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M20.5 5C21.3284 5 22 4.32843 22 3.5C22 2.67157 21.3284 2 20.5 2C19.6716 2 19 2.67157 19 3.5C19 4.32843 19.6716 5 20.5 5Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 22C4.32843 22 5 21.3284 5 20.5C5 19.6716 4.32843 19 3.5 19C2.67157 19 2 19.6716 2 20.5C2 21.3284 2.67157 22 3.5 22Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.0385 13.0623C21.6076 12.9268 22 12.4933 22 12C22 11.5067 21.6076 11.0732 21.0385 10.9377L16.5212 9.8622C15.7198 8.17022 13.9966 7 12 7C10.0034 7 8.28021 8.17023 7.47877 9.8622L2.96152 10.9377C2.39239 11.0732 2 11.5067 2 12C2 12.4933 2.39239 12.9268 2.96152 13.0623L7.47877 14.1378C8.28021 15.8298 10.0034 17 12 17C13.9966 17 15.7198 15.8298 16.5212 14.1378L21.0385 13.0623Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.0007 2.4578C14.0537 2.16035 13.0459 2 12.0007 2C8.7291 2 5.82441 3.57111 4 6M9.00073 21.5422C9.94777 21.8396 10.9555 22 12.0007 22C15.2719 22 18.1763 20.4293 20.0007 18.001"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Smart-Phone-04 Icon -----> */
export const SmartPhone04Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M16 6.5C15.9377 4.78752 15.7251 3.75009 14.9988 3.02513C13.9718 2 12.3188 2 9.01289 2C5.70698 2 4.05403 2 3.02701 3.02513C2 4.05025 2 5.70017 2 9V15C2 18.2998 2 19.9497 3.02701 20.9749C4.05403 22 5.70698 22 9.01289 22C12.3188 22 13.9718 22 14.9988 20.9749C15.7251 20.2499 15.9377 19.2125 16 17.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M8 19H10"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 11.9908L16 11.9998M20.0483 16.4912C21.2541 15.3396 22 13.7486 22 11.9912C22 10.2339 21.2541 8.64286 20.0483 7.49121M18 9.74121C18.6029 10.317 18.9759 11.1125 18.9759 11.9912C18.9759 12.8699 18.6029 13.6654 18 14.2412"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M6 2L6.089 2.53402C6.28188 3.69129 6.37832 4.26993 6.77519 4.62204C7.18918 4.98934 7.77614 5 9 5C10.2239 5 10.8108 4.98934 11.2248 4.62204C11.6217 4.26993 11.7181 3.69129 11.911 2.53402L12 2"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- File-Upload Icon -----> */
export const FileUploadIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M4 12L4 14.5442C4 17.7892 4 19.4117 4.88607 20.5107C5.06508 20.7327 5.26731 20.9349 5.48933 21.1139C6.58831 22 8.21082 22 11.4558 22C12.1614 22 12.5141 22 12.8372 21.886C12.9044 21.8623 12.9702 21.835 13.0345 21.8043C13.3436 21.6564 13.593 21.407 14.0919 20.9081L18.8284 16.1716C19.4065 15.5935 19.6955 15.3045 19.8478 14.9369C20 14.5694 20 14.1606 20 13.3431V10C20 6.22876 20 4.34315 18.8284 3.17157C17.6569 2 15.7712 2 12 2M13 21.5V21C13 18.1716 13 16.7574 13.8787 15.8787C14.7574 15 16.1716 15 19 15H19.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 5C9.41016 4.39316 7.84027 2 7 2C6.15973 2 4.58984 4.39316 4 5M7 3L7 10"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Mail-Send-02 Icon -----> */
export const MailSend02Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M22 12.5001C22 12.0087 21.9947 11.0172 21.9842 10.5244C21.9189 7.45886 21.8862 5.92609 20.7551 4.79066C19.6239 3.65523 18.0497 3.61568 14.9012 3.53657C12.9607 3.48781 11.0393 3.48781 9.09882 3.53656C5.95033 3.61566 4.37608 3.65521 3.24495 4.79065C2.11382 5.92608 2.08114 7.45885 2.01576 10.5244C1.99474 11.5101 1.99475 12.4899 2.01577 13.4756C2.08114 16.5412 2.11383 18.0739 3.24496 19.2094C4.37608 20.3448 5.95033 20.3843 9.09883 20.4634C9.90159 20.4836 10.7011 20.4954 11.5 20.4989"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 8.5L9.94202 10.2394C11.6572 11.2535 12.3428 11.2535 14.058 10.2394L17 8.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 17.5L14 17.5M22 17.5C22 16.7998 20.0057 15.4915 19.5 15M22 17.5C22 18.2002 20.0057 19.5085 19.5 20"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Message-Add-01 Icon -----> */
export const MessageAdd01Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M12.5 3.00372C11.6049 2.99039 10.7047 3.01289 9.8294 3.07107C5.64639 3.34913 2.31441 6.72838 2.04024 10.9707C1.98659 11.8009 1.98659 12.6607 2.04024 13.4909C2.1401 15.036 2.82343 16.4666 3.62791 17.6746C4.09501 18.5203 3.78674 19.5758 3.30021 20.4978C2.94941 21.1626 2.77401 21.495 2.91484 21.7351C3.05568 21.9752 3.37026 21.9829 3.99943 21.9982C5.24367 22.0285 6.08268 21.6757 6.74868 21.1846C7.1264 20.9061 7.31527 20.7668 7.44544 20.7508C7.5756 20.7348 7.83177 20.8403 8.34401 21.0513C8.8044 21.2409 9.33896 21.3579 9.8294 21.3905C11.2536 21.4852 12.7435 21.4854 14.1706 21.3905C18.3536 21.1125 21.6856 17.7332 21.9598 13.4909C22.0021 12.836 22.011 12.1627 21.9866 11.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 15H15.5M8.5 10H12"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 5.5H22M18.5 2L18.5 9"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Tick-02 Icon -----> */
export const Tick02Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M5 14L8.5 17.5L19 6.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Note-Edit Icon -----> */
export const NoteEditIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M10.2892 21.9614H9.39111C6.14261 21.9614 4.51836 21.9614 3.50918 20.9363C2.5 19.9111 2.5 18.2612 2.5 14.9614V9.96139C2.5 6.66156 2.5 5.01165 3.50918 3.98653C4.51836 2.9614 6.14261 2.9614 9.39111 2.9614H12.3444C15.5929 2.9614 17.4907 3.01658 18.5 4.04171C19.5092 5.06683 19.5 6.66156 19.5 9.96139V11.1478"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9453 2V4M10.9453 2V4M5.94531 2V4"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 15H11M7 10H15"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
    />
    <path
      opacity="0.93"
      d="M20.7598 14.8785C19.8544 13.8641 19.3112 13.9245 18.7076 14.1056C18.2851 14.166 16.8365 15.8568 16.2329 16.3952C15.2419 17.3743 14.2464 18.3823 14.1807 18.5138C13.9931 18.8188 13.8186 19.3592 13.7341 19.963C13.5771 20.8688 13.3507 21.8885 13.6375 21.9759C13.9242 22.0632 14.7239 21.8954 15.6293 21.7625C16.2329 21.6538 16.6554 21.533 16.9572 21.3519C17.3797 21.0983 18.1644 20.2046 19.5164 18.8761C20.3644 17.9833 21.1823 17.3664 21.4238 16.7626C21.6652 15.8568 21.3031 15.3737 20.7598 14.8785Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
  </svg>
);

/* <----- Upload-04 Icon -----> */
export const Upload04Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M12 4.5L12 14.5M12 4.5C11.2998 4.5 9.99153 6.4943 9.5 7M12 4.5C12.7002 4.5 14.0085 6.4943 14.5 7"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 16.5C20 18.982 19.482 19.5 17 19.5H7C4.518 19.5 4 18.982 4 16.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Color-Picker Icon -----> */
export const ColorPickerIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M13.435 7L7.15915 13.2759M7.15915 13.2759L4.82728 15.6077C3.92569 16.5093 3.47489 16.9601 3.23745 17.5334C3 18.1066 3 18.7441 3 20.0192V21H3.98082C5.25586 21 5.89338 21 6.46663 20.7626C7.03988 20.5251 7.49068 20.0743 8.39227 19.1727L14.2891 13.2759M7.15915 13.2759H14.2891M14.2891 13.2759L17 10.565"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.2087 8.38869L20.82 10M19.2087 8.38869L20.0705 7.52682C20.363 7.23431 20.5093 7.08805 20.611 6.94529C21.1297 6.21676 21.1297 5.23953 20.611 4.511C20.5093 4.36824 20.363 4.22198 20.0705 3.92947C19.778 3.63697 19.6318 3.4907 19.489 3.38905C18.7605 2.87032 17.7832 2.87032 17.0547 3.38905C16.912 3.4907 16.7657 3.63695 16.4732 3.92947L15.6113 4.79133M19.2087 8.38869L15.6113 4.79133M14 3.18002L15.6113 4.79133"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Refresh Icon -----> */
export const RefreshIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Reload Icon -----> */
export const ReloadIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.heights}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M15.1667 0.999756L15.7646 2.11753C16.1689 2.87322 16.371 3.25107 16.2374 3.41289C16.1037 3.57471 15.6635 3.44402 14.7831 3.18264C13.9029 2.92131 12.9684 2.78071 12 2.78071C6.75329 2.78071 2.5 6.90822 2.5 11.9998C2.5 13.6789 2.96262 15.2533 3.77093 16.6093M8.83333 22.9998L8.23536 21.882C7.83108 21.1263 7.62894 20.7484 7.7626 20.5866C7.89627 20.4248 8.33649 20.5555 9.21689 20.8169C10.0971 21.0782 11.0316 21.2188 12 21.2188C17.2467 21.2188 21.5 17.0913 21.5 11.9998C21.5 10.3206 21.0374 8.74623 20.2291 7.39023"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- File-Download Icon -----> */
export const FileDownloadIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M4 7C4.58984 7.60684 6.15973 10 7 10C7.84027 10 9.41016 7.60684 10 7M7 9L7 2"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 13L4 14.5442C4 17.7892 4 19.4117 4.88607 20.5107C5.06508 20.7327 5.26731 20.9349 5.48933 21.1139C6.58831 22 8.21082 22 11.4558 22C12.1614 22 12.5141 22 12.8372 21.886C12.9044 21.8623 12.9702 21.835 13.0345 21.8043C13.3436 21.6564 13.593 21.407 14.0919 20.9081L18.8284 16.1716C19.4065 15.5935 19.6955 15.3045 19.8478 14.9369C20 14.5694 20 14.1606 20 13.3431V10C20 6.22876 20 4.34315 18.8284 3.17157C17.6569 2 15.7712 2 12 2M13 21.5V21C13 18.1716 13 16.7574 13.8787 15.8787C14.7574 15 16.1716 15 19 15H19.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Search-Minus Icon -----> */
export const SearchMinusIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M17.5 17.5L22 22"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinejoin="round"
    />
    <path
      d="M7.5 11H14.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Search-Add Icon -----> */
export const SearchAddIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M17.5 17.5L22 22"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinejoin="round"
    />
    <path
      d="M7.5 11L14.5 11M11 7.5V14.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Calendar-03 Icon -----> */
export const Calendar03Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M18 2V4M6 2V4"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9955 13H12.0045M11.9955 17H12.0045M15.991 13H16M8 13H8.00897M8 17H8.00897"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 8H20.5"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 12.2432C2.5 7.88594 2.5 5.70728 3.75212 4.35364C5.00424 3 7.01949 3 11.05 3H12.95C16.9805 3 18.9958 3 20.2479 4.35364C21.5 5.70728 21.5 7.88594 21.5 12.2432V12.7568C21.5 17.1141 21.5 19.2927 20.2479 20.6464C18.9958 22 16.9805 22 12.95 22H11.05C7.01949 22 5.00424 22 3.75212 20.6464C2.5 19.2927 2.5 17.1141 2.5 12.7568V12.2432Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 8H21"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Sent Icon -----> */
export const SentIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    {...props}
  >
    <path
      d="M21.0477 3.05293C18.8697 0.707363 2.48648 6.4532 2.50001 8.551C2.51535 10.9299 8.89809 11.6617 10.6672 12.1581C11.7311 12.4565 12.016 12.7625 12.2613 13.8781C13.3723 18.9305 13.9301 21.4435 15.2014 21.4996C17.2278 21.5892 23.1733 5.342 21.0477 3.05293Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
    />
    <path
      d="M11.5 12.5L15 9"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <----- Filter Icon -----> */
export const FilterIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    className={props.className}
    onClick={props.onClick}
    fill={"none"}
  >
    <path
      d="M8.85746 12.5061C6.36901 10.6456 4.59564 8.59915 3.62734 7.44867C3.3276 7.09253 3.22938 6.8319 3.17033 6.3728C2.96811 4.8008 2.86701 4.0148 3.32795 3.5074C3.7889 3 4.60404 3 6.23433 3H17.7657C19.396 3 20.2111 3 20.672 3.5074C21.133 4.0148 21.0319 4.8008 20.8297 6.37281C20.7706 6.83191 20.6724 7.09254 20.3726 7.44867C19.403 8.60062 17.6261 10.6507 15.1326 12.5135C14.907 12.6821 14.7583 12.9567 14.7307 13.2614C14.4837 15.992 14.2559 17.4876 14.1141 18.2442C13.8853 19.4657 12.1532 20.2006 11.226 20.8563C10.6741 21.2466 10.0043 20.782 9.93278 20.1778C9.79643 19.0261 9.53961 16.6864 9.25927 13.2614C9.23409 12.9539 9.08486 12.6761 8.85746 12.5061Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
